var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechFocusTopBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1123,
    height: 442,
    viewBox: "0 0 1123 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M923.979 55.8494H924.651V283.028H923.979V55.8494Z",
    fill: "#1A4784"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M913.514 55.8494H914.186V283.028H913.514V55.8494Z",
    fill: "#1A4784"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M918.013 55.8494H918.685V283.028H918.013V55.8494Z",
    fill: "#1A4784"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M919.611 55.8494H920.283V283.028H919.611V55.8494Z",
    fill: "#1A4784"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 282.773L924.602 282.491L920.062 277.636L919.816 277.918L924.364 282.773Z",
    fill: "#1A4784"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 282.773L924.438 277.909L924.184 277.636L919.988 282.5L920.234 282.773Z",
    fill: "#1A4784"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 282.91L918.464 282.637L913.809 277.636L913.563 277.918L918.226 282.91Z",
    fill: "#1A4784"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 282.91L918.464 277.918L918.226 277.636L913.563 282.637L913.809 282.91Z",
    fill: "#1A4784"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 278.164L924.602 277.882L920.062 273.017L919.816 273.3L924.364 278.164Z",
    fill: "#1A4784"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 278.155L924.438 273.299L924.184 273.026L919.988 277.891L920.234 278.155Z",
    fill: "#1A4784"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 278.301L918.464 278.018L913.809 273.017L913.563 273.3L918.226 278.301Z",
    fill: "#1A4784"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M918.217 273.034L918.461 273.316L913.799 278.322L913.554 278.04L918.217 273.034Z",
    fill: "#1A4784"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M920.057 268.341L924.592 273.205L924.348 273.487L919.812 268.623L920.057 268.341Z",
    fill: "#1A4784"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 273.546L924.438 268.681L924.184 268.408L919.988 273.272L920.234 273.546Z",
    fill: "#1A4784"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 273.682L918.464 273.4L913.809 268.408L913.563 268.681L918.226 273.682Z",
    fill: "#1A4784"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M918.245 268.269L918.489 268.55L913.831 273.548L913.586 273.266L918.245 268.269Z",
    fill: "#1A4784"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M920.053 263.718L924.595 268.588L924.35 268.87L919.808 264L920.053 263.718Z",
    fill: "#1A4784"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M924.116 263.745L924.369 264.017L920.165 268.875L919.911 268.604L924.116 263.745Z",
    fill: "#1A4784"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 269.073L918.464 268.79L913.809 263.789L913.563 264.063L918.226 269.073Z",
    fill: "#1A4784"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 269.073L918.464 264.063L918.226 263.789L913.563 268.79L913.809 269.073Z",
    fill: "#1A4784"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 264.308L924.602 264.035L920.062 259.171L919.816 259.453L924.364 264.308Z",
    fill: "#1A4784"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 264.309L924.438 259.453L924.184 259.18L919.988 264.035L920.234 264.309Z",
    fill: "#1A4784"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 264.454L918.464 264.172L913.809 259.171L913.563 259.453L918.226 264.454Z",
    fill: "#1A4784"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M918.214 259.16L918.459 259.441L913.801 264.44L913.557 264.158L918.214 259.16Z",
    fill: "#1A4784"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 259.699L924.602 259.417L920.062 254.561L919.816 254.844L924.364 259.699Z",
    fill: "#1A4784"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 259.699L924.438 254.835L924.184 254.561L919.988 259.426L920.234 259.699Z",
    fill: "#1A4784"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 259.845L918.464 259.553L913.809 254.561L913.563 254.844L918.226 259.845Z",
    fill: "#1A4784"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 259.845L918.464 254.844L918.226 254.561L913.563 259.553L913.809 259.845Z",
    fill: "#1A4784"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 255.081L924.602 254.807L920.062 249.943L919.816 250.225L924.364 255.081Z",
    fill: "#1A4784"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 255.081L924.438 250.225L924.184 249.952L919.988 254.807L920.234 255.081Z",
    fill: "#1A4784"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 255.227L918.464 254.944L913.809 249.943L913.563 250.225L918.226 255.227Z",
    fill: "#1A4784"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 255.227L918.464 250.225L918.226 249.943L913.563 254.944L913.809 255.227Z",
    fill: "#1A4784"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 250.471L924.602 250.189L920.062 245.334L919.816 245.616L924.364 250.471Z",
    fill: "#1A4784"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 250.462L924.438 245.598L924.184 245.334L919.988 250.198L920.234 250.462Z",
    fill: "#1A4784"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 250.608L918.464 250.335L913.809 245.334L913.563 245.616L918.226 250.608Z",
    fill: "#1A4784"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 250.608L918.464 245.616L918.226 245.334L913.563 250.335L913.809 250.608Z",
    fill: "#1A4784"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 245.862L924.602 245.58L920.062 240.715L919.816 240.998L924.364 245.862Z",
    fill: "#1A4784"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M924.25 240.669L924.504 240.94L920.296 245.808L920.042 245.536L924.25 240.669Z",
    fill: "#1A4784"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 245.999L918.464 245.716L913.809 240.715L913.563 240.998L918.226 245.999Z",
    fill: "#1A4784"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 245.999L918.464 240.998L918.226 240.715L913.563 245.716L913.809 245.999Z",
    fill: "#1A4784"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M920.084 236.194L924.613 241.065L924.368 241.346L919.839 236.475L920.084 236.194Z",
    fill: "#1A4784"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M924.115 236.061L924.369 236.332L920.164 241.19L919.91 240.919L924.115 236.061Z",
    fill: "#1A4784"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 241.38L918.464 241.098L913.809 236.097L913.563 236.379L918.226 241.38Z",
    fill: "#1A4784"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 241.38L918.464 236.379L918.226 236.097L913.563 241.098L913.809 241.38Z",
    fill: "#1A4784"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 236.625L924.602 236.352L920.062 231.487L919.816 231.77L924.364 236.625Z",
    fill: "#1A4784"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 236.625L924.438 231.761L924.184 231.497L919.988 236.352L920.234 236.625Z",
    fill: "#1A4784"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 236.762L918.464 236.488L913.809 231.487L913.563 231.761L918.226 236.762Z",
    fill: "#1A4784"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 236.762L918.464 231.761L918.226 231.487L913.563 236.488L913.809 236.762Z",
    fill: "#1A4784"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 232.016L924.602 231.724L920.062 226.869L919.816 227.151L924.364 232.016Z",
    fill: "#1A4784"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M924.118 226.825L924.372 227.097L920.168 231.955L919.914 231.683L924.118 226.825Z",
    fill: "#1A4784"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M913.698 226.818L918.351 231.823L918.106 232.104L913.453 227.099L913.698 226.818Z",
    fill: "#1A4784"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M918.181 226.951L918.426 227.233L913.767 232.231L913.523 231.949L918.181 226.951Z",
    fill: "#1A4784"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 227.397L924.602 227.115L920.062 222.259L919.816 222.533L924.364 227.397Z",
    fill: "#1A4784"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 227.388L924.438 222.533L924.184 222.259L919.988 227.124L920.234 227.388Z",
    fill: "#1A4784"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 227.534L918.464 227.261L913.809 222.259L913.563 222.533L918.226 227.534Z",
    fill: "#1A4784"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 227.534L918.464 222.533L918.226 222.259L913.563 227.261L913.809 227.534Z",
    fill: "#1A4784"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 222.779L924.602 222.506L920.062 217.641L919.816 217.915L924.364 222.779Z",
    fill: "#1A4784"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 222.779L924.438 217.915L924.184 217.641L919.988 222.506L920.234 222.779Z",
    fill: "#1A4784"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 222.925L918.464 222.642L913.809 217.641L913.563 217.915L918.226 222.925Z",
    fill: "#1A4784"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 222.925L918.464 217.915L918.226 217.641L913.563 222.642L913.809 222.925Z",
    fill: "#1A4784"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 218.16L924.602 217.887L920.062 213.022L919.816 213.305L924.364 218.16Z",
    fill: "#1A4784"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 218.16L924.438 213.305L924.184 213.032L919.988 217.896L920.234 218.16Z",
    fill: "#1A4784"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 218.306L918.464 218.024L913.809 213.022L913.563 213.305L918.226 218.306Z",
    fill: "#1A4784"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 218.306L918.464 213.305L918.226 213.022L913.563 218.024L913.809 218.306Z",
    fill: "#1A4784"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 213.551L924.602 213.269L920.062 208.413L919.816 208.687L924.364 213.551Z",
    fill: "#1A4784"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M924.116 208.368L924.37 208.639L920.165 213.497L919.911 213.226L924.116 208.368Z",
    fill: "#1A4784"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 213.697L918.464 213.414L913.809 208.413L913.563 208.696L918.226 213.697Z",
    fill: "#1A4784"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 213.697L918.464 208.696L918.226 208.413L913.563 213.414L913.809 213.697Z",
    fill: "#1A4784"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M920.012 203.934L924.562 208.781L924.319 209.063L919.768 204.217L920.012 203.934Z",
    fill: "#1A4784"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 208.932L924.438 204.077L924.184 203.804L919.988 208.659L920.234 208.932Z",
    fill: "#1A4784"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 209.078L918.464 208.796L913.809 203.795L913.563 204.077L918.226 209.078Z",
    fill: "#1A4784"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M918.219 203.79L918.464 204.071L913.8 209.076L913.556 208.795L918.219 203.79Z",
    fill: "#1A4784"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 204.323L924.602 204.041L920.062 199.185L919.816 199.459L924.364 204.323Z",
    fill: "#1A4784"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 204.323L924.438 199.459L924.184 199.185L919.988 204.041L920.234 204.323Z",
    fill: "#1A4784"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M913.701 199.125L918.354 204.13L918.108 204.412L913.456 199.407L913.701 199.125Z",
    fill: "#1A4784"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M918.213 199.141L918.458 199.423L913.798 204.42L913.554 204.138L918.213 199.141Z",
    fill: "#1A4784"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 199.705L924.602 199.422L920.062 194.567L919.816 194.849L924.364 199.705Z",
    fill: "#1A4784"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 199.705L924.438 194.84L924.184 194.576L919.988 199.431L920.234 199.705Z",
    fill: "#1A4784"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 199.85L918.464 199.568L913.809 194.567L913.563 194.849L918.226 199.85Z",
    fill: "#1A4784"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M918.212 194.558L918.457 194.84L913.799 199.839L913.554 199.557L918.212 194.558Z",
    fill: "#1A4784"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 195.095L924.602 194.813L920.062 189.958L919.816 190.231L924.364 195.095Z",
    fill: "#1A4784"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 195.086L924.438 190.222L924.184 189.958L919.988 194.822L920.234 195.086Z",
    fill: "#1A4784"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 195.232L918.464 194.95L913.809 189.949L913.563 190.231L918.226 195.232Z",
    fill: "#1A4784"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 195.232L918.464 190.231L918.226 189.949L913.563 194.95L913.809 195.232Z",
    fill: "#1A4784"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M920.042 185.332L924.578 190.196L924.333 190.477L919.798 185.614L920.042 185.332Z",
    fill: "#1A4784"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M924.262 185.295L924.516 185.567L920.313 190.426L920.059 190.155L924.262 185.295Z",
    fill: "#1A4784"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 190.623L918.464 190.34L913.809 185.339L913.563 185.613L918.226 190.623Z",
    fill: "#1A4784"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 190.623L918.464 185.613L918.226 185.339L913.563 190.34L913.809 190.623Z",
    fill: "#1A4784"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 185.858L924.602 185.585L920.062 180.721L919.816 181.003L924.364 185.858Z",
    fill: "#1A4784"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 185.859L924.438 180.994L924.184 180.73L919.988 185.585L920.234 185.859Z",
    fill: "#1A4784"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M913.874 180.609L918.532 185.62L918.287 185.901L913.629 180.89L913.874 180.609Z",
    fill: "#1A4784"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 186.004L918.464 181.003L918.226 180.721L913.563 185.722L913.809 186.004Z",
    fill: "#1A4784"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 181.249L924.602 180.967L920.062 176.111L919.816 176.394L924.364 181.249Z",
    fill: "#1A4784"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 181.24L924.438 176.385L924.184 176.111L919.988 180.967L920.234 181.24Z",
    fill: "#1A4784"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 181.386L918.464 181.103L913.809 176.111L913.563 176.385L918.226 181.386Z",
    fill: "#1A4784"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 181.386L918.464 176.385L918.226 176.111L913.563 181.103L913.809 181.386Z",
    fill: "#1A4784"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 176.631L924.602 176.357L920.062 171.493L919.816 171.775L924.364 176.631Z",
    fill: "#1A4784"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 176.621L924.438 171.775L924.184 171.493L919.988 176.357L920.234 176.621Z",
    fill: "#1A4784"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 176.776L918.464 176.494L913.809 171.493L913.563 171.775L918.226 176.776Z",
    fill: "#1A4784"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 176.776L918.464 171.775L918.226 171.493L913.563 176.494L913.809 176.776Z",
    fill: "#1A4784"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 172.022L924.602 171.739L920.062 166.875L919.816 167.157L924.364 172.022Z",
    fill: "#1A4784"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 172.021L924.438 167.157L924.184 166.883L919.988 171.739L920.234 172.021Z",
    fill: "#1A4784"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 172.158L918.464 171.876L913.809 166.875L913.563 167.157L918.226 172.158Z",
    fill: "#1A4784"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 172.158L918.464 167.157L918.226 166.875L913.563 171.876L913.809 172.158Z",
    fill: "#1A4784"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 167.403L924.602 167.12L920.062 162.256L919.816 162.538L924.364 167.403Z",
    fill: "#1A4784"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M924.277 162.221L924.531 162.492L920.327 167.351L920.073 167.079L924.277 162.221Z",
    fill: "#1A4784"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 167.549L918.464 167.266L913.809 162.265L913.563 162.548L918.226 167.549Z",
    fill: "#1A4784"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 167.549L918.464 162.548L918.226 162.265L913.563 167.266L913.809 167.549Z",
    fill: "#1A4784"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M920.01 157.784L924.56 162.631L924.317 162.913L919.766 158.067L920.01 157.784Z",
    fill: "#1A4784"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 162.784L924.438 157.92L924.184 157.656L919.988 162.511L920.234 162.784Z",
    fill: "#1A4784"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M913.886 157.535L918.538 162.54L918.293 162.822L913.641 157.817L913.886 157.535Z",
    fill: "#1A4784"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 162.93L918.464 157.929L918.226 157.647L913.563 162.648L913.809 162.93Z",
    fill: "#1A4784"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M920.047 153.023L924.583 157.886L924.338 158.168L919.802 153.305L920.047 153.023Z",
    fill: "#1A4784"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M924.275 152.993L924.529 153.264L920.325 158.123L920.071 157.851L924.275 152.993Z",
    fill: "#1A4784"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 158.312L918.464 158.029L913.809 153.037L913.563 153.311L918.226 158.312Z",
    fill: "#1A4784"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 158.312L918.464 153.311L918.226 153.037L913.563 158.029L913.809 158.312Z",
    fill: "#1A4784"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M920.043 148.411L924.579 153.275L924.334 153.557L919.798 148.693L920.043 148.411Z",
    fill: "#1A4784"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M924.289 148.381L924.543 148.652L920.338 153.509L920.084 153.237L924.289 148.381Z",
    fill: "#1A4784"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M913.879 148.301L918.537 153.313L918.292 153.594L913.634 148.583L913.879 148.301Z",
    fill: "#1A4784"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 153.702L918.464 148.701L918.226 148.419L913.563 153.42L913.809 153.702Z",
    fill: "#1A4784"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M920.046 143.794L924.581 148.658L924.337 148.94L919.801 144.076L920.046 143.794Z",
    fill: "#1A4784"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 148.938L924.438 144.083L924.184 143.809L919.988 148.665L920.234 148.938Z",
    fill: "#1A4784"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 149.084L918.464 148.811L913.809 143.8L913.563 144.083L918.226 149.084Z",
    fill: "#1A4784"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 149.084L918.464 144.083L918.226 143.8L913.563 148.811L913.809 149.084Z",
    fill: "#1A4784"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 144.329L924.602 144.046L920.062 139.191L919.816 139.473L924.364 144.329Z",
    fill: "#1A4784"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 144.32L924.438 139.464L924.184 139.191L919.988 144.056L920.234 144.32Z",
    fill: "#1A4784"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M913.914 139.18L918.559 144.193L918.313 144.474L913.668 139.461L913.914 139.18Z",
    fill: "#1A4784"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M918.214 139.151L918.458 139.432L913.799 144.43L913.555 144.148L918.214 139.151Z",
    fill: "#1A4784"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M920.13 134.579L924.673 139.434L924.429 139.716L919.886 134.861L920.13 134.579Z",
    fill: "#1A4784"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 139.71L924.438 134.846L924.184 134.572L919.988 139.437L920.234 139.71Z",
    fill: "#1A4784"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 139.856L918.464 139.574L913.809 134.572L913.563 134.855L918.226 139.856Z",
    fill: "#1A4784"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 139.856L918.464 134.855L918.226 134.572L913.563 139.574L913.809 139.856Z",
    fill: "#1A4784"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M920.127 129.955L924.676 134.817L924.432 135.099L919.883 130.238L920.127 129.955Z",
    fill: "#1A4784"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 135.092L924.438 130.237L924.184 129.963L919.988 134.828L920.234 135.092Z",
    fill: "#1A4784"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M913.863 129.97L918.55 134.948L918.307 135.231L913.62 130.254L913.863 129.97Z",
    fill: "#1A4784"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M918.256 129.863L918.501 130.144L913.838 135.15L913.593 134.868L918.256 129.863Z",
    fill: "#1A4784"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 130.482L924.602 130.209L920.062 125.345L919.816 125.627L924.364 130.482Z",
    fill: "#1A4784"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 130.483L924.438 125.618L924.184 125.354L919.988 130.209L920.234 130.483Z",
    fill: "#1A4784"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M913.914 125.335L918.559 130.348L918.313 130.629L913.669 125.616L913.914 125.335Z",
    fill: "#1A4784"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M918.338 125.409L918.583 125.691L913.924 130.687L913.679 130.405L918.338 125.409Z",
    fill: "#1A4784"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M920.132 120.733L924.674 125.588L924.43 125.871L919.887 121.016L920.132 120.733Z",
    fill: "#1A4784"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 125.873L924.438 121.009L924.184 120.736L919.988 125.591L920.234 125.873Z",
    fill: "#1A4784"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M913.837 120.588L918.511 125.568L918.267 125.851L913.593 120.871L913.837 120.588Z",
    fill: "#1A4784"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M918.22 120.722L918.465 121.003L913.807 126.002L913.563 125.72L918.22 120.722Z",
    fill: "#1A4784"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M920.134 116.117L924.677 120.972L924.433 121.254L919.89 116.399L920.134 116.117Z",
    fill: "#1A4784"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 121.245L924.438 116.39L924.184 116.117L919.988 120.981L920.234 121.245Z",
    fill: "#1A4784"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M913.78 116.128L918.439 121.124L918.195 121.406L913.535 116.41L913.78 116.128Z",
    fill: "#1A4784"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M918.179 116.177L918.424 116.459L913.765 121.456L913.52 121.174L918.179 116.177Z",
    fill: "#1A4784"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 116.646L924.602 116.354L920.062 111.499L919.816 111.781L924.364 116.646Z",
    fill: "#1A4784"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M924.265 111.459L924.519 111.73L920.316 116.59L920.062 116.318L924.265 111.459Z",
    fill: "#1A4784"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M913.903 111.49L918.554 116.509L918.308 116.79L913.658 111.771L913.903 111.49Z",
    fill: "#1A4784"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M918.213 111.486L918.458 111.768L913.794 116.773L913.55 116.491L918.213 111.486Z",
    fill: "#1A4784"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M920.133 106.888L924.676 111.744L924.432 112.026L919.889 107.171L920.133 106.888Z",
    fill: "#1A4784"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M924.261 106.848L924.515 107.119L920.312 111.979L920.058 111.708L924.261 106.848Z",
    fill: "#1A4784"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M913.918 106.956L918.612 111.924L918.369 112.208L913.675 107.239L913.918 106.956Z",
    fill: "#1A4784"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M918.224 106.904L918.468 107.186L913.806 112.192L913.561 111.911L918.224 106.904Z",
    fill: "#1A4784"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M920.129 102.278L924.672 107.133L924.428 107.415L919.885 102.56L920.129 102.278Z",
    fill: "#1A4784"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M924.264 102.231L924.518 102.502L920.315 107.362L920.061 107.09L924.264 102.231Z",
    fill: "#1A4784"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M913.78 102.281L918.44 107.277L918.195 107.559L913.535 102.563L913.78 102.281Z",
    fill: "#1A4784"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 107.545L918.464 102.553L918.226 102.271L913.563 107.272L913.809 107.545Z",
    fill: "#1A4784"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 102.799L924.602 102.517L920.062 97.6522L919.816 97.9346L924.364 102.799Z",
    fill: "#1A4784"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M924.266 97.6138L924.52 97.8853L920.317 102.745L920.063 102.473L924.266 97.6138Z",
    fill: "#1A4784"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M913.833 97.5087L918.512 102.495L918.269 102.778L913.589 97.7916L913.833 97.5087Z",
    fill: "#1A4784"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M918.256 97.5611L918.5 97.8428L913.837 102.848L913.593 102.567L918.256 97.5611Z",
    fill: "#1A4784"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 98.1807L924.602 97.8983L920.062 93.0339L919.816 93.3254L924.364 98.1807Z",
    fill: "#1A4784"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M924.118 92.9982L924.372 93.2697L920.168 98.128L919.914 97.8564L924.118 92.9982Z",
    fill: "#1A4784"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M913.773 93.0465L918.439 98.0492L918.194 98.3311L913.529 93.3283L913.773 93.0465Z",
    fill: "#1A4784"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M918.186 93.1231L918.43 93.4049L913.766 98.409L913.521 98.1273L918.186 93.1231Z",
    fill: "#1A4784"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 93.5713L924.602 93.289L920.062 88.4246L919.816 88.7069L924.364 93.5713Z",
    fill: "#1A4784"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 93.5622L924.438 88.7068L924.184 88.4336L919.988 93.2888L920.234 93.5622Z",
    fill: "#1A4784"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M913.775 88.4416L918.435 93.438L918.19 93.7199L913.531 88.7236L913.775 88.4416Z",
    fill: "#1A4784"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M918.248 88.2989L918.493 88.5807L913.834 93.5787L913.589 93.2969L918.248 88.2989Z",
    fill: "#1A4784"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M920.131 83.8144L924.674 88.6696L924.43 88.952L919.887 84.0968L920.131 83.8144Z",
    fill: "#1A4784"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M924.28 83.7667L924.534 84.0382L920.33 88.8964L920.076 88.6249L924.28 83.7667Z",
    fill: "#1A4784"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M913.772 83.8179L918.437 88.8206L918.192 89.1025L913.527 84.0998L913.772 83.8179Z",
    fill: "#1A4784"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M918.216 83.8229L918.461 84.1045L913.799 89.1109L913.554 88.8292L918.216 83.8229Z",
    fill: "#1A4784"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 84.3347L924.602 84.0522L920.062 79.1969L919.816 79.4701L924.364 84.3347Z",
    fill: "#1A4784"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M924.277 79.1564L924.531 79.4279L920.327 84.2862L920.073 84.0147L924.277 79.1564Z",
    fill: "#1A4784"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M913.78 79.2068L918.44 84.2032L918.195 84.4852L913.535 79.4887L913.78 79.2068Z",
    fill: "#1A4784"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M918.213 79.1842L918.457 79.4659L913.8 84.4646L913.555 84.1828L918.213 79.1842Z",
    fill: "#1A4784"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 79.725L924.602 79.4426L920.062 74.5781L919.816 74.8606L924.364 79.725Z",
    fill: "#1A4784"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M924.278 74.5389L924.532 74.8104L920.328 79.6686L920.074 79.3971L924.278 74.5389Z",
    fill: "#1A4784"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 79.8616L918.464 79.5791L913.809 74.5781L913.563 74.8606L918.226 79.8616Z",
    fill: "#1A4784"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 79.8616L918.464 74.8606L918.226 74.5781L913.563 79.5791L913.809 79.8616Z",
    fill: "#1A4784"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M920.128 69.976L924.67 74.8312L924.426 75.1135L919.883 70.2584L920.128 69.976Z",
    fill: "#1A4784"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M924.118 69.9236L924.372 70.1952L920.168 75.0534L919.914 74.7818L924.118 69.9236Z",
    fill: "#1A4784"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M918.226 75.2434L918.464 74.9701L913.809 69.9691L913.563 70.2424L918.226 75.2434Z",
    fill: "#1A4784"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M913.809 75.2434L918.464 70.2424L918.226 69.9691L913.563 74.9701L913.809 75.2434Z",
    fill: "#1A4784"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 70.4882L924.602 70.215L920.062 65.3505L919.816 65.6329L924.364 70.4882Z",
    fill: "#1A4784"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 70.4882L924.438 65.6239L924.184 65.3597L919.988 70.2242L920.234 70.4882Z",
    fill: "#1A4784"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M913.749 65.2907L918.371 70.3295L918.125 70.6092L913.502 65.5703L913.749 65.2907Z",
    fill: "#1A4784"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M918.174 65.4035L918.419 65.6853L913.759 70.6818L913.515 70.3999L918.174 65.4035Z",
    fill: "#1A4784"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 65.87L924.602 65.5967L920.062 60.7323L919.816 61.0146L924.364 65.87Z",
    fill: "#1A4784"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M924.287 60.7065L924.541 60.9781L920.336 65.835L920.082 65.5634L924.287 60.7065Z",
    fill: "#1A4784"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M913.812 60.6092L918.427 65.6567L918.179 65.9359L913.565 60.8884L913.812 60.6092Z",
    fill: "#1A4784"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M918.34 60.8004L918.584 61.0822L913.925 66.0787L913.681 65.7969L918.34 60.8004Z",
    fill: "#1A4784"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M924.364 61.2605L924.602 60.9782L920.062 56.1228L919.816 56.4053L924.364 61.2605Z",
    fill: "#1A4784"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M920.234 61.2604L924.438 56.396L924.184 56.1318L919.988 60.9872L920.234 61.2604Z",
    fill: "#1A4784"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M913.78 56.1327L918.44 61.1291L918.196 61.4109L913.536 56.4146L913.78 56.1327Z",
    fill: "#1A4784"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M918.179 56.1817L918.424 56.4636L913.765 61.4601L913.52 61.1782L918.179 56.1817Z",
    fill: "#1A4784"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M910.465 282.637H925.922V287.182H910.465V282.637Z",
    fill: "#1A4784"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M907.719 83.5329L922.258 83.6694L922.422 61.7067L904.613 61.552L907.719 83.5329Z",
    fill: "#1A4784"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M908.916 80.9547H914.374V63.2644H906.228L908.916 80.9547Z",
    fill: "#1A4784"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M910.62 51.8141H927.364V61.051H910.62V51.8141Z",
    fill: "#1A4784"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M725.198 44.2714H901.016L900.983 44.3626L901.139 44.2714L910.301 56.0498H927.11L926.954 55.7493L935.445 44.2714H995.69L1004.86 56.0498V56.8332H715.757V56.0498L725.198 44.2714ZM995.37 45.0549H935.97L927.602 56.0498H1003.77L995.37 45.0549ZM900.753 44.9819L900.729 45.0549H725.706L716.781 56.0498H909.203L900.753 44.9819Z",
    fill: "#1A4784"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M715.757 57.3798H1004.86V58.1541H715.757V57.3798Z",
    fill: "#1A4784"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M998.468 55.3667H1003.25V67.9923H998.468V55.3667Z",
    fill: "#1A4784"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M992.731 55.3667H997.517V67.9923H992.731V55.3667Z",
    fill: "#1A4784"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M987.126 55.3667H991.912V67.9923H987.126V55.3667Z",
    fill: "#1A4784"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M985.609 54.8017H1003.88V59.9577H985.609V54.8017Z",
    fill: "#1A4784"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M912.62 83.56H912.973V284.914H912.62V83.56Z",
    fill: "#1A4784"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M911.079 83.56H911.432V284.914H911.079V83.56Z",
    fill: "#1A4784"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M995.321 44.2714H996.042V57.3798H995.321V44.2714Z",
    fill: "#1A4784"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M986.56 45.0551H987.281V57.38H986.56V45.0551Z",
    fill: "#1A4784"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M987.208 57.0703L995.632 45.2918L995.075 44.8091L986.642 56.5874L987.208 57.0703Z",
    fill: "#1A4784"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M995.395 57.6168L995.968 57.1431L987.208 44.8091L986.642 45.2918L995.395 57.6168Z",
    fill: "#1A4784"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M985.134 44.2714H985.855V57.3798H985.134V44.2714Z",
    fill: "#1A4784"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M976.389 45.0551H977.102V57.38H976.389V45.0551Z",
    fill: "#1A4784"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M977.02 57.0703L985.454 45.2918L984.888 44.8091L976.463 56.5874L977.02 57.0703Z",
    fill: "#1A4784"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M985.216 57.6168L985.781 57.1431L977.029 44.8091L976.463 45.2918L985.216 57.6168Z",
    fill: "#1A4784"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M974.955 44.2714H975.677V57.3798H974.955V44.2714Z",
    fill: "#1A4784"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M966.194 45.0551H966.916V57.38H966.194V45.0551Z",
    fill: "#1A4784"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M966.842 57.0703L975.267 45.2918L974.701 44.8091L966.276 56.5874L966.842 57.0703Z",
    fill: "#1A4784"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M975.029 57.6168L975.594 57.1431L966.842 44.8091L966.276 45.2918L975.029 57.6168Z",
    fill: "#1A4784"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M964.776 44.2714H965.49V57.3798H964.776V44.2714Z",
    fill: "#1A4784"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M956.016 45.0551H956.737V57.38H956.016V45.0551Z",
    fill: "#1A4784"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M956.655 57.0703L965.087 45.2918L964.522 44.8091L956.089 56.5874L956.655 57.0703Z",
    fill: "#1A4784"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M964.842 57.6168L965.416 57.1431L956.655 44.8091L956.089 45.2918L964.842 57.6168Z",
    fill: "#1A4784"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M954.581 44.2714H955.302V57.3798H954.581V44.2714Z",
    fill: "#1A4784"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M945.829 45.0551H946.55V57.38H945.829V45.0551Z",
    fill: "#1A4784"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M946.476 57.0703L954.901 45.2918L954.335 44.8091L945.902 56.5874L946.476 57.0703Z",
    fill: "#1A4784"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M954.663 57.6168L955.229 57.1431L946.476 44.8091L945.902 45.2918L954.663 57.6168Z",
    fill: "#1A4784"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M944.41 44.2714H945.123V57.3798H944.41V44.2714Z",
    fill: "#1A4784"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M935.641 45.0551H936.363V57.38H935.641V45.0551Z",
    fill: "#1A4784"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M936.289 57.0703L944.714 45.2918L944.149 44.8091L935.723 56.5874L936.289 57.0703Z",
    fill: "#1A4784"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M944.484 57.6168L945.042 57.1431L936.289 44.8091L935.723 45.2918L944.484 57.6168Z",
    fill: "#1A4784"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M900.409 44.2714H901.13V57.3798H900.409V44.2714Z",
    fill: "#1A4784"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M891.656 45.0551H892.378V57.38H891.656V45.0551Z",
    fill: "#1A4784"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M892.296 57.0703L900.729 45.2918L900.163 44.8091L891.738 56.5874L892.296 57.0703Z",
    fill: "#1A4784"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M900.491 57.6168L901.057 57.1431L892.304 44.8091L891.73 45.2918L900.491 57.6168Z",
    fill: "#1A4784"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M890.599 44.2714H891.312V57.3798H890.599V44.2714Z",
    fill: "#1A4784"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M881.847 45.0551H882.559V57.38H881.847V45.0551Z",
    fill: "#1A4784"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M882.486 57.0703L890.911 45.2918L890.345 44.8091L881.92 56.5874L882.486 57.0703Z",
    fill: "#1A4784"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M890.673 57.6168L891.238 57.1431L882.486 44.8091L881.92 45.2918L890.673 57.6168Z",
    fill: "#1A4784"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M880.781 44.2714H881.502V57.3798H880.781V44.2714Z",
    fill: "#1A4784"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M872.02 45.0551H872.741V57.38H872.02V45.0551Z",
    fill: "#1A4784"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M872.667 57.0703L881.092 45.2918L880.527 44.8091L872.102 56.5874L872.667 57.0703Z",
    fill: "#1A4784"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M880.855 57.6168L881.42 57.1431L872.667 44.8091L872.102 45.2918L880.855 57.6168Z",
    fill: "#1A4784"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M870.963 44.2714H871.684V57.3798H870.963V44.2714Z",
    fill: "#1A4784"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M862.21 45.0551H862.923V57.38H862.21V45.0551Z",
    fill: "#1A4784"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M862.849 57.0703L871.274 45.2918L870.709 44.8091L862.284 56.5874L862.849 57.0703Z",
    fill: "#1A4784"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M871.036 57.6168L871.61 57.1431L862.849 44.8091L862.284 45.2918L871.036 57.6168Z",
    fill: "#1A4784"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M861.145 44.2714H861.866V57.3798H861.145V44.2714Z",
    fill: "#1A4784"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M852.392 45.0551H853.113V57.38H852.392V45.0551Z",
    fill: "#1A4784"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M853.031 57.0703L861.464 45.2918L860.899 44.8091L852.466 56.5874L853.031 57.0703Z",
    fill: "#1A4784"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M861.226 57.6168L861.792 57.1431L853.039 44.8091L852.465 45.2918L861.226 57.6168Z",
    fill: "#1A4784"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M851.334 44.2714H852.047V57.3798H851.334V44.2714Z",
    fill: "#1A4784"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M842.582 45.0551H843.295V57.38H842.582V45.0551Z",
    fill: "#1A4784"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M843.221 57.0703L851.646 45.2918L851.081 44.8091L842.656 56.5874L843.221 57.0703Z",
    fill: "#1A4784"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M851.408 57.6168L851.974 57.1431L843.221 44.8091L842.656 45.2918L851.408 57.6168Z",
    fill: "#1A4784"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M841.516 44.2714H842.237V57.3798H841.516V44.2714Z",
    fill: "#1A4784"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M832.755 45.0551H833.476V57.38H832.755V45.0551Z",
    fill: "#1A4784"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M833.403 57.0703L841.828 45.2918L841.262 44.8091L832.837 56.5874L833.403 57.0703Z",
    fill: "#1A4784"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M841.59 57.6168L842.156 57.1431L833.403 44.8091L832.837 45.2918L841.59 57.6168Z",
    fill: "#1A4784"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M831.698 44.2714H832.419V57.3798H831.698V44.2714Z",
    fill: "#1A4784"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M822.937 45.0551H823.658V57.38H822.937V45.0551Z",
    fill: "#1A4784"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M823.584 57.0703L832.017 45.2918L831.452 44.8091L823.019 56.5874L823.584 57.0703Z",
    fill: "#1A4784"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M831.772 57.6168L832.345 57.1431L823.584 44.8091L823.019 45.2918L831.772 57.6168Z",
    fill: "#1A4784"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M821.88 44.2714H822.601V57.3798H821.88V44.2714Z",
    fill: "#1A4784"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M813.127 45.0551H813.84V57.38H813.127V45.0551Z",
    fill: "#1A4784"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M813.766 57.0703L822.199 45.2918L821.634 44.8091L813.201 56.5874L813.766 57.0703Z",
    fill: "#1A4784"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M821.962 57.6168L822.527 57.1431L813.774 44.8091L813.201 45.2918L821.962 57.6168Z",
    fill: "#1A4784"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M812.07 44.2714H812.783V57.3798H812.07V44.2714Z",
    fill: "#1A4784"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M803.309 45.0551H804.03V57.38H803.309V45.0551Z",
    fill: "#1A4784"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M803.956 57.0703L812.381 45.2918L811.816 44.8091L803.391 56.5874L803.956 57.0703Z",
    fill: "#1A4784"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M812.143 57.6168L812.709 57.1431L803.956 44.8091L803.391 45.2918L812.143 57.6168Z",
    fill: "#1A4784"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M802.252 44.2714H802.965V57.3798H802.252V44.2714Z",
    fill: "#1A4784"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M793.491 45.0551H794.212V57.38H793.491V45.0551Z",
    fill: "#1A4784"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M794.138 57.0703L802.563 45.2918L801.997 44.8091L793.573 56.5874L794.138 57.0703Z",
    fill: "#1A4784"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M802.325 57.6168L802.891 57.1431L794.138 44.8091L793.573 45.2918L802.325 57.6168Z",
    fill: "#1A4784"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M792.434 44.2714H793.155V57.3798H792.434V44.2714Z",
    fill: "#1A4784"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M783.681 45.0551H784.394V57.38H783.681V45.0551Z",
    fill: "#1A4784"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M784.32 57.0703L792.745 45.2918L792.187 44.8091L783.754 56.5874L784.32 57.0703Z",
    fill: "#1A4784"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M792.516 57.6168L793.081 57.1431L784.32 44.8091L783.755 45.2918L792.516 57.6168Z",
    fill: "#1A4784"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M782.615 44.2714H783.337V57.3798H782.615V44.2714Z",
    fill: "#1A4784"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M773.862 45.0551H774.583V57.38H773.862V45.0551Z",
    fill: "#1A4784"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M774.502 57.0703L782.927 45.2918L782.369 44.8091L773.936 56.5874L774.502 57.0703Z",
    fill: "#1A4784"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M782.697 57.6168L783.263 57.1431L774.51 44.8091L773.936 45.2918L782.697 57.6168Z",
    fill: "#1A4784"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M772.797 44.2714H773.518V57.3798H772.797V44.2714Z",
    fill: "#1A4784"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M764.044 45.0551H764.765V57.38H764.044V45.0551Z",
    fill: "#1A4784"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M764.684 57.0703L773.117 45.2918L772.551 44.8091L764.118 56.5874L764.684 57.0703Z",
    fill: "#1A4784"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M772.879 57.6168L773.445 57.1431L764.684 44.8091L764.118 45.2918L772.879 57.6168Z",
    fill: "#1A4784"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M762.987 44.2714H763.7V57.3798H762.987V44.2714Z",
    fill: "#1A4784"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M754.226 45.0551H754.947V57.38H754.226V45.0551Z",
    fill: "#1A4784"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M754.874 57.0703L763.299 45.2918L762.733 44.8091L754.308 56.5874L754.874 57.0703Z",
    fill: "#1A4784"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M763.061 57.6168L763.626 57.1431L754.874 44.8091L754.308 45.2918L763.061 57.6168Z",
    fill: "#1A4784"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M753.177 44.2714H753.89V57.3798H753.177V44.2714Z",
    fill: "#1A4784"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M744.408 45.0551H745.129V57.38H744.408V45.0551Z",
    fill: "#1A4784"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M745.056 57.0703L753.481 45.2918L752.915 44.8091L744.49 56.5874L745.056 57.0703Z",
    fill: "#1A4784"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M753.243 57.6168L753.808 57.1431L745.055 44.8091L744.49 45.2918L753.243 57.6168Z",
    fill: "#1A4784"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M743.359 44.2714H744.072V57.3798H743.359V44.2714Z",
    fill: "#1A4784"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M734.598 45.0551H735.311V57.38H734.598V45.0551Z",
    fill: "#1A4784"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M735.237 57.0703L743.67 45.2918L743.105 44.8091L734.672 56.5874L735.237 57.0703Z",
    fill: "#1A4784"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M743.433 57.6168L743.999 57.1431L735.237 44.8091L734.672 45.2918L743.433 57.6168Z",
    fill: "#1A4784"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M733.533 44.2714H734.254V57.3798H733.533V44.2714Z",
    fill: "#1A4784"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M724.78 45.0551H725.501V57.38H724.78V45.0551Z",
    fill: "#1A4784"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M725.419 57.0703L733.852 45.2918L733.287 44.8091L724.853 56.5874L725.419 57.0703Z",
    fill: "#1A4784"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M733.614 57.6168L734.18 57.1431L725.419 44.8091L724.853 45.2918L733.614 57.6168Z",
    fill: "#1A4784"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M912.071 52.0781L911.998 52.6611L911.301 52.5518L915.694 18.2276H915.276V15.3035H916.407V12.7802H915.833V10.3753H921.619V12.7802H921.094V15.2944H922.504V18.2185H922.086L922.135 18.6011H922.168V18.8106L926.487 52.5518L925.79 52.6611L925.725 52.1327L918.89 50.3382L912.071 52.0781ZM918.12 50.1287L912.514 48.6529L912.129 51.6591L918.12 50.1287ZM918.39 45.9839L913.096 44.2713H913.079L912.637 47.7238L918.39 45.9839ZM913.268 47.9333H924.422L919.029 46.1934L913.268 47.9333ZM914.341 44.2713L919.029 45.7835L924.045 44.2713H914.341ZM923.815 43.743L918.775 41.9211L914.104 43.743H923.815ZM918.226 41.7207L913.686 40.081H913.612L913.153 43.7065L918.226 41.7207ZM914.817 40.081L918.767 41.5112L922.43 40.081H914.817ZM923.422 39.5527L918.972 37.7582L913.948 39.5527H923.422ZM918.431 37.5396L914.325 35.8907H914.145L913.718 39.2248L918.431 37.5396ZM915.349 35.8907L918.972 37.3482L923.061 35.8907H915.349ZM923.16 35.3532L919.005 33.5588L914.735 35.3532H923.16ZM918.513 33.3492L914.686 31.7004L914.243 35.1438L918.513 33.3492ZM915.645 31.7004L919.005 33.1488L922.455 31.7004H915.645ZM922.553 31.172L918.874 29.423L915.21 31.172H922.553ZM918.423 29.2136L915.194 27.6831L914.776 30.9443L918.423 29.2136ZM915.718 27.5101L918.865 29.004L922.004 27.5101H915.718ZM921.873 26.9726L918.759 25.2237L915.53 26.9726H921.873ZM918.365 25.005L915.726 23.5202L915.325 26.6538L918.365 25.005ZM916.144 23.3197L918.767 24.7954L921.48 23.3197H916.144ZM921.34 22.7914L918.832 20.9422L916.095 22.7914H921.34ZM918.513 20.7053L916.366 19.1294H916.292L915.858 22.4908L918.513 20.7053ZM918.841 20.4867L920.857 19.1294H916.997L918.841 20.4867ZM919.169 20.7236L921.963 22.7823L921.496 19.1568L919.169 20.7236ZM922.053 23.4381L919.16 25.0141L922.496 26.8906L922.053 23.4381ZM922.594 27.6558L919.316 29.2136L923.012 30.9625L922.594 27.6558ZM923.127 31.8371L919.496 33.3674L923.545 35.1164L923.127 31.8371ZM923.668 36.082L919.521 37.5668L924.094 39.4069L923.668 36.082ZM923.479 40.081L919.308 41.7116L924.627 43.6337L924.176 40.081H923.479ZM924.741 44.4627L919.685 45.993L925.168 47.7694L924.741 44.4627ZM913.292 48.4617L918.89 49.9283L924.651 48.4617H913.292ZM921.381 18.2185H916.407L916.358 18.6011H921.422L921.381 18.2185ZM925.668 51.7137L925.282 48.6894L919.66 50.1287L925.668 51.7137Z",
    fill: "#1A4784"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M918.8 0H919.185V12.079H918.8V0Z",
    fill: "#1A4784"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M990.313 43.1237H996.042V44.5174H990.313V43.1237Z",
    fill: "#1A4784"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M942.96 43.1237H948.697V44.5174H942.96V43.1237Z",
    fill: "#1A4784"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M920.004 13.4776L991.237 43.4365L991.113 43.8029L919.88 13.844L920.004 13.4776Z",
    fill: "#1A4784"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M725.763 42.4132H730.263V44.2714H725.763V42.4132Z",
    fill: "#1A4784"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M917.939 13.3898L918.026 13.7694L812.396 43.5668L812.309 43.1871L917.939 13.3898Z",
    fill: "#1A4784"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M917.896 13.3648L917.945 13.7526L729.887 43.4571L729.837 43.0693L917.896 13.3648Z",
    fill: "#1A4784"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M920.639 13.6039L945.968 43.8096L945.711 44.0767L920.382 13.8709L920.639 13.6039Z",
    fill: "#1A4784"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M773.207 57.7718H792.024V60.459H773.207V57.7718Z",
    fill: "#1A4784"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M775.78 59.7666H790.016V63.1463H775.78V59.7666Z",
    fill: "#1A4784"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M780.845 156.863C780.845 158.403 781.968 159.651 783.353 159.651C784.738 159.651 785.861 158.403 785.861 156.863C785.861 155.333 784.738 154.085 783.353 154.085C781.968 154.085 780.845 155.333 780.845 156.863Z",
    fill: "#1A4784"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M783.132 158.549C783.132 160.443 783.074 161.792 783.746 161.792C784.132 161.792 784.361 161.427 784.582 160.653L785.107 160.662C784.877 162.028 784.385 162.976 783.812 162.976C783.025 162.976 782.386 161.163 782.386 158.931C782.386 158.512 782.41 158.12 782.451 157.747H783.181C783.156 157.993 783.132 158.294 783.132 158.549Z",
    fill: "#1A4784"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M782.107 153.384H784.598V154.386H782.107V153.384Z",
    fill: "#1A4784"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M785.107 62.7544H788.114V63.7291H785.107V62.7544Z",
    fill: "#1A4784"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M777.305 62.7544H780.132V63.7291H777.305V62.7544Z",
    fill: "#1A4784"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M783.689 154.167L786.951 63.2006L786.271 63.0184L783.009 153.994L783.689 154.167Z",
    fill: "#1A4784"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M783.017 154.203L783.681 153.957L778.804 62.982L778.141 63.237L783.017 154.203Z",
    fill: "#1A4784"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M815.676 161.017H844.024V162.666H815.676V161.017Z",
    fill: "#1A4784"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M812.34 159.988H839.762V161.637H812.34V159.988Z",
    fill: "#1A4784"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M812.537 162.393L816.594 162.557L816.954 160.47L812.537 161.472V162.393Z",
    fill: "#1A4784"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M839.763 160.862L843.377 161.536V160.607L839.763 159.933V160.862Z",
    fill: "#1A4784"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M815.676 159.806H844.024V161.445H815.676V159.806Z",
    fill: "#1A4784"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M813.168 160.626H838.837V162.274H813.168V160.626Z",
    fill: "#1A4784"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M816.045 194.048C816.118 194.048 816.192 194.02 816.249 193.957L844.786 160.279C844.893 160.161 844.884 159.96 844.778 159.842C844.663 159.723 844.491 159.733 844.385 159.851L815.848 193.528C815.741 193.656 815.75 193.847 815.856 193.966C815.905 194.02 815.979 194.048 816.045 194.048Z",
    fill: "#1A4784"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M843.352 193.137C843.417 193.137 843.491 193.101 843.541 193.055C843.655 192.937 843.655 192.736 843.549 192.618L816.241 160.826C816.127 160.708 815.954 160.708 815.848 160.817C815.733 160.935 815.733 161.136 815.84 161.254L843.147 193.037C843.205 193.101 843.278 193.137 843.352 193.137Z",
    fill: "#1A4784"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M812.053 194.768C812.127 194.768 812.209 194.731 812.258 194.667L839.041 161.09C839.14 160.963 839.131 160.771 839.017 160.653C838.902 160.544 838.73 160.553 838.623 160.68L811.848 194.257C811.75 194.385 811.758 194.585 811.873 194.695C811.922 194.74 811.996 194.768 812.053 194.768Z",
    fill: "#1A4784"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M838.418 192.627C838.484 192.627 838.558 192.599 838.607 192.545C838.722 192.426 838.73 192.235 838.623 192.108L813.086 161.245C812.988 161.127 812.807 161.108 812.693 161.227C812.578 161.345 812.57 161.536 812.676 161.664L838.214 192.518C838.271 192.59 838.345 192.627 838.418 192.627Z",
    fill: "#1A4784"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M839.845 162.347L844.254 161.345V160.416L839.845 161.418V162.347Z",
    fill: "#1A4784"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M811.914 161.527L816.323 160.516V159.587L811.914 160.589V161.527Z",
    fill: "#1A4784"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M813.676 192.937C813.824 192.937 813.947 192.809 813.955 192.645L815.274 161.291C815.282 161.117 815.16 160.972 815.012 160.963C814.865 160.944 814.725 161.09 814.725 161.254L813.406 192.609C813.398 192.782 813.521 192.927 813.668 192.927H813.676V192.937Z",
    fill: "#1A4784"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M815.07 193.018C815.078 193.018 815.078 193.018 815.086 193.018C815.242 193 815.356 192.855 815.348 192.681L813.398 161.245C813.389 161.081 813.266 160.953 813.119 160.953C813.111 160.953 813.102 160.953 813.102 160.953C812.955 160.963 812.832 161.108 812.849 161.281L814.791 192.718C814.799 192.891 814.922 193.018 815.07 193.018Z",
    fill: "#1A4784"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M839.32 192.162C839.451 192.162 839.566 192.053 839.59 191.907L844.557 161.09C844.581 160.917 844.483 160.762 844.336 160.735C844.172 160.698 844.041 160.816 844.008 160.98L839.041 191.798C839.017 191.971 839.115 192.125 839.263 192.153C839.287 192.162 839.304 192.162 839.32 192.162Z",
    fill: "#1A4784"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M843.147 193.018C843.155 193.018 843.172 193.018 843.18 193.018C843.336 193 843.442 192.845 843.426 192.672L840.262 161.664C840.246 161.491 840.082 161.372 839.959 161.391C839.803 161.418 839.697 161.564 839.713 161.737L842.877 192.754C842.885 192.9 843.008 193.018 843.147 193.018Z",
    fill: "#1A4784"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M815.676 189.557H844.024V191.206H815.676V189.557Z",
    fill: "#1A4784"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M813.168 190.377H838.837V192.026H813.168V190.377Z",
    fill: "#1A4784"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M816.045 223.79C816.118 223.79 816.192 223.753 816.249 223.699L844.786 190.021C844.893 189.894 844.884 189.702 844.778 189.584C844.663 189.466 844.491 189.475 844.385 189.593L815.848 223.271C815.741 223.398 815.75 223.589 815.856 223.708C815.905 223.763 815.979 223.79 816.045 223.79Z",
    fill: "#1A4784"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M843.352 222.879C843.417 222.879 843.491 222.852 843.541 222.797C843.655 222.679 843.655 222.487 843.549 222.36L816.241 190.577C816.127 190.459 815.954 190.45 815.848 190.568C815.733 190.686 815.733 190.878 815.84 191.005L843.147 222.788C843.205 222.852 843.278 222.879 843.352 222.879Z",
    fill: "#1A4784"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M812.053 224.51C812.127 224.51 812.209 224.473 812.258 224.409L839.041 190.841C839.14 190.714 839.131 190.513 839.017 190.404C838.902 190.295 838.73 190.304 838.623 190.431L811.848 223.999C811.75 224.127 811.758 224.327 811.873 224.437C811.922 224.491 811.996 224.51 812.053 224.51Z",
    fill: "#1A4784"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M838.418 222.378C838.484 222.378 838.558 222.351 838.607 222.296C838.722 222.178 838.73 221.986 838.623 221.859L813.086 191.005C812.988 190.878 812.807 190.869 812.693 190.987C812.578 191.106 812.57 191.297 812.676 191.424L838.214 222.287C838.271 222.342 838.345 222.378 838.418 222.378Z",
    fill: "#1A4784"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M839.845 192.098L844.254 191.096V190.167L839.845 191.169V192.098Z",
    fill: "#1A4784"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M811.914 191.269L816.323 190.267V189.338L811.914 190.34V191.269Z",
    fill: "#1A4784"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M813.676 222.688C813.824 222.688 813.947 222.56 813.955 222.396L815.274 191.033C815.282 190.86 815.16 190.714 815.012 190.705C814.865 190.686 814.725 190.832 814.725 190.996L813.406 222.36C813.398 222.533 813.521 222.679 813.668 222.688H813.676Z",
    fill: "#1A4784"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M815.07 222.77C815.078 222.77 815.078 222.77 815.086 222.77C815.242 222.752 815.356 222.615 815.348 222.442L813.398 191.005C813.389 190.841 813.266 190.714 813.119 190.714C813.111 190.714 813.102 190.714 813.102 190.714C812.955 190.723 812.832 190.869 812.849 191.042L814.791 222.478C814.799 222.642 814.922 222.77 815.07 222.77Z",
    fill: "#1A4784"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M839.32 221.913C839.451 221.913 839.566 221.813 839.59 221.658L844.557 190.841C844.581 190.668 844.483 190.513 844.336 190.477C844.172 190.44 844.041 190.559 844.008 190.723L839.041 221.54C839.017 221.704 839.115 221.868 839.263 221.895C839.287 221.913 839.304 221.913 839.32 221.913Z",
    fill: "#1A4784"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M843.147 222.769C843.155 222.769 843.172 222.769 843.18 222.769C843.336 222.751 843.442 222.596 843.426 222.423L840.262 191.415C840.246 191.242 840.082 191.124 839.959 191.142C839.803 191.16 839.697 191.306 839.713 191.479L842.877 222.496C842.885 222.651 843.008 222.769 843.147 222.769Z",
    fill: "#1A4784"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M815.676 221.176H844.024V222.824H815.676V221.176Z",
    fill: "#1A4784"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M813.168 221.995H838.837V223.644H813.168V221.995Z",
    fill: "#1A4784"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M816.045 255.418C816.118 255.418 816.192 255.391 816.249 255.327L844.786 221.64C844.893 221.522 844.884 221.322 844.778 221.212C844.663 221.094 844.491 221.094 844.385 221.221L815.848 254.899C815.741 255.026 815.75 255.218 815.856 255.336C815.905 255.391 815.979 255.418 816.045 255.418Z",
    fill: "#1A4784"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M843.352 254.497C843.417 254.497 843.491 254.47 843.541 254.416C843.655 254.297 843.655 254.097 843.549 253.978L816.241 222.196C816.127 222.068 815.954 222.068 815.848 222.177C815.733 222.296 815.733 222.496 815.84 222.615L843.147 254.397C843.205 254.47 843.278 254.497 843.352 254.497Z",
    fill: "#1A4784"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M812.053 256.137C812.127 256.137 812.209 256.101 812.258 256.028L839.041 222.46C839.14 222.333 839.131 222.141 839.017 222.023C838.902 221.904 838.73 221.923 838.623 222.05L811.848 255.618C811.75 255.746 811.758 255.946 811.873 256.055C811.922 256.11 811.996 256.137 812.053 256.137Z",
    fill: "#1A4784"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M838.418 253.997C838.484 253.997 838.558 253.969 838.607 253.914C838.722 253.796 838.73 253.605 838.623 253.486L813.086 222.633C812.988 222.505 812.807 222.496 812.693 222.615C812.578 222.733 812.57 222.924 812.676 223.052L838.214 253.905C838.271 253.969 838.345 253.997 838.418 253.997Z",
    fill: "#1A4784"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M839.845 223.717L844.254 222.715V221.795L839.845 222.797V223.717Z",
    fill: "#1A4784"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M811.914 222.888L816.323 221.886V220.957L811.914 221.968V222.888Z",
    fill: "#1A4784"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M813.676 254.306C813.824 254.306 813.947 254.179 813.955 254.015L815.274 222.651C815.282 222.487 815.16 222.332 815.012 222.332C814.865 222.314 814.725 222.451 814.725 222.624L813.406 253.987C813.398 254.161 813.521 254.306 813.668 254.306H813.676Z",
    fill: "#1A4784"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M815.07 254.388H815.086C815.242 254.379 815.356 254.234 815.348 254.06L813.398 222.624C813.389 222.46 813.266 222.342 813.119 222.342C813.111 222.342 813.102 222.342 813.102 222.342C812.955 222.351 812.832 222.496 812.849 222.67L814.791 254.115C814.799 254.261 814.922 254.388 815.07 254.388Z",
    fill: "#1A4784"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M839.32 253.532C839.451 253.532 839.566 253.432 839.59 253.277L844.557 222.451C844.581 222.287 844.483 222.123 844.336 222.096C844.172 222.059 844.041 222.178 844.008 222.342L839.041 253.159C839.017 253.332 839.115 253.487 839.263 253.514C839.287 253.532 839.304 253.532 839.32 253.532Z",
    fill: "#1A4784"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M843.147 254.388H843.18C843.336 254.37 843.442 254.215 843.426 254.042L840.262 223.034C840.246 222.861 840.082 222.742 839.959 222.76C839.803 222.779 839.697 222.933 839.713 223.107L842.877 254.115C842.885 254.27 843.008 254.388 843.147 254.388Z",
    fill: "#1A4784"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M815.676 252.794H844.024V254.443H815.676V252.794Z",
    fill: "#1A4784"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M813.168 253.614H838.837V255.263H813.168V253.614Z",
    fill: "#1A4784"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M816.045 287.036C816.118 287.036 816.192 287 816.249 286.936L844.786 253.259C844.893 253.14 844.884 252.94 844.778 252.821C844.663 252.703 844.491 252.703 844.385 252.831L815.848 286.508C815.741 286.635 815.75 286.827 815.856 286.945C815.905 287.009 815.979 287.036 816.045 287.036Z",
    fill: "#1A4784"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M843.352 286.125C843.417 286.125 843.491 286.089 843.541 286.044C843.655 285.925 843.655 285.725 843.549 285.606L816.241 253.815C816.127 253.696 815.954 253.687 815.848 253.805C815.733 253.924 815.733 254.115 815.84 254.243L843.147 286.025C843.205 286.089 843.278 286.125 843.352 286.125Z",
    fill: "#1A4784"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M812.053 287.756C812.127 287.756 812.209 287.719 812.258 287.656L839.041 254.079C839.14 253.951 839.131 253.76 839.017 253.641C838.902 253.523 838.73 253.541 838.623 253.669L811.848 287.246C811.75 287.373 811.758 287.565 811.873 287.683C811.922 287.729 811.996 287.756 812.053 287.756Z",
    fill: "#1A4784"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M838.418 285.624C838.484 285.624 838.558 285.597 838.607 285.543C838.722 285.424 838.73 285.233 838.623 285.105L813.086 254.243C812.988 254.115 812.807 254.106 812.693 254.224C812.578 254.343 812.57 254.534 812.676 254.662L838.214 285.515C838.271 285.588 838.345 285.624 838.418 285.624Z",
    fill: "#1A4784"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M839.845 255.345L844.254 254.343V253.414L839.845 254.416V255.345Z",
    fill: "#1A4784"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M811.914 254.516L816.323 253.514V252.585L811.914 253.587V254.516Z",
    fill: "#1A4784"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M813.676 285.934C813.824 285.934 813.947 285.816 813.955 285.643L815.274 254.288C815.282 254.115 815.16 253.969 815.012 253.969C814.865 253.951 814.725 254.088 814.725 254.261L813.406 285.624C813.398 285.788 813.521 285.943 813.668 285.943H813.676V285.934Z",
    fill: "#1A4784"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M815.07 286.007H815.086C815.242 285.998 815.356 285.852 815.348 285.679L813.398 254.242C813.389 254.078 813.266 253.96 813.119 253.96C813.111 253.96 813.102 253.96 813.102 253.96C812.955 253.969 812.832 254.115 812.849 254.288L814.791 285.725C814.799 285.879 814.922 286.007 815.07 286.007Z",
    fill: "#1A4784"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M839.32 285.16C839.451 285.16 839.566 285.06 839.59 284.914L844.557 254.088C844.581 253.924 844.483 253.76 844.336 253.733C844.172 253.696 844.041 253.815 844.008 253.988L839.041 284.805C839.017 284.978 839.115 285.133 839.263 285.169C839.287 285.16 839.304 285.16 839.32 285.16Z",
    fill: "#1A4784"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M843.147 286.007C843.155 286.007 843.172 286.007 843.18 285.998C843.336 285.989 843.442 285.834 843.426 285.661L840.262 254.653C840.246 254.479 840.082 254.361 839.959 254.379C839.803 254.397 839.697 254.552 839.713 254.725L842.877 285.734C842.885 285.889 843.008 286.007 843.147 286.007Z",
    fill: "#1A4784"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M815.676 284.413H844.024V286.062H815.676V284.413Z",
    fill: "#1A4784"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M813.168 285.242H838.837V286.891H813.168V285.242Z",
    fill: "#1A4784"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M816.045 318.664C816.118 318.664 816.192 318.637 816.249 318.573L844.786 284.896C844.893 284.768 844.884 284.577 844.778 284.459C844.663 284.34 844.491 284.349 844.385 284.468L815.848 318.145C815.741 318.264 815.75 318.464 815.856 318.582C815.905 318.637 815.979 318.664 816.045 318.664Z",
    fill: "#1A4784"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M843.352 317.744C843.417 317.744 843.491 317.717 843.541 317.653C843.655 317.535 843.655 317.343 843.549 317.216L816.241 285.433C816.127 285.315 815.954 285.306 815.848 285.424C815.733 285.543 815.733 285.734 815.84 285.861L843.147 317.644C843.205 317.717 843.278 317.744 843.352 317.744Z",
    fill: "#1A4784"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M812.053 319.384C812.127 319.384 812.209 319.348 812.258 319.284L839.041 285.716C839.14 285.588 839.131 285.397 839.017 285.278C838.902 285.169 838.73 285.178 838.623 285.306L811.848 318.874C811.75 319.001 811.758 319.202 811.873 319.311C811.922 319.357 811.996 319.384 812.053 319.384Z",
    fill: "#1A4784"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M838.418 317.243C838.484 317.243 838.558 317.216 838.607 317.161C838.722 317.043 838.73 316.852 838.623 316.724L813.086 285.861C812.988 285.734 812.807 285.725 812.693 285.843C812.578 285.953 812.57 286.153 812.676 286.28L838.214 317.134C838.271 317.207 838.345 317.243 838.418 317.243Z",
    fill: "#1A4784"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M839.845 286.964L844.254 285.962V285.033L839.845 286.044V286.964Z",
    fill: "#1A4784"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M811.914 286.135L816.323 285.133V284.203L811.914 285.205V286.135Z",
    fill: "#1A4784"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M813.676 317.553C813.824 317.553 813.947 317.425 813.955 317.261L815.274 285.898C815.282 285.725 815.16 285.579 815.012 285.57C814.865 285.552 814.725 285.697 814.725 285.871L813.406 317.225C813.398 317.398 813.521 317.544 813.668 317.553H813.676Z",
    fill: "#1A4784"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M815.07 317.626H815.086C815.242 317.617 815.356 317.471 815.348 317.298L813.398 285.861C813.389 285.698 813.266 285.57 813.119 285.57C813.111 285.57 813.102 285.57 813.102 285.579C812.955 285.588 812.832 285.734 812.849 285.907L814.791 317.343C814.799 317.507 814.922 317.626 815.07 317.626Z",
    fill: "#1A4784"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M839.32 316.778C839.451 316.778 839.566 316.669 839.59 316.523L844.557 285.706C844.581 285.542 844.483 285.378 844.336 285.351C844.172 285.315 844.041 285.433 844.008 285.597L839.041 316.414C839.017 316.587 839.115 316.742 839.263 316.778C839.287 316.778 839.304 316.778 839.32 316.778Z",
    fill: "#1A4784"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M843.147 317.626C843.155 317.626 843.172 317.626 843.18 317.626C843.336 317.617 843.442 317.462 843.426 317.28L840.262 286.271C840.246 286.098 840.082 285.989 839.959 285.998C839.803 286.016 839.697 286.171 839.713 286.344L842.877 317.352C842.885 317.516 843.008 317.626 843.147 317.626Z",
    fill: "#1A4784"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 136.458H834.108V137.697H827.437V136.458Z",
    fill: "#1A4784"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 147.189H834.108V148.428H827.437V147.189Z",
    fill: "#1A4784"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 157.929H834.108V159.168H827.437V157.929Z",
    fill: "#1A4784"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 172.322H834.108V173.561H827.437V172.322Z",
    fill: "#1A4784"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 186.724H834.108V187.963H827.437V186.724Z",
    fill: "#1A4784"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 201.117H834.108V202.356H827.437V201.117Z",
    fill: "#1A4784"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 215.519H834.108V216.757H827.437V215.519Z",
    fill: "#1A4784"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 229.911H834.108V231.15H827.437V229.911Z",
    fill: "#1A4784"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 244.313H834.108V245.552H827.437V244.313Z",
    fill: "#1A4784"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 258.706H834.108V259.936H827.437V258.706Z",
    fill: "#1A4784"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 273.108H834.108V274.338H827.437V273.108Z",
    fill: "#1A4784"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 287.51H834.108V288.74H827.437V287.51Z",
    fill: "#1A4784"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 301.903H834.108V303.142H827.437V301.903Z",
    fill: "#1A4784"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M827.437 316.296H834.108V317.535H827.437V316.296Z",
    fill: "#1A4784"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M807.554 314.966H849.499V327.173H807.554V314.966Z",
    fill: "#1A4784"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.96 140.776H1118.32V142.133H1094.96V140.776Z",
    fill: "#1A4784"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.23 141.459H1120.38V142.817H1099.23V141.459Z",
    fill: "#1A4784"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.4 142.88L1094.77 142.051V141.286L1098.4 142.115V142.88Z",
    fill: "#1A4784"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.42 142.197L1117.79 141.368V140.603L1121.42 141.432V142.197Z",
    fill: "#1A4784"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.96 114.687H1118.32V116.044H1094.96V114.687Z",
    fill: "#1A4784"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.23 115.361H1120.38V116.718H1099.23V115.361Z",
    fill: "#1A4784"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.02 142.899C1117.96 142.899 1117.89 142.871 1117.85 142.817L1094.34 115.07C1094.25 114.969 1094.26 114.805 1094.35 114.705C1094.44 114.614 1094.58 114.614 1094.67 114.714L1118.2 142.461C1118.28 142.562 1118.28 142.726 1118.19 142.826C1118.13 142.88 1118.07 142.899 1118.02 142.899Z",
    fill: "#1A4784"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.51 142.152C1095.45 142.152 1095.4 142.124 1095.36 142.079C1095.26 141.978 1095.26 141.824 1095.35 141.714L1117.85 115.516C1117.94 115.416 1118.09 115.416 1118.18 115.516C1118.27 115.607 1118.27 115.771 1118.19 115.88L1095.68 142.07C1095.63 142.115 1095.58 142.152 1095.51 142.152Z",
    fill: "#1A4784"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.3 143.491C1121.24 143.491 1121.18 143.463 1121.13 143.409L1099.07 115.744C1098.99 115.643 1098.99 115.479 1099.08 115.388C1099.17 115.297 1099.32 115.306 1099.4 115.406L1121.47 143.072C1121.55 143.181 1121.54 143.336 1121.45 143.436C1121.41 143.472 1121.35 143.491 1121.3 143.491Z",
    fill: "#1A4784"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.58 141.733C1099.52 141.733 1099.47 141.714 1099.42 141.669C1099.33 141.578 1099.32 141.414 1099.41 141.304L1120.46 115.88C1120.54 115.78 1120.69 115.762 1120.79 115.862C1120.88 115.953 1120.88 116.126 1120.79 116.226L1099.75 141.651C1099.71 141.705 1099.64 141.733 1099.58 141.733Z",
    fill: "#1A4784"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.4 116.782L1094.77 115.953V115.188L1098.4 116.017V116.782Z",
    fill: "#1A4784"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.42 116.099L1117.79 115.27V114.514L1121.42 115.334V116.099Z",
    fill: "#1A4784"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.97 141.988C1119.84 141.988 1119.74 141.878 1119.74 141.742L1118.65 115.898C1118.64 115.762 1118.74 115.643 1118.87 115.634C1118.99 115.616 1119.1 115.734 1119.11 115.88L1120.19 141.724C1120.2 141.86 1120.1 141.979 1119.97 141.988H1119.97Z",
    fill: "#1A4784"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.82 142.051C1118.82 142.051 1118.81 142.051 1118.8 142.051C1118.68 142.042 1118.58 141.915 1118.59 141.778L1120.19 115.88C1120.2 115.744 1120.3 115.643 1120.42 115.643H1120.42C1120.56 115.652 1120.65 115.771 1120.65 115.917L1119.04 141.824C1119.04 141.951 1118.94 142.051 1118.82 142.051Z",
    fill: "#1A4784"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.84 141.35C1098.73 141.35 1098.63 141.268 1098.61 141.14L1094.51 115.743C1094.49 115.607 1094.57 115.479 1094.7 115.452C1094.83 115.415 1094.95 115.516 1094.96 115.652L1099.06 141.049C1099.08 141.186 1099 141.313 1098.87 141.341H1098.84V141.35Z",
    fill: "#1A4784"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.68 142.051C1095.67 142.051 1095.67 142.051 1095.66 142.051C1095.54 142.033 1095.45 141.906 1095.46 141.769L1098.07 116.217C1098.08 116.072 1098.22 115.98 1098.32 115.99C1098.45 116.008 1098.53 116.135 1098.53 116.272L1095.92 141.824C1095.9 141.96 1095.8 142.051 1095.68 142.051Z",
    fill: "#1A4784"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.96 88.5884H1118.32V89.9456H1094.96V88.5884Z",
    fill: "#1A4784"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.23 89.2624H1120.38V90.6197H1099.23V89.2624Z",
    fill: "#1A4784"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.02 116.809C1117.96 116.809 1117.89 116.782 1117.85 116.737L1094.34 88.9894C1094.25 88.8801 1094.26 88.7253 1094.35 88.6251C1094.44 88.534 1094.58 88.5339 1094.67 88.6341L1118.2 116.381C1118.28 116.482 1118.28 116.645 1118.19 116.746C1118.13 116.782 1118.07 116.809 1118.02 116.809Z",
    fill: "#1A4784"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.51 116.053C1095.45 116.053 1095.4 116.026 1095.36 115.98C1095.26 115.889 1095.26 115.725 1095.35 115.616L1117.85 89.4266C1117.94 89.3264 1118.09 89.3264 1118.18 89.4175C1118.27 89.5177 1118.27 89.6726 1118.19 89.7728L1095.68 115.971C1095.63 116.026 1095.58 116.053 1095.51 116.053Z",
    fill: "#1A4784"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.3 117.401C1121.24 117.401 1121.18 117.374 1121.13 117.31L1099.07 89.6452C1098.99 89.545 1098.99 89.381 1099.08 89.2808C1099.17 89.1897 1099.32 89.1988 1099.4 89.3081L1121.47 116.973C1121.55 117.074 1121.54 117.237 1121.45 117.329C1121.41 117.374 1121.35 117.401 1121.3 117.401Z",
    fill: "#1A4784"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.58 115.634C1099.52 115.634 1099.47 115.616 1099.42 115.561C1099.33 115.47 1099.32 115.306 1099.41 115.206L1120.46 89.7728C1120.54 89.6726 1120.69 89.6634 1120.79 89.7637C1120.88 89.8547 1120.88 90.0187 1120.79 90.1189L1099.75 115.543C1099.71 115.607 1099.64 115.634 1099.58 115.634Z",
    fill: "#1A4784"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.4 90.6928L1094.77 89.8547V89.0986L1098.4 89.9275V90.6928Z",
    fill: "#1A4784"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.42 90.0004L1117.79 89.1714V88.4154L1121.42 89.2353V90.0004Z",
    fill: "#1A4784"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.97 115.889C1119.84 115.889 1119.74 115.78 1119.74 115.643L1118.65 89.8092C1118.64 89.6635 1118.74 89.5541 1118.87 89.545C1118.99 89.5541 1119.1 89.6452 1119.11 89.7818L1120.19 115.625C1120.2 115.771 1120.1 115.889 1119.97 115.898H1119.97V115.889Z",
    fill: "#1A4784"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.82 115.953C1118.82 115.953 1118.81 115.953 1118.8 115.953C1118.68 115.944 1118.58 115.816 1118.59 115.68L1120.19 89.7727C1120.2 89.636 1120.3 89.5358 1120.42 89.5358H1120.42C1120.56 89.5449 1120.65 89.6634 1120.65 89.8092L1119.04 115.716C1119.04 115.853 1118.94 115.953 1118.82 115.953Z",
    fill: "#1A4784"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.84 115.261C1098.73 115.261 1098.63 115.179 1098.61 115.051L1094.51 89.6542C1094.49 89.5176 1094.57 89.39 1094.7 89.3627C1094.83 89.3354 1094.95 89.4357 1094.96 89.5723L1099.06 114.969C1099.08 115.115 1099 115.243 1098.87 115.27C1098.86 115.252 1098.85 115.261 1098.84 115.261Z",
    fill: "#1A4784"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.68 115.953C1095.67 115.953 1095.67 115.953 1095.66 115.953C1095.54 115.935 1095.45 115.807 1095.46 115.671L1098.07 90.1189C1098.08 89.9823 1098.22 89.873 1098.32 89.8912C1098.45 89.9094 1098.53 90.0369 1098.53 90.1735L1095.92 115.725C1095.9 115.862 1095.8 115.953 1095.68 115.953Z",
    fill: "#1A4784"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.12 94.5004H1108.62V95.5206H1103.12V94.5004Z",
    fill: "#1A4784"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.12 103.355H1108.62V104.366H1103.12V103.355Z",
    fill: "#1A4784"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.12 112.2H1108.62V113.22H1103.12V112.2Z",
    fill: "#1A4784"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.12 156.435H1108.62V157.446H1103.12V156.435Z",
    fill: "#1A4784"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M975.242 299.699H953.139L953.13 297.439H975.234L975.242 299.699Z",
    fill: "#1A4784"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M974.972 268.563H953.54L953.532 266.313H974.963L974.972 268.563Z",
    fill: "#1A4784"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M954.023 267.001L975.721 298.142L974.918 298.833L953.22 267.693L954.023 267.001Z",
    fill: "#1A4784"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M954.384 298.906L953.573 298.232L974.562 267.096L975.373 267.77L954.384 298.906Z",
    fill: "#1A4784"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M967.891 269.683H948.82L948.812 267.433H967.882L967.891 269.683Z",
    fill: "#1A4784"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M967.989 300.254H947.91L947.902 298.004H967.981L967.989 300.254Z",
    fill: "#1A4784"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M949.272 268.244L968.27 298.817L967.44 299.454L948.443 268.881L949.272 268.244Z",
    fill: "#1A4784"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M966.993 268.463L967.832 269.101L948.882 299.876L948.043 299.238L966.993 268.463Z",
    fill: "#1A4784"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M949.269 268.566L954.602 299.141L953.612 299.355L948.28 268.779L949.269 268.566Z",
    fill: "#1A4784"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M948.91 299.616L947.918 299.398L953.213 268.453L954.204 268.663L948.91 299.616Z",
    fill: "#1A4784"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M974.242 299.644L966.555 267.57L967.53 267.287L975.226 299.362L974.242 299.644Z",
    fill: "#1A4784"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M968.309 299.261L967.325 298.997L973.636 268.617L974.627 268.872L968.309 299.261Z",
    fill: "#1A4784"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M974.873 238.31H953.45L953.434 236.06H974.865L974.873 238.31Z",
    fill: "#1A4784"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M953.899 236.931L975.601 268.068L974.804 268.754L953.102 237.617L953.899 236.931Z",
    fill: "#1A4784"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M974.4 236.841L975.212 237.52L954.175 268.618L953.363 267.939L974.4 236.841Z",
    fill: "#1A4784"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M967.792 239.44H948.721L948.713 237.19H967.784L967.792 239.44Z",
    fill: "#1A4784"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M949.028 238.009L968.029 268.581L967.199 269.218L948.198 238.646L949.028 238.009Z",
    fill: "#1A4784"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M966.895 238.264L967.734 238.901L948.793 269.684L947.955 269.046L966.895 238.264Z",
    fill: "#1A4784"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M953.557 268.991L948.221 238.42L949.221 238.21L954.548 268.781L953.557 268.991Z",
    fill: "#1A4784"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M948.812 269.364L947.82 269.155L953.114 238.21L954.114 238.42L948.812 269.364Z",
    fill: "#1A4784"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M967.488 237.063L975.184 269.136L974.21 269.424L966.514 237.352L967.488 237.063Z",
    fill: "#1A4784"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M968.21 269.018L967.227 268.754L973.537 238.374L974.529 238.629L968.21 269.018Z",
    fill: "#1A4784"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M974.775 208.113H953.352L953.335 205.863H974.775V208.113Z",
    fill: "#1A4784"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M974.644 238.474L952.942 207.338L953.745 206.646L975.447 237.782L974.644 238.474Z",
    fill: "#1A4784"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M974.445 206.621L975.257 207.3L954.209 238.386L953.397 237.707L974.445 206.621Z",
    fill: "#1A4784"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M967.694 209.242H948.623V206.992H967.686L967.694 209.242Z",
    fill: "#1A4784"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M967.202 239.002L948.205 208.431L949.041 207.803L968.038 238.374L967.202 239.002Z",
    fill: "#1A4784"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M966.68 208.015L967.519 208.653L948.555 239.421L947.717 238.782L966.68 208.015Z",
    fill: "#1A4784"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M953.458 238.793L948.123 208.222L949.123 208.012L954.45 238.583L953.458 238.793Z",
    fill: "#1A4784"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M948.713 239.176L947.722 238.957L953.024 208.012L954.016 208.222L948.713 239.176Z",
    fill: "#1A4784"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M967.271 206.903L974.97 238.975L973.996 239.264L966.297 207.192L967.271 206.903Z",
    fill: "#1A4784"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M968.112 238.811L967.129 238.565L973.439 208.176L974.431 208.431L968.112 238.811Z",
    fill: "#1A4784"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M974.685 177.915H953.254L953.245 175.665H974.677L974.685 177.915Z",
    fill: "#1A4784"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M974.545 208.267L952.852 177.131L953.647 176.448L975.348 207.584L974.545 208.267Z",
    fill: "#1A4784"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M974.248 176.52L975.061 177.197L954.088 208.346L953.274 207.669L974.248 176.52Z",
    fill: "#1A4784"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M967.596 179.045H948.533L948.525 176.795H967.588L967.596 179.045Z",
    fill: "#1A4784"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M948.955 177.666L967.953 208.239L967.124 208.875L948.126 178.303L948.955 177.666Z",
    fill: "#1A4784"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M966.589 177.821L967.421 178.454L948.457 209.221L947.625 208.588L966.589 177.821Z",
    fill: "#1A4784"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M949.025 177.701L954.352 208.279L953.362 208.492L948.035 177.914L949.025 177.701Z",
    fill: "#1A4784"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M952.996 177.84L953.994 178.052L948.675 208.992L947.677 208.78L952.996 177.84Z",
    fill: "#1A4784"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M967.303 176.658L974.999 208.73L974.017 209.021L966.321 176.949L967.303 176.658Z",
    fill: "#1A4784"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M968.022 208.623L967.03 208.359L973.34 177.979L974.332 178.234L968.022 208.623Z",
    fill: "#1A4784"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M953.991 178.07L953.188 177.396L974.177 146.26L974.988 146.934L953.991 178.07Z",
    fill: "#1A4784"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M966.524 147.623L967.362 148.262L948.364 179.003L947.527 178.364L966.524 147.623Z",
    fill: "#1A4784"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M973.857 178.808L966.161 146.743L967.137 146.451L974.832 178.525L973.857 178.808Z",
    fill: "#1A4784"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M967.923 178.416L966.94 178.17L973.251 147.781L974.234 148.036L967.923 178.416Z",
    fill: "#1A4784"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M974.291 57.1339H952.86V54.8748H974.283L974.291 57.1339Z",
    fill: "#1A4784"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M967.21 58.2545H948.139L948.131 56.0043H967.202L967.21 58.2545Z",
    fill: "#1A4784"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.48 170.081L1320.78 169.689L1320.22 182.142L1320.7 182.552L1320.87 182.297L1320.93 181.677L1325.48 182.124L1325.54 183.016L1325.78 183.253L1326.17 182.834L1326.96 175.091L1327.39 174.8L1327.46 173.898L1327.05 173.515L1327.48 170.081Z",
    fill: "#1A4784"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.29 181.313C1324.28 181.404 1324.01 182.123 1324.33 182.779C1324.66 183.444 1325.2 184.018 1325.21 184.92C1325.21 185.822 1324.91 187.762 1324.66 188.117C1324.4 188.482 1323.04 188.764 1322.62 187.926C1322.21 187.088 1321.7 185.567 1321.71 185.476C1321.71 185.385 1321.26 184.711 1321.64 184.428C1322.02 184.146 1322.6 183.708 1322.71 184.264C1322.83 184.82 1322.98 185.867 1323.01 186.086C1323.04 186.296 1323.47 187.771 1323.51 186.669C1323.55 185.558 1323.43 185.011 1323.32 184.783C1323.21 184.565 1322.82 183.517 1322.63 183.508C1322.44 183.49 1322.12 183.28 1321.95 182.725C1321.8 182.178 1321.91 180.548 1321.91 180.548L1324.29 181.313Z",
    fill: "#1A4784"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.95 32.0829C1333.95 32.0829 1331.57 30.1427 1331.16 30.2429C1330.74 30.3432 1328.62 30.5708 1328.62 30.5708L1327.22 31.8826L1312.89 31.4818L1312.28 29.6963L1311.86 31.0537L1310.68 31.2449L1308.54 29.25L1307.23 29.1771C1307.23 29.1771 1305.08 28.8309 1305.3 29.9423C1305.52 31.0536 1306.5 32.5476 1307.02 33.3948C1307.54 34.2328 1311.29 35.6448 1311.29 35.6448L1311.99 36.5374L1313.04 35.6995L1320.87 35.7358L1317.4 39.2794L1312.29 39.835L1309.62 44.827L1308.59 45.3645L1307.99 47.1499L1308.72 47.3594L1279.57 110.56L1291.67 111.107L1319.03 47.578L1322.3 47.5871C1322.3 47.5871 1322.43 49.0994 1323.23 49.3544C1324.03 49.6095 1330.55 51.1945 1331.39 47.8331C1332.24 44.4718 1332.42 42.4313 1332.42 42.4313L1332.82 41.2379C1332.82 41.2379 1335.61 40.3634 1335.37 38.8786L1335.13 37.3847C1335.13 37.3847 1338.49 37.0841 1337.99 35.1438C1337.47 33.2217 1339.4 31.5364 1333.95 32.0829Z",
    fill: "#1A4784"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.81 40.391C1331.16 39.389 1327.39 39.4071 1327.22 39.4436C1327.06 39.4891 1324.74 40.6825 1324.74 40.6825L1324.26 42.4041C1324.26 42.4041 1326.39 40.7918 1326.93 40.6642C1327.49 40.5276 1329.59 41.1835 1329.73 41.3383C1329.88 41.5023 1331.64 42.8141 1331.55 43.5428L1332.19 41.2016L1331.81 40.391Z",
    fill: "#1A4784"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.62 45.4464C1328.62 45.4464 1328.32 43.8796 1327.07 44.1802C1325.83 44.4808 1324.31 45.6194 1324.56 46.4302C1324.8 47.2409 1326.12 47.3047 1326.74 47.3502C1327.36 47.3957 1328.62 45.4464 1328.62 45.4464Z",
    fill: "#1A4784"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.48 45.9747L1309.93 44.9545L1308.9 45.8746L1310.14 45.574L1318.52 46.6398L1318.48 45.9747Z",
    fill: "#1A4784"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.39 33.7684L1322.57 40.2452L1320.58 41.2107L1322.71 39.6348L1326.62 34.3423L1324.56 33.0943L1327.39 33.7684Z",
    fill: "#1A4784"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.12 47.7056L1315.38 48.3616L1309.01 48.2613L1310.12 47.7056Z",
    fill: "#1A4784"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.03 50.3291L1290.24 109.959L1289.19 109.877L1315.37 50.1106L1316.03 50.3291Z",
    fill: "#1A4784"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.47 49.7008L1281.99 109.495L1280.43 109.968L1308.37 49.8738L1309.47 49.7008Z",
    fill: "#1A4784"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.35 170.345L1330.09 48.9354L1329.75 48.8991L1327.02 170.309L1327.35 170.345Z",
    fill: "#1A4784"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.71 171.065L1328.12 49.7189L1327.79 49.6824L1324.37 171.028L1324.71 171.065Z",
    fill: "#1A4784"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.09 171.475L1324.48 49.4364L1324.14 49.4091L1323.75 171.438L1324.09 171.475Z",
    fill: "#1A4784"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M1321.75 171.174L1323.33 48.2978L1322.98 48.2704L1321.4 171.138L1321.75 171.174Z",
    fill: "#1A4784"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.95 47.979C1318.95 47.979 1319.49 50.2655 1319.3 51.0854C1319.11 51.9052 1318.81 52.1693 1318.81 52.1693L1318.17 50.2016L1317.76 48.562L1319.08 46.8858L1318.95 47.979Z",
    fill: "#1A4784"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.71 359.975L1291.92 112.901L1318.77 51.0123C1319.79 50.6752 1320.9 50.3473 1321.1 50.3473H1321.11C1321.35 50.3746 1323.87 50.8301 1324.7 51.0123C1324.8 51.0396 1324.9 51.067 1325.01 51.0852C1325.77 51.2856 1326.8 51.5588 1328.84 50.8938C1331.25 50.1013 1330.88 48.0153 1330.87 47.988L1330.54 48.07C1330.56 48.1429 1330.85 49.8463 1328.75 50.5295C1326.8 51.1762 1325.85 50.9213 1325.09 50.7208C1324.98 50.6935 1324.88 50.6662 1324.77 50.6389C1323.96 50.4476 1321.43 50.0011 1321.15 49.9647C1320.87 49.9192 1319.13 50.4931 1318.62 50.6661L1318.54 50.6935L1318.51 50.7663L1291.63 112.737L1187.41 359.811L1187.71 359.975Z",
    fill: "#1A4784"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M1293.83 110.788L1291.14 108.155L1278.16 108.875L1276.76 112.4L1277.48 112.036L1228.38 223.444L1243.04 225.502L1291.1 112.41L1293.01 112.337L1293.83 110.788Z",
    fill: "#1A4784"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.75 117.228C1289.08 117.146 1291.69 118.932 1291.74 119.205C1291.8 119.487 1290.76 122.147 1290.76 122.147C1290.76 122.147 1289.8 122.576 1289.78 121.993C1289.75 121.419 1289.34 120.653 1289.34 120.653L1286.92 120.271L1288.75 117.228Z",
    fill: "#1A4784"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M1289.1 111.927H1278.32L1277.68 112.665L1289.1 111.927Z",
    fill: "#1A4784"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.84 114.605L1242.06 223.225L1240.45 223.808L1285.66 113.922L1286.84 114.605Z",
    fill: "#1A4784"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.65 220.92L1244.4 217.75L1228.73 218.625L1227.04 222.888L1227.9 222.442L1168.63 356.942L1186.33 359.429L1244.37 222.888L1246.65 222.797L1247.65 220.92Z",
    fill: "#1A4784"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.51 228.709C1241.92 228.618 1245.07 230.768 1245.14 231.105C1245.2 231.433 1243.95 234.658 1243.95 234.658C1243.95 234.658 1242.78 235.168 1242.76 234.475C1242.73 233.783 1242.23 232.854 1242.23 232.854L1239.31 232.398L1241.51 228.709Z",
    fill: "#1A4784"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.94 222.305H1228.93L1228.15 223.198L1241.94 222.305Z",
    fill: "#1A4784"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.21 225.539L1185.16 356.677L1183.2 357.388L1237.79 224.71L1239.21 225.539Z",
    fill: "#1A4784"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M660.445 206.6L663.092 204.004L675.877 204.724L677.246 208.194L676.549 207.83L724.878 317.498L710.446 319.52L663.125 208.194L661.256 208.131L660.445 206.6Z",
    fill: "#1A4784"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M667.33 210.354L711.397 317.28L712.995 317.853L668.485 209.689L667.33 210.354Z",
    fill: "#1A4784"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.88 90.4468L1077.28 87.0672V98.3264L969.104 123.067L968.35 160.188L938.846 170.309V126.438L917.661 133.197V183.809L873.02 215.309L872.266 178.188L851.843 174.809L853.351 148.938L834.444 147.818L833.69 120.817L821.585 121.139V192.809L811.742 204.059V168.068H774.682V147.253H730.041V181.003H694.866V211.939L670.657 227.68V239.494L623 247.374V437.478L1148.4 439.937V154.568H1101.49V117.438L1161.25 99.4468V91.1937L1146.88 90.4468Z",
    fill: "#1A4784"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.51 102.134H1143.13V165.881H1142.51V102.134Z",
    fill: "#1A4784"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.41 101.105H1140.49V164.852H1138.41V101.105Z",
    fill: "#1A4784"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.56 108.793H1118.19V160.534H1117.56V108.793Z",
    fill: "#1A4784"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.19 132.906H1148.14V135.675H1096.19V132.906Z",
    fill: "#1A4784"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.72 129.808H1144.36V133.507H1099.72V129.808Z",
    fill: "#1A4784"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M1110 113.284H1110.62V156.035H1110V113.284Z",
    fill: "#1A4784"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.7 110.952H1118.18V156.044H1115.7V110.952Z",
    fill: "#1A4784"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.46 108.975H1126.94V156.226H1124.46V108.975Z",
    fill: "#1A4784"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.18 108.975H1127.8V156.226H1127.18V108.975Z",
    fill: "#1A4784"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.77 109.449H1141.4V156.69H1140.77V109.449Z",
    fill: "#1A4784"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.29 154.868L1140.86 134.063L1140.42 133.388L1125.86 154.203L1126.29 154.868Z",
    fill: "#1A4784"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.09 155.98L1139.54 155.342L1125.74 133.689L1125.28 134.327L1139.09 155.98Z",
    fill: "#1A4784"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.12 155.224L1117.69 134.409L1117.25 133.744L1102.69 154.559L1103.12 155.224Z",
    fill: "#1A4784"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.87 155.634L1117.32 154.996L1103.51 133.343L1103.06 133.972L1116.87 155.634Z",
    fill: "#1A4784"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.12 132.869L1117.69 112.054L1117.25 111.389L1102.69 132.195L1103.12 132.869Z",
    fill: "#1A4784"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.87 133.27L1117.32 132.632L1103.51 110.979L1103.06 111.617L1116.87 133.27Z",
    fill: "#1A4784"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.48 113.321H1141.77V117.019H1108.48V113.321Z",
    fill: "#1A4784"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.9 133.516L1140.45 115.233L1140.05 114.532L1125.5 132.805L1125.9 133.516Z",
    fill: "#1A4784"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.43 134.782L1140.84 134.081L1125.81 114.678L1125.4 115.37L1140.43 134.782Z",
    fill: "#1A4784"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.44 128.105L1141.11 132.323L1115.11 135.137V137.807C1115.11 137.807 1100.35 138.645 1100.35 137.807C1100.35 136.959 1100.44 128.806 1100.44 128.806L1123.99 128.952L1133.35 129.089L1142.44 128.105Z",
    fill: "#1A4784"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M968.768 111.125L1077.33 85.8101L1077.23 84.8991L968.669 110.214L968.768 111.125Z",
    fill: "#1A4784"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.7 78.04H1075.33V107.664H1074.7V78.04Z",
    fill: "#1A4784"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.15 76.5367H1069.77V106.16H1069.15V76.5367Z",
    fill: "#1A4784"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M975.34 104.293H975.963V134.29H975.34V104.293Z",
    fill: "#1A4784"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M981.143 102.79H981.766V132.031H981.143V102.79Z",
    fill: "#1A4784"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.22 93.4165H1019.84V124.917H1019.22V93.4165Z",
    fill: "#1A4784"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.75 92.6694H1023.37V127.923H1022.75V92.6694Z",
    fill: "#1A4784"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M972.431 117.119L1035.47 100.622L1035.36 99.7112L972.325 116.208L972.431 117.119Z",
    fill: "#1A4784"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.54 113.749L1022.57 112.828L973.906 109.075L973.873 110.005L1022.54 113.749Z",
    fill: "#1A4784"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.66 119.378L1006.7 118.449L974.16 115.452L974.119 116.381L1006.66 119.378Z",
    fill: "#1A4784"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M936.862 149.758L970.735 137.251L970.603 136.522L936.723 149.038L936.862 149.758Z",
    fill: "#1A4784"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M960.441 130.637H961.498V166.92H960.441V130.637Z",
    fill: "#1A4784"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M946.41 134.882H946.943V175.92H946.41V134.882Z",
    fill: "#1A4784"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M937.215 164.524L964.211 154.513L964.08 153.793L937.084 163.795L937.215 164.524Z",
    fill: "#1A4784"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M932.642 108.365H933.175V146.898H932.642V108.365Z",
    fill: "#1A4784"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M929.118 107.609H929.65V141.131H929.118V107.609Z",
    fill: "#1A4784"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M936.535 116.126H937.059V143.4H936.535V116.126Z",
    fill: "#1A4784"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M925.766 118.622H926.299V158.403H925.766V118.622Z",
    fill: "#1A4784"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M920.291 125.381H920.824V165.663H920.291V125.381Z",
    fill: "#1A4784"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M918.177 103.364H918.71V153.402H918.177V103.364Z",
    fill: "#1A4784"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M924.356 97.1055H924.881V149.402H924.356V97.1055Z",
    fill: "#1A4784"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M867.275 145.021H867.807V199.44H867.275V145.021Z",
    fill: "#1A4784"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M861.98 131.885H862.513V197.564H861.98V131.885Z",
    fill: "#1A4784"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M858.014 135.256H859.071V202.811H858.014V135.256Z",
    fill: "#1A4784"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M870.446 148.401H870.979V197.937H870.446V148.401Z",
    fill: "#1A4784"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M874.675 172.604L874.692 171.857L854.58 170.728L854.555 171.484L874.675 172.604Z",
    fill: "#1A4784"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M873.077 169.407L873.118 168.66L856.178 166.601L856.137 167.348L873.077 169.407Z",
    fill: "#1A4784"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M856.022 163.222H875.741V163.968H856.022V163.222Z",
    fill: "#1A4784"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M938.559 160.762L963.965 148L963.793 147.289L938.379 160.052L938.559 160.762Z",
    fill: "#1A4784"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M870.307 209.151L919.537 171.994L919.291 171.338L870.061 208.486L870.307 209.151Z",
    fill: "#1A4784"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M870.578 202.765L922.717 162.611L922.463 161.955L870.324 202.11L870.578 202.765Z",
    fill: "#1A4784"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M880.502 174.29H881.035V215.2H880.502V174.29Z",
    fill: "#1A4784"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M888.714 175.419H889.247V215.573H888.714V175.419Z",
    fill: "#1A4784"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M914.12 144.648H914.653V200.944H914.12V144.648Z",
    fill: "#1A4784"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M910.678 158.53H911.211V197.182H910.678V158.53Z",
    fill: "#1A4784"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M905.384 172.039H905.916V207.694H905.384V172.039Z",
    fill: "#1A4784"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.94 76.71H1159.47V95.8487H1158.94V76.71Z",
    fill: "#1A4784"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.8 86.2199L1162.84 85.4729L1080.09 78.9597L1080.05 79.7157L1162.8 86.2199Z",
    fill: "#1A4784"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.97 66.8263H1083.5V94.8558H1082.97V66.8263Z",
    fill: "#1A4784"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.38 70.3336H1123.92V91.3489H1123.38V70.3336Z",
    fill: "#1A4784"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.55 78.8414H1133.09V93.3525H1132.55V78.8414Z",
    fill: "#1A4784"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.68 79.5883H1141.21V95.8485H1140.68V79.5883Z",
    fill: "#1A4784"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.75 88.7251L1143.78 87.9782L1079.91 82.221L1079.87 82.968L1143.75 88.7251Z",
    fill: "#1A4784"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M849.237 140.421H849.769V158.931H849.237V140.421Z",
    fill: "#1A4784"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M844.475 141.423H845.008V152.181H844.475V141.423Z",
    fill: "#1A4784"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M838.664 140.922H839.189V156.435H838.664V140.922Z",
    fill: "#1A4784"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M827.805 145.294H853.392V146.041H827.805V145.294Z",
    fill: "#1A4784"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M829.035 143.299H846.327V144.046H829.035V143.299Z",
    fill: "#1A4784"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M804.243 147.426H804.776V181.95H804.243V147.426Z",
    fill: "#1A4784"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M801.424 146.424H801.957V180.457H801.424V146.424Z",
    fill: "#1A4784"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M797.539 139.92H798.072V187.954H797.539V139.92Z",
    fill: "#1A4784"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M780.952 145.923H781.485V200.461H780.952V145.923Z",
    fill: "#1A4784"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M774.518 160.562H809.456V161.318H774.518V160.562Z",
    fill: "#1A4784"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M772.404 156.062H803.809V156.809H772.404V156.062Z",
    fill: "#1A4784"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M719.379 137.169H719.912V215.983H719.379V137.169Z",
    fill: "#1A4784"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M711.437 148.428H711.97V206.974H711.437V148.428Z",
    fill: "#1A4784"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M702.963 169.443H703.496V191.215H702.963V169.443Z",
    fill: "#1A4784"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M700.849 154.431H701.382V207.721H700.849V154.431Z",
    fill: "#1A4784"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M727.845 128.16H728.378V230.996H727.845V128.16Z",
    fill: "#1A4784"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M723.083 151.425H723.616V206.218H723.083V151.425Z",
    fill: "#1A4784"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M682.057 170.564H734.992V171.311H682.057V170.564Z",
    fill: "#1A4784"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M711.175 160.061H735.524V160.817H711.175V160.061Z",
    fill: "#1A4784"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M713.822 152.555H733.409V153.302H713.822V152.555Z",
    fill: "#1A4784"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M745.318 115.397H745.851V170.946H745.318V115.397Z",
    fill: "#1A4784"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M755.374 113.147H755.906V154.431H755.374V113.147Z",
    fill: "#1A4784"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M768.077 122.904H768.609V161.937H768.077V122.904Z",
    fill: "#1A4784"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M762.79 125.91H763.315V157.437H762.79V125.91Z",
    fill: "#1A4784"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M758.545 123.65H759.078V165.681H758.545V123.65Z",
    fill: "#1A4784"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M752.194 131.157H752.726V174.699H752.194V131.157Z",
    fill: "#1A4784"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M742.67 134.163H743.203V161.19H742.67V134.163Z",
    fill: "#1A4784"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M735.254 136.413H735.786V164.187H735.254V136.413Z",
    fill: "#1A4784"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M656.118 174.326H711.175V175.073H656.118V174.326Z",
    fill: "#1A4784"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M648.185 194.585H703.234V195.342H648.185V194.585Z",
    fill: "#1A4784"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M647.652 204.341H683.114V205.088H647.652V204.341Z",
    fill: "#1A4784"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.82 143.545H1170.11V144.292H1119.82V143.545Z",
    fill: "#1A4784"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.44 129.663H1162.96V441.449H1162.44V129.663Z",
    fill: "#1A4784"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.55 135.666H1156.08V439.937H1155.55V135.666Z",
    fill: "#1A4784"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.64 361.223H1175.4V361.97H1134.64V361.223Z",
    fill: "#1A4784"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.76 317.68H1171.7V318.427H1145.76V317.68Z",
    fill: "#1A4784"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.06 298.168H1175.93V298.915H1133.06V298.168Z",
    fill: "#1A4784"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.94 269.647H1171.7V270.394H1139.94V269.647Z",
    fill: "#1A4784"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.93 234.375H1164.81V235.122H1130.93V234.375Z",
    fill: "#1A4784"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.08 134.163H1165.61V441.44H1165.08V134.163Z",
    fill: "#1A4784"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M1135.17 180.32H1170.11V181.067H1135.17V180.32Z",
    fill: "#1A4784"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.11 151.052H1165.87V151.799H1134.11V151.052Z",
    fill: "#1A4784"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.06 121.337H1071.58V151.908H1056.06V121.337Z",
    fill: "#1A4784"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M986.634 147.016H1043.13V121.337L984.913 128.679L986.634 147.016Z",
    fill: "#1A4784"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M952.573 224.063H1031.91V283.985H952.573V224.063Z",
    fill: "#1A4784"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M855.99 244.851H872.372V304.772H855.99V244.851Z",
    fill: "#1A4784"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M827.092 203.266H843.483V263.188H827.092V203.266Z",
    fill: "#1A4784"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M824.511 288.877H830.542V348.798H824.511V288.877Z",
    fill: "#1A4784"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M740.425 195.934H756.808V255.855H740.425V195.934Z",
    fill: "#1A4784"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M735.688 274.812H752.071V334.733H735.688V274.812Z",
    fill: "#1A4784"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.98 208.167H1049.16V359.802H1043.98V208.167Z",
    fill: "#1A4784"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.51 226.505H1064.68V359.802H1059.51V226.505Z",
    fill: "#1A4784"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.16 261.266H1399.53V291.527H1363.16V261.266Z",
    fill: "#1A4784"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.99 253.241H1399.53V290.562H1381.99V253.241Z",
    fill: "#1A4784"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M1377.8 218.333H1382.78V290.561H1377.8V218.333Z",
    fill: "#1A4784"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M1394.63 221.385H1399.37V290.562H1394.63V221.385Z",
    fill: "#1A4784"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.16 229.693H1367.91V290.562H1363.16V229.693Z",
    fill: "#1A4784"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.93 229.183H1402.46V229.693H1374.93V229.183Z",
    fill: "#1A4784"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.54 237.199H1402.46V237.718H1359.54V237.199Z",
    fill: "#1A4784"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.54 245.224H1402.46V245.744H1359.54V245.224Z",
    fill: "#1A4784"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.54 253.241H1402.46V253.751H1359.54V253.241Z",
    fill: "#1A4784"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.54 261.266H1402.46V261.776H1359.54V261.266Z",
    fill: "#1A4784"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.54 269.282H1402.46V269.802H1359.54V269.282Z",
    fill: "#1A4784"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.54 277.308H1402.46V277.818H1359.54V277.308Z",
    fill: "#1A4784"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.54 285.324H1402.46V285.843H1359.54V285.324Z",
    fill: "#1A4784"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.9 213.897H1399.02V221.385H1398.9V213.897Z",
    fill: "#1A4784"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.38 214.872H1398.5V221.385H1398.38V214.872Z",
    fill: "#1A4784"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.19 215.755H1398.31V221.385H1398.19V215.755Z",
    fill: "#1A4784"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M1395.46 215.555H1395.58V221.385H1395.46V215.555Z",
    fill: "#1A4784"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M1397.44 217.359H1397.56V218.333H1397.44V217.359Z",
    fill: "#1A4784"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M1397.24 216.776H1397.36V218.333H1397.24V216.776Z",
    fill: "#1A4784"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.6 217.641H1396.72V218.334H1396.6V217.641Z",
    fill: "#1A4784"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.25 217.213H1396.38V218.333H1396.25V217.213Z",
    fill: "#1A4784"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M1394.93 214.872H1395.06V221.385H1394.93V214.872Z",
    fill: "#1A4784"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M1380.11 218.744H1380.23V226.824H1380.11V218.744Z",
    fill: "#1A4784"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.36 216.384H1381.48V218.343H1381.36V216.384Z",
    fill: "#1A4784"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.62 214.817H1381.74V218.333H1381.62V214.817Z",
    fill: "#1A4784"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.15 214.927H1381.27V218.333H1381.15V214.927Z",
    fill: "#1A4784"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M1382.21 214.079H1382.33V218.333H1382.21V214.079Z",
    fill: "#1A4784"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.94 215.327H1382.07V218.333H1381.94V215.327Z",
    fill: "#1A4784"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.45 216.384H1366.57V218.343H1366.45V216.384Z",
    fill: "#1A4784"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.25 214.817H1366.37V218.333H1366.25V214.817Z",
    fill: "#1A4784"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.72 214.927H1366.84V218.333H1366.72V214.927Z",
    fill: "#1A4784"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.66 214.079H1365.78V218.333H1365.66V214.079Z",
    fill: "#1A4784"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.92 215.327H1366.04V218.333H1365.92V215.327Z",
    fill: "#1A4784"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.62 216.748H1379.74V226.832H1379.62V216.748Z",
    fill: "#1A4784"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.36 215.692H1379.48V226.832H1379.36V215.692Z",
    fill: "#1A4784"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M1378.81 214.152H1378.94V226.832H1378.81V214.152Z",
    fill: "#1A4784"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M1378.62 217.441H1378.75V226.832H1378.62V217.441Z",
    fill: "#1A4784"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.67 221.613H1363.79V229.702H1363.67V221.613Z",
    fill: "#1A4784"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.16 219.609H1364.28V229.693H1364.16V219.609Z",
    fill: "#1A4784"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.41 218.552H1364.54V229.702H1364.41V218.552Z",
    fill: "#1A4784"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.96 217.022H1365.08V229.702H1364.96V217.022Z",
    fill: "#1A4784"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.15 220.301H1365.27V229.693H1365.15V220.301Z",
    fill: "#1A4784"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M1377.14 215.783H1377.26V226.832H1377.14V215.783Z",
    fill: "#1A4784"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.59 214.152H1376.71V226.832H1376.59V214.152Z",
    fill: "#1A4784"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.27 219.49H1376.39V226.832H1376.27V219.49Z",
    fill: "#1A4784"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M1394.74 215.755H1394.87V221.385H1394.74V215.755Z",
    fill: "#1A4784"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.11 218.333H1397.7V290.561H1396.11V218.333Z",
    fill: "#1A4784"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.54 218.333H1367.13V290.561H1365.54V218.333Z",
    fill: "#1A4784"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M1384.07 255.372H1388.7V257.741H1384.07V255.372Z",
    fill: "#1A4784"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M1390 262.66H1394.62V265.019H1390V262.66Z",
    fill: "#1A4784"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M1382.41 271.341H1387.03V273.709H1382.41V271.341Z",
    fill: "#1A4784"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.32 278.765H1396.93V281.125H1392.32V278.765Z",
    fill: "#1A4784"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.08 226.833H1379.89V290.562H1376.08V226.833Z",
    fill: "#1A4784"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.2 323.911H1173.05V428.614H1055.2V323.911Z",
    fill: "#1A4784"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M975.799 323.911H998.509V428.614H975.799V323.911Z",
    fill: "#1A4784"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.41 266.996H1153.42V324.658H1152.41V266.996Z",
    fill: "#1A4784"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.93 229.984H1151.94V324.658H1150.93V229.984Z",
    fill: "#1A4784"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.6 209.333H1147.61V324.658H1146.6V209.333Z",
    fill: "#1A4784"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.45 240.706H1149.46V324.658H1148.45V240.706Z",
    fill: "#1A4784"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.1 246.281H1160.11V324.658H1159.1V246.281Z",
    fill: "#1A4784"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.06 281.562H1166.06V324.658H1165.06V281.562Z",
    fill: "#1A4784"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.55 209.333H1164.55V324.658H1163.55V209.333Z",
    fill: "#1A4784"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.08 222.961H1162.09V323.902H1161.08V222.961Z",
    fill: "#1A4784"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.24 349.773H1309.24V407.435H1308.24V349.773Z",
    fill: "#1A4784"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.75 312.752H1307.76V407.435H1306.75V312.752Z",
    fill: "#1A4784"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M1302.42 322.244H1303.43V407.435H1302.42V322.244Z",
    fill: "#1A4784"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.28 323.483H1305.28V407.426H1304.28V323.483Z",
    fill: "#1A4784"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M1314.92 329.049H1315.93V407.426H1314.92V329.049Z",
    fill: "#1A4784"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 364.33H1321.88V407.426H1320.88V364.33Z",
    fill: "#1A4784"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.49 399.455H1322.86V400.567H1301.49V399.455Z",
    fill: "#1A4784"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.49 396.978H1322.86V398.089H1301.49V396.978Z",
    fill: "#1A4784"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.49 394.509H1322.86V395.62H1301.49V394.509Z",
    fill: "#1A4784"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.49 392.032H1322.86V393.152H1301.49V392.032Z",
    fill: "#1A4784"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.37 328.885H1320.37V407.426H1319.37V328.885Z",
    fill: "#1A4784"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.9 305.738H1317.91V406.679H1316.9V305.738Z",
    fill: "#1A4784"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.33 405.122H1381.71V406.242H1360.33V405.122Z",
    fill: "#1A4784"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.33 402.088H1381.71V403.208H1360.33V402.088Z",
    fill: "#1A4784"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.33 399.055H1381.71V400.166H1360.33V399.055Z",
    fill: "#1A4784"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.33 396.021H1381.71V397.133H1360.33V396.021Z",
    fill: "#1A4784"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.33 392.988H1381.71V394.099H1360.33V392.988Z",
    fill: "#1A4784"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M1367.1 357.917H1368.1V415.579H1367.1V357.917Z",
    fill: "#1A4784"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.63 320.896H1366.63V415.57H1365.63V320.896Z",
    fill: "#1A4784"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M1361.29 331.627H1362.29V415.579H1361.29V331.627Z",
    fill: "#1A4784"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.14 331.627H1364.15V415.579H1363.14V331.627Z",
    fill: "#1A4784"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.79 344.626H1374.79V415.579H1373.79V344.626Z",
    fill: "#1A4784"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.74 327.172H1380.74V415.579H1379.74V327.172Z",
    fill: "#1A4784"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M1378.24 314.92H1379.24V415.579H1378.24V314.92Z",
    fill: "#1A4784"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M1375.26 324.613H1376.26V413.265H1375.26V324.613Z",
    fill: "#1A4784"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.45 247.037H1072.93V329.869H1041.45V247.037Z",
    fill: "#1A4784"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M979.766 310.867H1055.21V329.869H979.766V310.867Z",
    fill: "#1A4784"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M979.766 409.084H1055.21V428.086H979.766V409.084Z",
    fill: "#1A4784"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M997.345 403.91H1019.26V409.43H997.345V403.91Z",
    fill: "#1A4784"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M989.035 400.02H1010.95V405.541H989.035V400.02Z",
    fill: "#1A4784"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M979.954 401.778H1002.52V395.529H979.954V401.778ZM1001.87 401.05H980.61V396.258H1001.87V401.05Z",
    fill: "#1A4784"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M991.576 251.437H992.625V323.383H991.576V251.437Z",
    fill: "#1A4784"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.15 162.775H1059.2V268.016H1058.15V162.775Z",
    fill: "#1A4784"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.29 165.8H1063.34V271.031H1062.29V165.8Z",
    fill: "#1A4784"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.75 174.599H1066.8V279.84H1065.75V174.599Z",
    fill: "#1A4784"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.61 183.217H1056.66V288.448H1055.61V183.217Z",
    fill: "#1A4784"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.48 242.82H1016.53V314.875H1015.48V242.82Z",
    fill: "#1A4784"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.28 236.215H1012.33V314.866H1011.28V236.215Z",
    fill: "#1A4784"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.69 252.166H1019.74V314.875H1018.69V252.166Z",
    fill: "#1A4784"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.32 248.121H1008.37V314.875H1007.32V248.121Z",
    fill: "#1A4784"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.98 186.442H1177.7V426.638H1173.98V186.442Z",
    fill: "#1A4784"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.88 190.768H1181.6V430.974H1177.88V190.768Z",
    fill: "#1A4784"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M1242.99 226.914H1246.7V430.973H1242.99V226.914Z",
    fill: "#1A4784"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.34 226.541H1335.06V430.983H1331.34V226.541Z",
    fill: "#1A4784"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M1399.15 257.449H1402.86V430.973H1399.15V257.449Z",
    fill: "#1A4784"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M1238.54 229.301H1242.25V426.638H1238.54V229.301Z",
    fill: "#1A4784"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.77 215.017H1329.48V426.637H1325.77V215.017Z",
    fill: "#1A4784"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.7 410.687H1402.57V433.588H1173.7V410.687Z",
    fill: "#1A4784"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.98 354.2H1402.86V358.326H1173.98V354.2Z",
    fill: "#1A4784"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.98 290.334H1402.86V294.461H1173.98V290.334Z",
    fill: "#1A4784"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M1401.01 245.926H1404.72V426.638H1401.01V245.926Z",
    fill: "#1A4784"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.22 293.779L1239.06 353.526L1238.08 354.761L1177.24 295.015L1178.22 293.779Z",
    fill: "#1A4784"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M1238.11 293.808L1239.09 295.042L1176.35 356.802L1175.37 355.568L1238.11 293.808Z",
    fill: "#1A4784"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.03 293.838L1402.37 353.573L1401.49 354.897L1329.14 295.162L1330.03 293.838Z",
    fill: "#1A4784"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M1401.47 293.906L1402.35 295.231L1329.92 354.836L1329.04 353.511L1401.47 293.906Z",
    fill: "#1A4784"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.24 357.706L1239.08 414.007L1238.13 415.274L1177.29 358.974L1178.24 357.706Z",
    fill: "#1A4784"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M1237.94 357.667L1238.89 358.933L1178.13 415.347L1177.18 414.082L1237.94 357.667Z",
    fill: "#1A4784"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.1 358.327H1196.59V417.328H1195.1V358.327Z",
    fill: "#1A4784"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.66 358.327H1215.15V417.328H1213.66V358.327Z",
    fill: "#1A4784"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.75 358.327H1219.23V417.328H1217.75V358.327Z",
    fill: "#1A4784"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.52 356.259H1279V414.632H1277.52V356.259Z",
    fill: "#1A4784"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M1281.97 358.327H1283.45V417.328H1281.97V358.327Z",
    fill: "#1A4784"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.29 357.755L1326.42 358.823L1283.33 415.108L1282.2 414.04L1325.29 357.755Z",
    fill: "#1A4784"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.07 415.187L1282.15 358.873L1283.27 357.78L1328.18 414.085L1327.07 415.187Z",
    fill: "#1A4784"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.9 357.771L1328.11 407.288L1327 408.377L1287.79 358.86L1288.9 357.771Z",
    fill: "#1A4784"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.74 355.722L1240.91 407.296L1239.97 408.576L1182.81 357.002L1183.74 355.722Z",
    fill: "#1A4784"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.66 415.115L1241.64 358.809L1242.86 357.853L1278.86 414.158L1277.66 415.115Z",
    fill: "#1A4784"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.62 355.754L1278.84 356.685L1242.91 415.15L1241.68 414.22L1277.62 355.754Z",
    fill: "#1A4784"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M1249.14 358.327H1250.62V414.632H1249.14V358.327Z",
    fill: "#1A4784"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.1 294.461H1245.59V356.259H1244.1V294.461Z",
    fill: "#1A4784"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M1229.26 294.461H1230.74V356.259H1229.26V294.461Z",
    fill: "#1A4784"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.48 294.461H1183.96V356.259H1182.48V294.461Z",
    fill: "#1A4784"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.68 294.461H1189.16V356.259H1187.68V294.461Z",
    fill: "#1A4784"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.92 294.461H1227.4V356.259H1225.92V294.461Z",
    fill: "#1A4784"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.23 294.461H1257.72V356.259H1256.23V294.461Z",
    fill: "#1A4784"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.36 294.461H1269.85V356.259H1268.36V294.461Z",
    fill: "#1A4784"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.84 363.282H1402.87V364.94H1175.84V363.282Z",
    fill: "#1A4784"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.84 296.847H1402.87V298.496H1175.84V296.847Z",
    fill: "#1A4784"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.79 294.461H1277.27V356.259H1275.79V294.461Z",
    fill: "#1A4784"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.49 294.461H1281.97V356.259H1280.49V294.461Z",
    fill: "#1A4784"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M1294.1 294.461H1295.58V356.259H1294.1V294.461Z",
    fill: "#1A4784"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M1299.79 294.461H1301.27V356.259H1299.79V294.461Z",
    fill: "#1A4784"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.42 294.461H1312.9V356.259H1311.42V294.461Z",
    fill: "#1A4784"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.87 294.461H1318.35V356.259H1316.87V294.461Z",
    fill: "#1A4784"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.46 294.461H1333.94V356.259H1332.46V294.461Z",
    fill: "#1A4784"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M1337.9 294.461H1339.38V356.259H1337.9V294.461Z",
    fill: "#1A4784"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.56 294.461H1341.05V356.259H1339.56V294.461Z",
    fill: "#1A4784"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M1345.01 294.461H1346.5V356.259H1345.01V294.461Z",
    fill: "#1A4784"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M1397.23 294.461H1398.71V356.259H1397.23V294.461Z",
    fill: "#1A4784"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.7 294.461H1395.19V356.259H1393.7V294.461Z",
    fill: "#1A4784"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.85 294.461H1375.33V356.259H1373.85V294.461Z",
    fill: "#1A4784"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.67 294.461H1367.16V356.259H1365.67V294.461Z",
    fill: "#1A4784"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.5 357.197H1313.99V415.579H1312.5V357.197Z",
    fill: "#1A4784"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M1336.16 356.259H1337.65V414.668H1336.16V356.259Z",
    fill: "#1A4784"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M1342.29 357.197H1343.78V414.677H1342.29V357.197Z",
    fill: "#1A4784"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.15 356.259H1388.63V414.632H1387.15V356.259Z",
    fill: "#1A4784"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M1395.06 357.197H1396.55V415.579H1395.06V357.197Z",
    fill: "#1A4784"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M1326.16 357.528L1403.25 413.835L1402.43 415.213L1325.35 358.906L1326.16 357.528Z",
    fill: "#1A4784"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M1402.49 357.715L1403.31 359.084L1328.02 415.297L1327.2 413.929L1402.49 357.715Z",
    fill: "#1A4784"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.63 389.408H1402.87V392.705H1327.63V389.408Z",
    fill: "#1A4784"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.09 339.16H1327.62V342.458H1245.09V339.16Z",
    fill: "#1A4784"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.46 391.066H1333.94V414.641H1332.46V391.066Z",
    fill: "#1A4784"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M1390.37 391.066H1391.85V414.641H1390.37V391.066Z",
    fill: "#1A4784"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.44 407.08H1330.53V419.086H1263.44V407.08Z",
    fill: "#1A4784"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.22 252.157H1068.76V279.84L1138.96 261.275L1144.22 252.157Z",
    fill: "#1A4784"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.98 258.715H1138.64V328.001H1137.98V258.715Z",
    fill: "#1A4784"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.44 260.911H1131.1V323.638H1130.44V260.911Z",
    fill: "#1A4784"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.12 303.935H1142.91V304.672H1067.12V303.935Z",
    fill: "#1A4784"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.37 297.367H1136.67V298.095H1072.37V297.367Z",
    fill: "#1A4784"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.89 337.12H1145.2V420.27H1143.89V337.12Z",
    fill: "#1A4784"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.34 336.391H1158.65V420.99H1157.34V336.391Z",
    fill: "#1A4784"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.2 338.222H1167.51V421.363H1166.2V338.222Z",
    fill: "#1A4784"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.89 405.168L1157.82 406.205L1143.88 421.704L1142.95 420.668L1156.89 405.168Z",
    fill: "#1A4784"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.39 405.78L1157.68 420.552L1156.75 421.583L1143.46 406.811L1144.39 405.78Z",
    fill: "#1A4784"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.12 329.468H1047.43V408.966H1046.12V329.468Z",
    fill: "#1A4784"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.7 326.544H1032.01V412.245H1030.7V326.544Z",
    fill: "#1A4784"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.91 326.544H1019.22V411.516H1017.91V326.544Z",
    fill: "#1A4784"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.86 328.375H1043.17V409.33H1041.86V328.375Z",
    fill: "#1A4784"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M995.919 380.153H1056.94V381.61H995.919V380.153Z",
    fill: "#1A4784"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M996.911 363.382H1058.92V364.84H996.911V363.382Z",
    fill: "#1A4784"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M995.264 335.298H1059.57V336.756H995.264V335.298Z",
    fill: "#1A4784"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M995.591 333.112H1056.29V334.569H995.591V333.112Z",
    fill: "#1A4784"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.38 331.29H1050.05V332.747H1008.38V331.29Z",
    fill: "#1A4784"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7789 231.719C70.7789 231.719 64.0474 229.003 61.7983 228.854C61.0716 230.385 60.0531 233.638 60.4881 234.388C60.9231 235.137 60.8593 237.37 60.3819 237.737C61.0963 237.995 61.7883 238.311 62.4507 238.683L63.4639 243.775L59.7507 244.211C59.7507 244.211 58.5201 244.355 58.3716 243.483C58.223 242.611 56.3398 238.97 55.9048 238.534C55.4699 238.098 55.9791 235.988 56.4353 234.462C56.8915 232.937 55.9048 227.839 55.9048 227.839L50.8125 235.084L51.709 242.601L45.3169 239.746C45.3169 239.746 44.447 236.328 44.6698 235.456C44.8926 234.584 44.4522 230.874 44.6326 230.672C44.813 230.47 49.7251 225.627 50.8125 224.463C51.9 223.299 57.1779 220.577 59.6074 220.795C60.8593 219.27 65.2144 223.985 68.5563 223.124C68.6306 221.449 70.588 216.867 71.8982 215.193C72.7682 210.897 75.3833 205.438 76.614 204.274C72.4074 202.599 71.8398 202.148 71.8398 202.148L71.2563 203.312C71.2563 203.312 70.0257 203.312 69.2247 203.386C68.4237 203.461 67.5537 203.168 67.5537 202.95C67.5537 202.732 67.628 202.148 67.628 202.148L65.8828 202.514C65.8828 202.514 64.6522 200.766 65.3789 199.24C65.0129 197.709 66.0313 196.837 67.3362 196.109C68.6412 195.381 74.455 192.834 75.0332 192.106C75.6114 191.378 80.046 189.778 80.046 189.778V183.351C80.046 183.351 81.786 188.465 82.3695 189.56C84.8814 189.452 87.3727 190.056 89.5571 191.303C91.2722 192.273 92.7014 193.68 93.7 195.381C94.8617 197.199 94.57 195.747 95.2914 197.858C95.6952 198.965 95.9868 200.11 96.1614 201.276L94.6389 200.473L96.1614 203.168L93.7637 202.95C93.7637 202.95 93.4772 204.407 94.7822 204.694L96.0871 204.986C96.0871 204.986 97.7634 199.601 99.0683 198.076C100.373 196.55 103.498 194.44 104.007 194.147L104.15 193.201C104.15 193.201 102.644 192.914 102.453 192.404C102.341 192.073 102.341 191.714 102.453 191.383V189.847L103.572 188.784L103.28 187.768C103.28 187.768 103.715 185.876 104.15 185.642C104.405 185.521 104.611 185.317 104.734 185.063L105.169 183.824L106.256 184.26L107.71 184.191C107.71 184.191 110.033 186.445 110.468 187.976C110.747 188.896 110.894 189.852 110.903 190.814C110.903 191.101 111.677 192.484 111.677 192.776V193.068L110.372 193.797C110.372 193.797 110.006 194.089 110.733 194.743C111.46 195.397 111.969 196.199 112.621 199.325C113.274 202.451 113.009 210.026 112.722 211.264L111.921 212.062C111.921 212.062 114.754 221.593 115.698 222.252C116.711 222.831 118.748 222.98 119.91 224.431C121.072 225.883 125.862 231.565 127.172 234.26C128.912 234.622 132.328 234.622 135.596 241.607C138.863 248.592 139.081 257.474 144.163 262.87C149.244 268.265 149.61 269.344 152.008 270.312C154.406 271.279 147.796 271.04 147.796 271.04L150.263 273.225C150.263 273.225 148.884 273.804 149.25 274.288C149.616 274.772 150.48 275.744 150.194 275.819C149.907 275.893 147.011 275.819 147.011 275.819L145.706 276.691C145.706 276.691 138.37 270.987 137.219 268.127C136.068 265.267 131.267 250.856 131.044 248.017C130.822 245.179 127.862 242.048 126.981 240.958C126.111 242.34 123.347 246.274 121.751 246.928C120.154 247.582 117.321 248.235 118.191 248.964C119.061 249.692 123.565 254.279 124.026 254.641C124.488 255.002 123.231 256.895 123.231 256.895C123.231 256.895 121.846 264.337 120.101 266.718C119.128 267.986 118.408 269.43 117.979 270.971L112.706 269.908C112.706 269.908 109.152 268.021 111.693 267.144C114.234 266.266 114.966 264.018 116.202 262.269C117.438 260.52 118.6 256.953 116.563 255.359C114.526 253.764 110.245 252.663 110.319 251.637C110.245 253.455 110.245 255.784 112.139 257.24C113.3 258.915 112.5 261.02 111.12 261.605C109.741 262.189 105.524 265.246 104.436 266.553L99.063 265.389C99.063 265.389 104.728 259.01 105.381 258.043C106.033 257.075 105.747 255.789 103.789 254.258C101.832 252.727 101.763 253.53 100.559 251.563C99.3547 249.596 98.0498 245.716 98.4848 244.722C98.9197 243.728 98.7076 243.127 100.013 242.755C94.204 242.468 90.8568 245.593 85.2658 238.97C84.1158 240.106 83.1382 241.404 82.3642 242.824C82.3642 242.824 82.3642 245.519 81.054 245.955C79.7437 246.391 76.9322 248.613 75.2613 248.613C73.5903 248.613 69.5112 241.367 69.2194 239.911C70.9646 239.549 75.5849 238.529 76.9906 235.983C77.7173 234.893 76.9217 234.239 76.1207 234.239C75.3197 234.239 73.9405 234.771 72.4075 234.021C70.8744 233.271 70.6145 232.692 70.7789 231.719Z",
    fill: "#1A4784"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M0 355.433H259.5C259.5 355.433 245.942 344.956 232.977 338.55C220.013 332.145 218.453 328.849 209.356 321.279C200.259 313.71 213.419 318.951 191.538 310.217C169.656 301.483 165.392 301.095 154.549 289.842C143.706 278.588 153.196 283.048 134.795 276.648C116.393 270.248 107.492 264.81 93.9495 263.837C80.4068 262.864 80.2 263.837 64.1271 263.449C48.0542 263.061 30.6233 261.897 30.8196 270.822C31.0158 279.747 33.5303 290.033 34.501 290.033C35.4718 290.033 52.8973 291.782 44.9564 302.456C37.0154 313.13 2.71064 343.212 0 355.433Z",
    fill: "#1A4784"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M324.123 303.058H270.556V298.509H324.123V303.058ZM272.097 301.179H322.582V300.391H272.097V301.179Z",
    fill: "#1A4784"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M444.877 303.462H498.444V298.913H444.877V303.462ZM496.903 301.583H446.418V300.795H496.903V301.583Z",
    fill: "#1A4784"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M325.031 305.787H274.188V301.238H325.031V305.787ZM275.72 304.086H323.5V302.94H275.72V304.086Z",
    fill: "#1A4784"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M443.969 306.191H494.812V301.642H443.969V306.191ZM493.28 304.489H445.501V303.344H493.28V304.489Z",
    fill: "#1A4784"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M325.031 311.246H276.004V303.968H325.031V311.246ZM277.546 309.384H323.483V305.809H277.546V309.384Z",
    fill: "#1A4784"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M443.969 311.65H492.996V304.371H443.969V311.65ZM491.454 309.787H445.517V306.212H491.454V309.787Z",
    fill: "#1A4784"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M323.314 355.305H312.41V344.578H323.314V355.305ZM314.262 353.45H321.462V346.43H314.262V353.45Z",
    fill: "#1A4784"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M445.686 355.709H456.59V344.982H445.686V355.709ZM454.738 353.854H447.538V346.834H454.738V353.854Z",
    fill: "#1A4784"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M323.314 340.013H312.41V319.356C312.41 317.907 312.985 316.517 314.007 315.493C315.029 314.468 316.416 313.892 317.862 313.892C319.308 313.892 320.695 314.468 321.717 315.493C322.739 316.517 323.314 317.907 323.314 319.356V340.013ZM314.262 338.157H321.462V319.366C321.462 318.41 321.083 317.492 320.408 316.815C319.733 316.139 318.817 315.759 317.862 315.759C316.907 315.759 315.991 316.139 315.316 316.815C314.641 317.492 314.262 318.41 314.262 319.366V338.157Z",
    fill: "#1A4784"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M445.686 340.416H456.59V319.759C456.59 318.31 456.016 316.92 454.993 315.896C453.971 314.871 452.584 314.296 451.138 314.296C449.692 314.296 448.305 314.871 447.283 315.896C446.261 316.92 445.686 318.31 445.686 319.759V340.416ZM454.738 338.56H447.538V319.77C447.538 318.813 447.917 317.895 448.592 317.219C449.267 316.542 450.183 316.162 451.138 316.162C452.093 316.162 453.009 316.542 453.684 317.219C454.359 317.895 454.738 318.813 454.738 319.77V338.56Z",
    fill: "#1A4784"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M306.656 355.305H295.756V344.578H306.656V355.305ZM297.604 353.45H304.808V346.43H297.604V353.45Z",
    fill: "#1A4784"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M462.344 355.709H473.244V344.982H462.344V355.709ZM471.396 353.854H464.192V346.834H471.396V353.854Z",
    fill: "#1A4784"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M306.656 340.013H295.756V319.356C295.737 318.627 295.865 317.901 296.13 317.223C296.396 316.544 296.794 315.925 297.302 315.403C297.81 314.881 298.417 314.466 299.088 314.182C299.758 313.899 300.478 313.753 301.206 313.753C301.934 313.753 302.654 313.899 303.325 314.182C303.995 314.466 304.602 314.881 305.11 315.403C305.618 315.925 306.016 316.544 306.282 317.223C306.548 317.901 306.675 318.627 306.656 319.356V340.013ZM297.604 338.157H304.808V319.366C304.779 318.429 304.386 317.539 303.714 316.886C303.042 316.234 302.142 315.868 301.206 315.868C300.27 315.868 299.37 316.234 298.698 316.886C298.026 317.539 297.633 318.429 297.604 319.366V338.157Z",
    fill: "#1A4784"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M462.344 340.416H473.244V319.759C473.263 319.03 473.135 318.305 472.87 317.626C472.604 316.947 472.206 316.328 471.698 315.806C471.19 315.284 470.583 314.869 469.912 314.586C469.242 314.302 468.522 314.156 467.794 314.156C467.066 314.156 466.346 314.302 465.675 314.586C465.005 314.869 464.398 315.284 463.89 315.806C463.382 316.328 462.984 316.947 462.718 317.626C462.452 318.305 462.325 319.03 462.344 319.759V340.416ZM471.396 338.561H464.192V319.77C464.221 318.832 464.614 317.943 465.286 317.29C465.958 316.637 466.858 316.272 467.794 316.272C468.73 316.272 469.63 316.637 470.302 317.29C470.974 317.943 471.367 318.832 471.396 319.77V338.561Z",
    fill: "#1A4784"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M290.002 355.305H279.098V344.578H290.002V355.305ZM280.95 353.45H288.15V346.43H280.95V353.45Z",
    fill: "#1A4784"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M478.998 355.709H489.902V344.982H478.998V355.709ZM488.05 353.854H480.85V346.834H488.05V353.854Z",
    fill: "#1A4784"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M290.002 340.013H279.098V319.356C279.098 317.907 279.673 316.517 280.695 315.493C281.718 314.468 283.104 313.892 284.55 313.892C285.996 313.892 287.383 314.468 288.405 315.493C289.428 316.517 290.002 317.907 290.002 319.356V340.013ZM280.95 338.157H288.15V319.366C288.15 318.41 287.771 317.492 287.096 316.815C286.421 316.139 285.505 315.759 284.55 315.759C283.595 315.759 282.68 316.139 282.004 316.815C281.329 317.492 280.95 318.41 280.95 319.366V338.157Z",
    fill: "#1A4784"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M478.998 340.416H489.902V319.759C489.902 318.31 489.327 316.92 488.305 315.896C487.282 314.871 485.896 314.296 484.45 314.296C483.004 314.296 481.617 314.871 480.595 315.896C479.572 316.92 478.998 318.31 478.998 319.759V340.416ZM488.05 338.56H480.85V319.77C480.85 318.813 481.229 317.895 481.904 317.219C482.579 316.542 483.495 316.162 484.45 316.162C485.405 316.162 486.32 316.542 486.996 317.219C487.671 317.895 488.05 318.813 488.05 319.77V338.56Z",
    fill: "#1A4784"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M323.314 297.656H312.41V276.999C312.41 275.55 312.985 274.16 314.007 273.136C315.029 272.111 316.416 271.535 317.862 271.535C319.308 271.535 320.695 272.111 321.717 273.136C322.739 274.16 323.314 275.55 323.314 276.999V297.656ZM314.262 295.8H321.462V277.013C321.462 276.056 321.083 275.139 320.408 274.462C319.733 273.785 318.817 273.405 317.862 273.405C316.907 273.405 315.991 273.785 315.316 274.462C314.641 275.139 314.262 276.056 314.262 277.013V295.8Z",
    fill: "#1A4784"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M445.686 298.059H456.59V277.402C456.59 275.953 456.016 274.563 454.993 273.539C453.971 272.514 452.584 271.939 451.138 271.939C449.692 271.939 448.305 272.514 447.283 273.539C446.261 274.563 445.686 275.953 445.686 277.402V298.059ZM454.738 296.203H447.538V277.416C447.538 276.459 447.917 275.542 448.592 274.865C449.267 274.189 450.183 273.809 451.138 273.809C452.093 273.809 453.009 274.189 453.684 274.865C454.359 275.542 454.738 276.459 454.738 277.416V296.203Z",
    fill: "#1A4784"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M306.656 297.655H295.756V276.998C295.737 276.269 295.865 275.544 296.13 274.865C296.396 274.186 296.794 273.567 297.302 273.045C297.81 272.523 298.417 272.108 299.088 271.825C299.758 271.541 300.478 271.396 301.206 271.396C301.934 271.396 302.654 271.541 303.325 271.825C303.995 272.108 304.602 272.523 305.11 273.045C305.618 273.567 306.016 274.186 306.282 274.865C306.548 275.544 306.675 276.269 306.656 276.998V297.655ZM297.604 295.8H304.808V277.013C304.823 276.529 304.741 276.047 304.567 275.596C304.393 275.145 304.13 274.733 303.794 274.386C303.458 274.039 303.056 273.762 302.611 273.574C302.167 273.385 301.689 273.288 301.206 273.288C300.723 273.288 300.245 273.385 299.801 273.574C299.356 273.762 298.954 274.039 298.618 274.386C298.282 274.733 298.019 275.145 297.845 275.596C297.671 276.047 297.589 276.529 297.604 277.013V295.8Z",
    fill: "#1A4784"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M462.344 298.059H473.244V277.402C473.263 276.673 473.135 275.948 472.87 275.269C472.604 274.59 472.206 273.971 471.698 273.449C471.19 272.927 470.583 272.512 469.912 272.228C469.242 271.945 468.522 271.799 467.794 271.799C467.066 271.799 466.346 271.945 465.675 272.228C465.005 272.512 464.398 272.927 463.89 273.449C463.382 273.971 462.984 274.59 462.718 275.269C462.452 275.948 462.325 276.673 462.344 277.402V298.059ZM471.396 296.203H464.192V277.416C464.177 276.933 464.259 276.451 464.433 276C464.607 275.549 464.87 275.137 465.206 274.79C465.542 274.442 465.944 274.166 466.389 273.977C466.833 273.789 467.311 273.691 467.794 273.691C468.277 273.691 468.755 273.789 469.199 273.977C469.644 274.166 470.046 274.442 470.382 274.79C470.718 275.137 470.981 275.549 471.155 276C471.329 276.451 471.411 276.933 471.396 277.416V296.203Z",
    fill: "#1A4784"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M290.002 297.656H279.098V276.999C279.098 275.55 279.673 274.16 280.695 273.136C281.718 272.111 283.104 271.535 284.55 271.535C285.996 271.535 287.383 272.111 288.405 273.136C289.428 274.16 290.002 275.55 290.002 276.999V297.656ZM280.95 295.8H288.15V277.013C288.15 276.056 287.771 275.139 287.096 274.462C286.421 273.785 285.505 273.405 284.55 273.405C283.595 273.405 282.68 273.785 282.004 274.462C281.329 275.139 280.95 276.056 280.95 277.013V295.8Z",
    fill: "#1A4784"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M478.998 298.059H489.902V277.402C489.902 275.953 489.327 274.563 488.305 273.539C487.282 272.514 485.896 271.939 484.45 271.939C483.004 271.939 481.617 272.514 480.595 273.539C479.572 274.563 478.998 275.953 478.998 277.402V298.059ZM488.05 296.203H480.85V277.416C480.85 276.459 481.229 275.542 481.904 274.865C482.579 274.189 483.495 273.809 484.45 273.809C485.405 273.809 486.32 274.189 486.996 274.865C487.671 275.542 488.05 276.459 488.05 277.416V296.203Z",
    fill: "#1A4784"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M323.314 265.819H312.41V253.535C312.41 252.086 312.985 250.697 314.007 249.672C315.029 248.648 316.416 248.072 317.862 248.072C319.308 248.072 320.695 248.648 321.717 249.672C322.739 250.697 323.314 252.086 323.314 253.535V265.819ZM314.262 263.964H321.462V253.535C321.462 252.579 321.083 251.661 320.408 250.984C319.733 250.308 318.817 249.928 317.862 249.928C316.907 249.928 315.991 250.308 315.316 250.984C314.641 251.661 314.262 252.579 314.262 253.535V263.964Z",
    fill: "#1A4784"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M445.686 266.223H456.59V253.939C456.59 252.49 456.016 251.1 454.993 250.076C453.971 249.051 452.584 248.476 451.138 248.476C449.692 248.476 448.305 249.051 447.283 250.076C446.261 251.1 445.686 252.49 445.686 253.939V266.223ZM454.738 264.367H447.538V253.939C447.538 252.982 447.917 252.064 448.592 251.388C449.267 250.711 450.183 250.331 451.138 250.331C452.093 250.331 453.009 250.711 453.684 251.388C454.359 252.064 454.738 252.982 454.738 253.939V264.367Z",
    fill: "#1A4784"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M306.656 265.819H295.756V253.535C295.737 252.806 295.865 252.081 296.13 251.402C296.396 250.723 296.794 250.104 297.302 249.582C297.81 249.06 298.417 248.645 299.088 248.362C299.758 248.078 300.478 247.932 301.206 247.932C301.934 247.932 302.654 248.078 303.325 248.362C303.995 248.645 304.602 249.06 305.11 249.582C305.618 250.104 306.016 250.723 306.282 251.402C306.548 252.081 306.675 252.806 306.656 253.535V265.819ZM297.604 263.963H304.808V253.535C304.823 253.052 304.741 252.57 304.567 252.119C304.393 251.668 304.13 251.256 303.794 250.909C303.458 250.561 303.056 250.285 302.611 250.096C302.167 249.908 301.689 249.81 301.206 249.81C300.723 249.81 300.245 249.908 299.801 250.096C299.356 250.285 298.954 250.561 298.618 250.909C298.282 251.256 298.019 251.668 297.845 252.119C297.671 252.57 297.589 253.052 297.604 253.535V263.963Z",
    fill: "#1A4784"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M462.344 266.222H473.244V253.939C473.263 253.21 473.135 252.484 472.87 251.805C472.604 251.126 472.206 250.508 471.698 249.986C471.19 249.463 470.583 249.048 469.912 248.765C469.242 248.482 468.522 248.336 467.794 248.336C467.066 248.336 466.346 248.482 465.675 248.765C465.005 249.048 464.398 249.463 463.89 249.986C463.382 250.508 462.984 251.126 462.718 251.805C462.452 252.484 462.325 253.21 462.344 253.939V266.222ZM471.396 264.367H464.192V253.939C464.177 253.455 464.259 252.973 464.433 252.522C464.607 252.071 464.87 251.659 465.206 251.312C465.542 250.964 465.944 250.688 466.389 250.5C466.833 250.311 467.311 250.214 467.794 250.214C468.277 250.214 468.755 250.311 469.199 250.5C469.644 250.688 470.046 250.964 470.382 251.312C470.718 251.659 470.981 252.071 471.155 252.522C471.329 252.973 471.411 253.455 471.396 253.939V264.367Z",
    fill: "#1A4784"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M290.002 265.819H279.098V253.535C279.098 252.086 279.673 250.697 280.695 249.672C281.718 248.648 283.104 248.072 284.55 248.072C285.996 248.072 287.383 248.648 288.405 249.672C289.428 250.697 290.002 252.086 290.002 253.535V265.819ZM280.95 263.964H288.15V253.535C288.15 252.579 287.771 251.661 287.096 250.984C286.421 250.308 285.505 249.928 284.55 249.928C283.595 249.928 282.68 250.308 282.004 250.984C281.329 251.661 280.95 252.579 280.95 253.535V263.964Z",
    fill: "#1A4784"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M478.998 266.223H489.902V253.939C489.902 252.49 489.327 251.1 488.305 250.076C487.282 249.051 485.896 248.476 484.45 248.476C483.004 248.476 481.617 249.051 480.595 250.076C479.572 251.1 478.998 252.49 478.998 253.939V266.223ZM488.05 264.367H480.85V253.939C480.85 252.982 481.229 252.064 481.904 251.388C482.579 250.711 483.495 250.331 484.45 250.331C485.405 250.331 486.32 250.711 486.996 251.388C487.671 252.064 488.05 252.982 488.05 253.939V264.367Z",
    fill: "#1A4784"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M322.386 278.993H313.334V280.848H322.386V278.993Z",
    fill: "#1A4784"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M446.614 279.396H455.666V281.252H446.614V279.396Z",
    fill: "#1A4784"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M318.786 272.476H316.934V296.73H318.786V272.476Z",
    fill: "#1A4784"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M450.214 272.879H452.066V297.133H450.214V272.879Z",
    fill: "#1A4784"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M305.732 278.993H296.68V280.848H305.732V278.993Z",
    fill: "#1A4784"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M463.268 279.396H472.32V281.252H463.268V279.396Z",
    fill: "#1A4784"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M302.132 272.476H300.28V296.73H302.132V272.476Z",
    fill: "#1A4784"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M466.868 272.879H468.72V297.133H466.868V272.879Z",
    fill: "#1A4784"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M289.078 278.993H280.026V280.848H289.078V278.993Z",
    fill: "#1A4784"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M479.922 279.396H488.974V281.252H479.922V279.396Z",
    fill: "#1A4784"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M285.478 272.476H283.626V296.73H285.478V272.476Z",
    fill: "#1A4784"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M483.522 272.879H485.374V297.133H483.522V272.879Z",
    fill: "#1A4784"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M199.738 303.058H140.724V298.509H199.738V303.058ZM142.4 301.179H198.046V300.391H142.406L142.4 301.179Z",
    fill: "#1A4784"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M569.262 303.462H628.276V298.913H569.262V303.462ZM626.6 301.583H570.954V300.795H626.594L626.6 301.583Z",
    fill: "#1A4784"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M200.646 305.787H143.448V301.238H200.646V305.787ZM145.161 304.086H198.93V302.94H145.168L145.161 304.086Z",
    fill: "#1A4784"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M568.354 306.191H625.552V301.642H568.354V306.191ZM623.839 304.489H570.07V303.344H623.832L623.839 304.489Z",
    fill: "#1A4784"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M200.646 311.246H143.448V303.968H200.646V311.246ZM145.247 309.384H198.84V305.809H145.254L145.247 309.384Z",
    fill: "#1A4784"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M568.354 311.65H625.552V304.371H568.354V311.65ZM623.753 309.787H570.16V306.212H623.746L623.753 309.787Z",
    fill: "#1A4784"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M197.732 239.312H138V234.254H197.732V239.312ZM139.644 237.219H196.111V236.347H139.644V237.219Z",
    fill: "#1A4784"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M571.268 239.716H631V234.657H571.268V239.716ZM629.356 237.623H572.889V236.751H629.356V237.623Z",
    fill: "#1A4784"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M198.573 241.841H140.524V237.626H198.573V241.841ZM142.176 240.262H196.918V239.202H142.176V240.262Z",
    fill: "#1A4784"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M570.427 242.245H628.476V238.03H570.427V242.245ZM626.824 240.666H572.082V239.605H626.824V240.666Z",
    fill: "#1A4784"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M199.415 247.743H143.889V240.155H199.415V247.743ZM145.569 245.802H197.751V242.096H145.569V245.802Z",
    fill: "#1A4784"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M569.585 248.147H625.111V240.559H569.585V248.147ZM623.431 246.206H571.249V242.5H623.431V246.206Z",
    fill: "#1A4784"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M163.386 355.305H152.483V344.578H163.386V355.305ZM154.334 353.45H161.535V346.43H154.334V353.45Z",
    fill: "#1A4784"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M605.614 355.709H616.517V344.982H605.614V355.709ZM614.666 353.854H607.465V346.834H614.666V353.854Z",
    fill: "#1A4784"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M163.386 340.013H152.483V319.356C152.483 317.907 153.057 316.517 154.079 315.493C155.102 314.468 156.489 313.892 157.934 313.892C159.38 313.892 160.767 314.468 161.79 315.493C162.812 316.517 163.386 317.907 163.386 319.356V340.013ZM154.334 338.157H161.535V319.366C161.535 318.41 161.155 317.492 160.48 316.815C159.805 316.139 158.889 315.759 157.934 315.759C156.98 315.759 156.064 316.139 155.389 316.815C154.714 317.492 154.334 318.41 154.334 319.366V338.157Z",
    fill: "#1A4784"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M605.614 340.416H616.517V319.759C616.517 318.31 615.943 316.92 614.921 315.896C613.898 314.871 612.511 314.296 611.066 314.296C609.62 314.296 608.233 314.871 607.21 315.896C606.188 316.92 605.614 318.31 605.614 319.759V340.416ZM614.666 338.56H607.465V319.77C607.465 318.813 607.845 317.895 608.52 317.219C609.195 316.542 610.111 316.162 611.066 316.162C612.02 316.162 612.936 316.542 613.611 317.219C614.286 317.895 614.666 318.813 614.666 319.77V338.56Z",
    fill: "#1A4784"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M180.041 355.305H169.14V344.578H180.041V355.305ZM170.988 353.45H178.189V346.43H170.988V353.45Z",
    fill: "#1A4784"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M588.959 355.709H599.86V344.982H588.959V355.709ZM598.012 353.854H590.811V346.834H598.012V353.854Z",
    fill: "#1A4784"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M180.041 340.013H169.14V319.356C169.122 318.627 169.249 317.901 169.515 317.223C169.78 316.544 170.179 315.925 170.686 315.403C171.194 314.881 171.802 314.466 172.472 314.182C173.142 313.899 173.863 313.753 174.59 313.753C175.318 313.753 176.038 313.899 176.709 314.182C177.379 314.466 177.986 314.881 178.494 315.403C179.002 315.925 179.401 316.544 179.666 317.223C179.932 317.901 180.059 318.627 180.041 319.356V340.013ZM170.988 338.157H178.189V319.366C178.189 318.41 177.81 317.492 177.134 316.815C176.459 316.139 175.544 315.759 174.589 315.759C173.634 315.759 172.718 316.139 172.043 316.815C171.368 317.492 170.988 318.41 170.988 319.366V338.157Z",
    fill: "#1A4784"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M588.959 340.416H599.86V319.759C599.878 319.03 599.751 318.305 599.485 317.626C599.22 316.947 598.821 316.328 598.314 315.806C597.806 315.284 597.199 314.869 596.528 314.586C595.858 314.302 595.137 314.156 594.41 314.156C593.682 314.156 592.962 314.302 592.291 314.586C591.621 314.869 591.014 315.284 590.506 315.806C589.998 316.328 589.599 316.947 589.334 317.626C589.068 318.305 588.941 319.03 588.959 319.759V340.416ZM598.012 338.561H590.811V319.77C590.811 318.813 591.19 317.896 591.866 317.219C592.541 316.542 593.457 316.162 594.411 316.162C595.366 316.162 596.282 316.542 596.957 317.219C597.632 317.896 598.012 318.813 598.012 319.77V338.561Z",
    fill: "#1A4784"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M196.698 355.305H185.795V344.578H196.698V355.305ZM187.646 353.45H194.847V346.43H187.646V353.45Z",
    fill: "#1A4784"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M572.302 355.709H583.205V344.982H572.302V355.709ZM581.354 353.854H574.153V346.834H581.354V353.854Z",
    fill: "#1A4784"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M196.698 340.013H185.795V319.356C185.795 317.907 186.369 316.517 187.391 315.493C188.414 314.468 189.8 313.892 191.246 313.892C192.692 313.892 194.079 314.468 195.101 315.493C196.124 316.517 196.698 317.907 196.698 319.356V340.013ZM187.646 338.157H194.847V319.366C194.847 318.893 194.753 318.423 194.573 317.986C194.392 317.548 194.126 317.15 193.792 316.815C193.458 316.48 193.061 316.215 192.624 316.033C192.187 315.852 191.719 315.759 191.246 315.759C190.774 315.759 190.305 315.852 189.869 316.033C189.432 316.215 189.035 316.48 188.701 316.815C188.366 317.15 188.101 317.548 187.92 317.986C187.739 318.423 187.646 318.893 187.646 319.366V338.157Z",
    fill: "#1A4784"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M572.302 340.416H583.205V319.759C583.205 318.31 582.631 316.92 581.609 315.896C580.586 314.871 579.2 314.296 577.754 314.296C576.308 314.296 574.921 314.871 573.899 315.896C572.876 316.92 572.302 318.31 572.302 319.759V340.416ZM581.354 338.56H574.153V319.77C574.153 319.296 574.247 318.827 574.427 318.389C574.608 317.951 574.874 317.554 575.208 317.219C575.542 316.884 575.939 316.618 576.376 316.437C576.813 316.255 577.281 316.162 577.754 316.162C578.226 316.162 578.695 316.255 579.131 316.437C579.568 316.618 579.965 316.884 580.299 317.219C580.634 317.554 580.899 317.951 581.08 318.389C581.261 318.827 581.354 319.296 581.354 319.77V338.56Z",
    fill: "#1A4784"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M163.386 297.656H152.483V276.999C152.483 275.55 153.057 274.16 154.079 273.136C155.102 272.111 156.489 271.535 157.934 271.535C159.38 271.535 160.767 272.111 161.79 273.136C162.812 274.16 163.386 275.55 163.386 276.999V297.656ZM154.334 295.8H161.535V277.013C161.535 276.539 161.442 276.07 161.261 275.632C161.08 275.195 160.815 274.797 160.48 274.462C160.146 274.127 159.749 273.861 159.312 273.68C158.875 273.499 158.407 273.405 157.934 273.405C157.462 273.405 156.994 273.499 156.557 273.68C156.12 273.861 155.723 274.127 155.389 274.462C155.054 274.797 154.789 275.195 154.608 275.632C154.427 276.07 154.334 276.539 154.334 277.013V295.8Z",
    fill: "#1A4784"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M605.614 298.059H616.517V277.402C616.517 275.953 615.943 274.563 614.921 273.539C613.898 272.514 612.511 271.939 611.066 271.939C609.62 271.939 608.233 272.514 607.21 273.539C606.188 274.563 605.614 275.953 605.614 277.402V298.059ZM614.666 296.203H607.465V277.416C607.465 276.943 607.558 276.473 607.739 276.036C607.92 275.598 608.185 275.2 608.52 274.865C608.854 274.53 609.251 274.264 609.688 274.083C610.125 273.902 610.593 273.809 611.066 273.809C611.538 273.809 612.006 273.902 612.443 274.083C612.88 274.264 613.277 274.53 613.611 274.865C613.946 275.2 614.211 275.598 614.392 276.036C614.573 276.473 614.666 276.943 614.666 277.416V296.203Z",
    fill: "#1A4784"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M180.041 297.655H169.14V276.998C169.122 276.269 169.249 275.544 169.515 274.865C169.78 274.186 170.179 273.567 170.686 273.045C171.194 272.523 171.802 272.108 172.472 271.825C173.142 271.541 173.863 271.396 174.59 271.396C175.318 271.396 176.038 271.541 176.709 271.825C177.379 272.108 177.986 272.523 178.494 273.045C179.002 273.567 179.401 274.186 179.666 274.865C179.932 275.544 180.059 276.269 180.041 276.998V297.655ZM170.988 295.8H178.189V277.013C178.189 276.056 177.81 275.138 177.134 274.461C176.459 273.785 175.544 273.405 174.589 273.405C173.634 273.405 172.718 273.785 172.043 274.461C171.368 275.138 170.988 276.056 170.988 277.013V295.8Z",
    fill: "#1A4784"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M588.959 298.059H599.86V277.402C599.878 276.673 599.751 275.948 599.485 275.269C599.22 274.59 598.821 273.971 598.314 273.449C597.806 272.927 597.199 272.512 596.528 272.228C595.858 271.945 595.137 271.799 594.41 271.799C593.682 271.799 592.962 271.945 592.291 272.228C591.621 272.512 591.014 272.927 590.506 273.449C589.998 273.971 589.599 274.59 589.334 275.269C589.068 275.948 588.941 276.673 588.959 277.402V298.059ZM598.012 296.203H590.811V277.416C590.811 276.459 591.19 275.542 591.866 274.865C592.541 274.188 593.457 273.808 594.411 273.808C595.366 273.808 596.282 274.188 596.957 274.865C597.632 275.542 598.012 276.459 598.012 277.416V296.203Z",
    fill: "#1A4784"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M196.698 297.656H185.795V276.999C185.795 275.55 186.369 274.16 187.391 273.136C188.414 272.111 189.8 271.535 191.246 271.535C192.692 271.535 194.079 272.111 195.101 273.136C196.124 274.16 196.698 275.55 196.698 276.999V297.656ZM187.646 295.8H194.847V277.013C194.847 276.539 194.753 276.07 194.573 275.632C194.392 275.195 194.126 274.797 193.792 274.462C193.458 274.127 193.061 273.861 192.624 273.68C192.187 273.499 191.719 273.405 191.246 273.405C190.774 273.405 190.305 273.499 189.869 273.68C189.432 273.861 189.035 274.127 188.701 274.462C188.366 274.797 188.101 275.195 187.92 275.632C187.739 276.07 187.646 276.539 187.646 277.013V295.8Z",
    fill: "#1A4784"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M572.302 298.059H583.205V277.402C583.205 275.953 582.631 274.563 581.609 273.539C580.586 272.514 579.2 271.939 577.754 271.939C576.308 271.939 574.921 272.514 573.899 273.539C572.876 274.563 572.302 275.953 572.302 277.402V298.059ZM581.354 296.203H574.153V277.416C574.153 276.943 574.247 276.473 574.427 276.036C574.608 275.598 574.874 275.2 575.208 274.865C575.542 274.53 575.939 274.264 576.376 274.083C576.813 273.902 577.281 273.809 577.754 273.809C578.226 273.809 578.695 273.902 579.131 274.083C579.568 274.264 579.965 274.53 580.299 274.865C580.634 275.2 580.899 275.598 581.08 276.036C581.261 276.473 581.354 276.943 581.354 277.416V296.203Z",
    fill: "#1A4784"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M163.386 265.819H152.483V253.535C152.483 252.086 153.057 250.697 154.079 249.672C155.102 248.648 156.489 248.072 157.934 248.072C159.38 248.072 160.767 248.648 161.79 249.672C162.812 250.697 163.386 252.086 163.386 253.535V265.819ZM154.334 263.964H161.535V253.535C161.535 253.062 161.442 252.592 161.261 252.155C161.08 251.717 160.815 251.319 160.48 250.984C160.146 250.649 159.749 250.384 159.312 250.202C158.875 250.021 158.407 249.928 157.934 249.928C157.462 249.928 156.994 250.021 156.557 250.202C156.12 250.384 155.723 250.649 155.389 250.984C155.054 251.319 154.789 251.717 154.608 252.155C154.427 252.592 154.334 253.062 154.334 253.535V263.964Z",
    fill: "#1A4784"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M605.614 266.223H616.517V253.939C616.517 252.49 615.943 251.1 614.921 250.076C613.898 249.051 612.511 248.476 611.066 248.476C609.62 248.476 608.233 249.051 607.21 250.076C606.188 251.1 605.614 252.49 605.614 253.939V266.223ZM614.666 264.367H607.465V253.939C607.465 253.465 607.558 252.996 607.739 252.558C607.92 252.121 608.185 251.723 608.52 251.388C608.854 251.053 609.251 250.787 609.688 250.606C610.125 250.424 610.593 250.331 611.066 250.331C611.538 250.331 612.006 250.424 612.443 250.606C612.88 250.787 613.277 251.053 613.611 251.388C613.946 251.723 614.211 252.121 614.392 252.558C614.573 252.996 614.666 253.465 614.666 253.939V264.367Z",
    fill: "#1A4784"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M180.041 265.819H169.14V253.535C169.122 252.806 169.249 252.081 169.515 251.402C169.78 250.723 170.179 250.104 170.686 249.582C171.194 249.06 171.802 248.645 172.472 248.362C173.142 248.078 173.863 247.932 174.59 247.932C175.318 247.932 176.038 248.078 176.709 248.362C177.379 248.645 177.986 249.06 178.494 249.582C179.002 250.104 179.401 250.723 179.666 251.402C179.932 252.081 180.059 252.806 180.041 253.535V265.819ZM170.988 263.963H178.189V253.535C178.189 252.578 177.81 251.661 177.134 250.984C176.459 250.308 175.544 249.927 174.589 249.927C173.634 249.927 172.718 250.308 172.043 250.984C171.368 251.661 170.988 252.578 170.988 253.535V263.963Z",
    fill: "#1A4784"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M588.959 266.222H599.86V253.939C599.878 253.21 599.751 252.484 599.485 251.805C599.22 251.126 598.821 250.508 598.314 249.986C597.806 249.463 597.199 249.048 596.528 248.765C595.858 248.482 595.137 248.336 594.41 248.336C593.682 248.336 592.962 248.482 592.291 248.765C591.621 249.048 591.014 249.463 590.506 249.986C589.998 250.508 589.599 251.126 589.334 251.805C589.068 252.484 588.941 253.21 588.959 253.939V266.222ZM598.012 264.367H590.811V253.939C590.811 252.982 591.19 252.064 591.866 251.387C592.541 250.711 593.457 250.331 594.411 250.331C595.366 250.331 596.282 250.711 596.957 251.387C597.632 252.064 598.012 252.982 598.012 253.939V264.367Z",
    fill: "#1A4784"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M196.698 265.819H185.795V253.535C185.795 252.086 186.369 250.697 187.391 249.672C188.414 248.648 189.8 248.072 191.246 248.072C192.692 248.072 194.079 248.648 195.101 249.672C196.124 250.697 196.698 252.086 196.698 253.535V265.819ZM187.646 263.964H194.847V253.535C194.847 253.062 194.753 252.592 194.573 252.155C194.392 251.717 194.126 251.319 193.792 250.984C193.458 250.649 193.061 250.384 192.624 250.202C192.187 250.021 191.719 249.928 191.246 249.928C190.774 249.928 190.305 250.021 189.869 250.202C189.432 250.384 189.035 250.649 188.701 250.984C188.366 251.319 188.101 251.717 187.92 252.155C187.739 252.592 187.646 253.062 187.646 253.535V263.964Z",
    fill: "#1A4784"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M572.302 266.223H583.205V253.939C583.205 252.49 582.631 251.1 581.609 250.076C580.586 249.051 579.2 248.476 577.754 248.476C576.308 248.476 574.921 249.051 573.899 250.076C572.876 251.1 572.302 252.49 572.302 253.939V266.223ZM581.354 264.367H574.153V253.939C574.153 253.465 574.247 252.996 574.427 252.558C574.608 252.121 574.874 251.723 575.208 251.388C575.542 251.053 575.939 250.787 576.376 250.606C576.813 250.424 577.281 250.331 577.754 250.331C578.226 250.331 578.695 250.424 579.131 250.606C579.568 250.787 579.965 251.053 580.299 251.388C580.634 251.723 580.899 252.121 581.08 252.558C581.261 252.996 581.354 253.465 581.354 253.939V264.367Z",
    fill: "#1A4784"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M162.462 278.993H153.41V280.848H162.462V278.993Z",
    fill: "#1A4784"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M606.538 279.396H615.59V281.252H606.538V279.396Z",
    fill: "#1A4784"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M140.724 353.099H627.368V355.828H140.724V353.099Z",
    fill: "#1A4784"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M158.862 272.476H157.011V296.73H158.862V272.476Z",
    fill: "#1A4784"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M610.138 272.879H611.989V297.133H610.138V272.879Z",
    fill: "#1A4784"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M179.117 278.993H170.064V280.848H179.117V278.993Z",
    fill: "#1A4784"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M589.883 279.396H598.936V281.252H589.883V279.396Z",
    fill: "#1A4784"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M175.516 272.476H173.665V296.73H175.516V272.476Z",
    fill: "#1A4784"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M593.484 272.879H595.335V297.133H593.484V272.879Z",
    fill: "#1A4784"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M145.572 241.842H143.889V300.013H145.572V241.842Z",
    fill: "#1A4784"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M623.428 242.245H625.111V300.417H623.428V242.245Z",
    fill: "#1A4784"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M145.263 303.058H143.448V354.919H145.263V303.058Z",
    fill: "#1A4784"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M623.737 303.462H625.552V355.322H623.737V303.462Z",
    fill: "#1A4784"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M195.771 278.993H186.719V280.848H195.771V278.993Z",
    fill: "#1A4784"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M573.229 279.396H582.281V281.252H573.229V279.396Z",
    fill: "#1A4784"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M244.202 245.214H232.424V246.9H244.202V245.214Z",
    fill: "#1A4784"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M524.798 245.617H536.576V247.303H524.798V245.617Z",
    fill: "#1A4784"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M245.134 307.649H231.516V309.335H245.134V307.649Z",
    fill: "#1A4784"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M523.866 308.052H537.484V309.739H523.866V308.052Z",
    fill: "#1A4784"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M244.202 241.842H232.424V243.528H244.202V241.842Z",
    fill: "#1A4784"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M524.798 242.245H536.576V243.931H524.798V242.245Z",
    fill: "#1A4784"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M245.134 304.277H231.516V305.963H245.134V304.277Z",
    fill: "#1A4784"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M523.866 304.68H537.484V306.367H523.866V304.68Z",
    fill: "#1A4784"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M244.003 237.626H232.225V239.312H244.003V237.626Z",
    fill: "#1A4784"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M524.997 238.03H536.775V239.716H524.997V238.03Z",
    fill: "#1A4784"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M244.202 234.254H232.424V235.94H244.202V234.254Z",
    fill: "#1A4784"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M524.798 234.657H536.576V236.344H524.798V234.657Z",
    fill: "#1A4784"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M243.319 296.689H232.424V298.375H243.319V296.689Z",
    fill: "#1A4784"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M525.681 297.093H536.576V298.779H525.681V297.093Z",
    fill: "#1A4784"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M244.202 237.626H232.424V239.312H244.202V237.626Z",
    fill: "#1A4784"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M524.798 238.03H536.576V239.716H524.798V238.03Z",
    fill: "#1A4784"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M245.134 300.061H231.516V301.747H245.134V300.061Z",
    fill: "#1A4784"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M523.866 300.465H537.484V302.151H523.866V300.465Z",
    fill: "#1A4784"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M221.504 245.214H209.726V246.9H221.504V245.214Z",
    fill: "#1A4784"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M547.496 245.617H559.274V247.303H547.496V245.617Z",
    fill: "#1A4784"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M222.436 307.649H208.818V309.335H222.436V307.649Z",
    fill: "#1A4784"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M546.564 308.052H560.182V309.739H546.564V308.052Z",
    fill: "#1A4784"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M221.504 241.842H209.726V243.528H221.504V241.842Z",
    fill: "#1A4784"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M547.496 242.245H559.274V243.931H547.496V242.245Z",
    fill: "#1A4784"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M222.436 304.277H208.818V305.963H222.436V304.277Z",
    fill: "#1A4784"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M546.564 304.68H560.182V306.367H546.564V304.68Z",
    fill: "#1A4784"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M221.504 237.626H209.726V239.312H221.504V237.626Z",
    fill: "#1A4784"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M547.496 238.03H559.274V239.716H547.496V238.03Z",
    fill: "#1A4784"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M222.436 300.061H208.818V301.747H222.436V300.061Z",
    fill: "#1A4784"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M546.564 300.465H560.182V302.151H546.564V300.465Z",
    fill: "#1A4784"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M221.504 234.254H209.726V235.94H221.504V234.254Z",
    fill: "#1A4784"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M547.496 234.657H559.274V236.344H547.496V234.657Z",
    fill: "#1A4784"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M220.621 296.689H209.726V298.375H220.621V296.689Z",
    fill: "#1A4784"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M548.379 297.093H559.274V298.779H548.379V297.093Z",
    fill: "#1A4784"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M265.992 245.214H254.214V246.9H265.992V245.214Z",
    fill: "#1A4784"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M503.008 245.617H514.786V247.303H503.008V245.617Z",
    fill: "#1A4784"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M266.924 307.649H253.306V309.335H266.924V307.649Z",
    fill: "#1A4784"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M502.076 308.052H515.694V309.739H502.076V308.052Z",
    fill: "#1A4784"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M322.308 244.829H276.004V246.648H322.308V244.829Z",
    fill: "#1A4784"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M364.98 252.107H342.282V253.927H364.98V252.107Z",
    fill: "#1A4784"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M364.98 299.418H342.282V301.238H364.98V299.418Z",
    fill: "#1A4784"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M395.849 252.107H373.151V253.927H395.849V252.107Z",
    fill: "#1A4784"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M395.849 299.418H373.151V301.238H395.849V299.418Z",
    fill: "#1A4784"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M426.718 252.107H404.02V253.927H426.718V252.107Z",
    fill: "#1A4784"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M426.718 299.418H404.02V301.238H426.718V299.418Z",
    fill: "#1A4784"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M446.692 245.232H492.996V247.052H446.692V245.232Z",
    fill: "#1A4784"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M265.992 241.842H254.214V243.528H265.992V241.842Z",
    fill: "#1A4784"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M503.008 242.245H514.786V243.931H503.008V242.245Z",
    fill: "#1A4784"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M266.924 304.277H253.306V305.963H266.924V304.277Z",
    fill: "#1A4784"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M502.076 304.68H515.694V306.367H502.076V304.68Z",
    fill: "#1A4784"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M322.308 241.189H276.004V243.009H322.308V241.189Z",
    fill: "#1A4784"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M364.98 248.468H342.282V250.288H364.98V248.468Z",
    fill: "#1A4784"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M364.98 295.779H342.282V297.599H364.98V295.779Z",
    fill: "#1A4784"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M395.849 248.468H373.151V250.288H395.849V248.468Z",
    fill: "#1A4784"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M395.849 295.779H373.151V297.599H395.849V295.779Z",
    fill: "#1A4784"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M426.718 248.468H404.02V250.288H426.718V248.468Z",
    fill: "#1A4784"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M426.718 295.779H404.02V297.599H426.718V295.779Z",
    fill: "#1A4784"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M446.692 241.593H492.996V243.412H446.692V241.593Z",
    fill: "#1A4784"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M266.718 237.626H254.94V239.312H266.718V237.626Z",
    fill: "#1A4784"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M502.282 238.03H514.06V239.716H502.282V238.03Z",
    fill: "#1A4784"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M265.992 234.254H254.214V235.94H265.992V234.254Z",
    fill: "#1A4784"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M503.008 234.657H514.786V236.344H503.008V234.657Z",
    fill: "#1A4784"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M265.109 296.689H254.214V298.375H265.109V296.689Z",
    fill: "#1A4784"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M503.891 297.093H514.786V298.779H503.891V297.093Z",
    fill: "#1A4784"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M322.308 233.911H276.004V235.73H322.308V233.911Z",
    fill: "#1A4784"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M361.348 241.189H345.913V243.009H361.348V241.189Z",
    fill: "#1A4784"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M392.217 241.189H376.783V243.009H392.217V241.189Z",
    fill: "#1A4784"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M423.087 241.189H407.652V243.009H423.087V241.189Z",
    fill: "#1A4784"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M446.692 234.314H492.996V236.134H446.692V234.314Z",
    fill: "#1A4784"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M265.992 237.626H254.214V239.312H265.992V237.626Z",
    fill: "#1A4784"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M503.008 238.03H514.786V239.716H503.008V238.03Z",
    fill: "#1A4784"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M266.924 300.061H253.306V301.747H266.924V300.061Z",
    fill: "#1A4784"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M502.076 300.465H515.694V302.151H502.076V300.465Z",
    fill: "#1A4784"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M322.308 237.55H276.004V239.37H322.308V237.55Z",
    fill: "#1A4784"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M363.164 244.829H345.006V246.648H363.164V244.829Z",
    fill: "#1A4784"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M394.033 244.829H375.875V246.648H394.033V244.829Z",
    fill: "#1A4784"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M424.902 244.829H406.744V246.648H424.902V244.829Z",
    fill: "#1A4784"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M446.692 237.954H492.996V239.773H446.692V237.954Z",
    fill: "#1A4784"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M192.17 272.476H190.319V296.73H192.17V272.476Z",
    fill: "#1A4784"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M576.83 272.879H578.681V297.133H576.83V272.879Z",
    fill: "#1A4784"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M242.488 292.302H233.308V262.742H242.488V292.302ZM235.16 290.45H240.637V264.576H235.149L235.16 290.45Z",
    fill: "#1A4784"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M526.512 292.706H535.692V263.146H526.512V292.706ZM533.84 290.854H528.363V264.98H533.851L533.84 290.854Z",
    fill: "#1A4784"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M242.488 342.929H233.308V313.369H242.488V342.929ZM235.16 341.077H240.637V315.214H235.149L235.16 341.077Z",
    fill: "#1A4784"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M526.512 343.333H535.692V313.772H526.512V343.333ZM533.84 341.481H528.363V315.617H533.851L533.84 341.481Z",
    fill: "#1A4784"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M242.488 260.373H233.308V251.334H242.488V260.373ZM235.149 258.521H240.626V253.179H235.149V258.521Z",
    fill: "#1A4784"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M526.512 260.777H535.692V251.738H526.512V260.777ZM533.851 258.925H528.374V253.583H533.851V258.925Z",
    fill: "#1A4784"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M242.488 355.306H233.308V346.267H242.488V355.306ZM235.149 353.45H240.626V348.108H235.149V353.45Z",
    fill: "#1A4784"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M526.512 355.709H535.692V346.67H526.512V355.709ZM533.851 353.854H528.374V348.511H533.851V353.854Z",
    fill: "#1A4784"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M264.875 292.302H255.695V262.742H264.875V292.302ZM257.547 290.45H263.023V264.576H257.54L257.547 290.45Z",
    fill: "#1A4784"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M504.125 292.706H513.305V263.146H504.125V292.706ZM511.453 290.854H505.977V264.98H511.46L511.453 290.854Z",
    fill: "#1A4784"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M264.875 342.929H255.695V313.369H264.875V342.929ZM257.547 341.077H263.023V315.214H257.54L257.547 341.077Z",
    fill: "#1A4784"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M504.125 343.333H513.305V313.772H504.125V343.333ZM511.453 341.481H505.977V315.617H511.46L511.453 341.481Z",
    fill: "#1A4784"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M264.875 260.373H255.695V251.334H264.875V260.373ZM257.54 258.521H263.016V253.179H257.54V258.521Z",
    fill: "#1A4784"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M504.125 260.777H513.305V251.738H504.125V260.777ZM511.46 258.925H505.984V253.583H511.46V258.925Z",
    fill: "#1A4784"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M264.875 355.306H255.695V346.267H264.875V355.306ZM257.54 353.45H263.016V348.108H257.54V353.45Z",
    fill: "#1A4784"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M504.125 355.709H513.305V346.67H504.125V355.709ZM511.46 353.854H505.984V348.511H511.46V353.854Z",
    fill: "#1A4784"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M220.098 292.302H210.921V262.742H220.098V292.302ZM212.773 290.45H218.25V264.576H212.759L212.773 290.45Z",
    fill: "#1A4784"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M548.902 292.706H558.079V263.146H548.902V292.706ZM556.227 290.854H550.75V264.98H556.241L556.227 290.854Z",
    fill: "#1A4784"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M220.098 342.929H210.921V313.369H220.098V342.929ZM212.773 341.077H218.25V315.214H212.759L212.773 341.077Z",
    fill: "#1A4784"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M548.902 343.333H558.079V313.772H548.902V343.333ZM556.227 341.481H550.75V315.617H556.241L556.227 341.481Z",
    fill: "#1A4784"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M220.098 260.373H210.921V251.334H220.098V260.373ZM212.759 258.521H218.236V253.179H212.759V258.521Z",
    fill: "#1A4784"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M548.902 260.777H558.079V251.738H548.902V260.777ZM556.241 258.925H550.764V253.583H556.241V258.925Z",
    fill: "#1A4784"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M220.098 355.306H210.921V346.267H220.098V355.306ZM212.759 353.45H218.236V348.108H212.759V353.45Z",
    fill: "#1A4784"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M548.902 355.709H558.079V346.67H548.902V355.709ZM556.241 353.854H550.764V348.511H556.241V353.854Z",
    fill: "#1A4784"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M208.611 293.624H200.675L201.514 256.819H207.783L208.611 293.624ZM202.569 291.768H206.717L205.964 258.671H203.312L202.569 291.768Z",
    fill: "#1A4784"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M560.389 294.027H568.325L567.486 257.223H561.217L560.389 294.027ZM566.431 292.172H562.283L563.037 259.075H565.688L566.431 292.172Z",
    fill: "#1A4784"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M210.047 297.424H199.229V291.768H210.047V297.424ZM201.08 295.572H208.188V293.624H201.08V295.572Z",
    fill: "#1A4784"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M558.953 297.828H569.771V292.172H558.953V297.828ZM567.92 295.976H560.812V294.027H567.92V295.976Z",
    fill: "#1A4784"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M209.109 258.671H200.167V253.628H209.109V258.671ZM202.001 256.819H207.239V255.483H202.019L202.001 256.819Z",
    fill: "#1A4784"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M559.891 259.075H568.833V254.032H559.891V259.075ZM566.999 257.223H561.761V255.887H566.981L566.999 257.223Z",
    fill: "#1A4784"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M210.147 255.483H199.129V249.92H210.147V255.483ZM200.981 253.628H208.295V251.772H200.981V253.628Z",
    fill: "#1A4784"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M558.853 255.887H569.871V250.324H558.853V255.887ZM568.019 254.032H560.705V252.176H568.019V254.032Z",
    fill: "#1A4784"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M210.04 251.772H199.232V244.988H210.04V251.772ZM201.084 249.92H208.192V246.847H201.084V249.92Z",
    fill: "#1A4784"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M558.96 252.176H569.768V245.391H558.96V252.176ZM567.916 250.324H560.808V247.25H567.916V250.324Z",
    fill: "#1A4784"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M211.359 246.847H197.917V241.341H211.359V246.847ZM199.765 244.988H209.507V243.207H199.765V244.988Z",
    fill: "#1A4784"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M557.641 247.25H571.083V241.744H557.641V247.25ZM569.235 245.391H559.493V243.61H569.235V245.391Z",
    fill: "#1A4784"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M212.094 243.207H197.167V237.013H212.094V243.207ZM199.033 241.351H210.243V238.88H199.033V241.351Z",
    fill: "#1A4784"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M556.906 243.61H571.833V237.417H556.906V243.61ZM569.967 241.755H558.757V239.283H569.967V241.755Z",
    fill: "#1A4784"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M212.986 238.869H196.282V233.883H212.986V238.869ZM198.141 237.013H211.135V235.727H198.141V237.013Z",
    fill: "#1A4784"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M556.014 239.272H572.718V234.286H556.014V239.272ZM570.859 237.417H557.865V236.131H570.859V237.417Z",
    fill: "#1A4784"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M208.608 351.246H200.675L201.514 312.09H207.783L208.608 351.246ZM202.566 349.394H206.717L205.96 313.942H203.316L202.566 349.394Z",
    fill: "#1A4784"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M560.392 351.649H568.325L567.486 312.494H561.217L560.392 351.649ZM566.434 349.797H562.283L563.04 314.346H565.684L566.434 349.797Z",
    fill: "#1A4784"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M210.047 355.306H199.229V349.394H210.047V355.306ZM201.08 353.45H208.188V351.246H201.08V353.45Z",
    fill: "#1A4784"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M558.953 355.709H569.771V349.797H558.953V355.709ZM567.92 353.854H560.812V351.649H567.92V353.854Z",
    fill: "#1A4784"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M209.109 313.942H200.167V308.685H209.109V313.942ZM202.001 312.09H207.239V310.537H202.019L202.001 312.09Z",
    fill: "#1A4784"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M559.891 314.346H568.833V309.089H559.891V314.346ZM566.999 312.494H561.761V310.941H566.981L566.999 312.494Z",
    fill: "#1A4784"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M210.147 310.537H199.129V304.725H210.147V310.537ZM200.981 308.685H208.295V306.58H200.981V308.685Z",
    fill: "#1A4784"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M558.853 310.941H569.871V305.128H558.853V310.941ZM568.019 309.089H560.705V306.984H568.019V309.089Z",
    fill: "#1A4784"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M210.04 306.58H199.232V299.457H210.04V306.58ZM201.084 304.725H208.192V301.32H201.084V304.725Z",
    fill: "#1A4784"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M558.96 306.984H569.768V299.861H558.96V306.984ZM567.916 305.128H560.808V301.724H567.916V305.128Z",
    fill: "#1A4784"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M211.359 301.32H197.917V295.561H211.359V301.32ZM199.765 299.468H209.507V297.424H199.765V299.468Z",
    fill: "#1A4784"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M557.641 301.724H571.083V295.965H557.641V301.724ZM569.235 299.872H559.493V297.828H569.235V299.872Z",
    fill: "#1A4784"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M230.785 293.624H222.838L223.677 256.819H229.946L230.785 293.624ZM224.743 291.768H228.901L228.148 258.671H225.497L224.743 291.768Z",
    fill: "#1A4784"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M538.215 294.027H546.162L545.323 257.223H539.054L538.215 294.027ZM544.257 292.172H540.099L540.852 259.075H543.503L544.257 292.172Z",
    fill: "#1A4784"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M232.221 297.424H221.402V291.768H232.221V297.424ZM223.254 295.572H230.362V293.624H223.254V295.572Z",
    fill: "#1A4784"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M536.779 297.828H547.598V292.172H536.779V297.828ZM545.746 295.976H538.638V294.027H545.746V295.976Z",
    fill: "#1A4784"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M231.282 258.671H222.355V253.628H231.297L231.282 258.671ZM224.192 256.819H229.431V255.483H224.192V256.819Z",
    fill: "#1A4784"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M537.718 259.075H546.645V254.032H537.703L537.718 259.075ZM544.808 257.223H539.569V255.887H544.808V257.223Z",
    fill: "#1A4784"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M232.306 255.483H221.289V249.92H232.306V255.483ZM223.14 253.628H230.454V251.772H223.154L223.14 253.628Z",
    fill: "#1A4784"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M536.694 255.887H547.711V250.324H536.694V255.887ZM545.86 254.032H538.546V252.176H545.846L545.86 254.032Z",
    fill: "#1A4784"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M232.214 251.772H221.406V244.988H232.214V251.772ZM223.258 249.92H230.366V246.847H223.258V249.92Z",
    fill: "#1A4784"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M536.786 252.176H547.594V245.391H536.786V252.176ZM545.742 250.324H538.634V247.25H545.742V250.324Z",
    fill: "#1A4784"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M233.532 246.847H220.091V241.341H233.532V246.847ZM221.939 244.988H231.681V243.207H221.939V244.988Z",
    fill: "#1A4784"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M535.468 247.25H548.909V241.744H535.468V247.25ZM547.061 245.391H537.319V243.61H547.061V245.391Z",
    fill: "#1A4784"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M234.268 243.207H219.341V237.013H234.268V243.207ZM221.207 241.351H232.416V238.88H221.207V241.351Z",
    fill: "#1A4784"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M534.732 243.61H549.659V237.417H534.732V243.61ZM547.793 241.755H536.584V239.283H547.793V241.755Z",
    fill: "#1A4784"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M235.149 238.869H218.445V233.883H235.149V238.869ZM220.304 237.013H233.298V235.727H220.315L220.304 237.013Z",
    fill: "#1A4784"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M533.851 239.272H550.555V234.286H533.851V239.272ZM548.696 237.417H535.702V236.131H548.685L548.696 237.417Z",
    fill: "#1A4784"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M230.785 351.246H222.838L223.677 312.09H229.946L230.785 351.246ZM224.743 349.394H228.894L228.134 313.942H225.489L224.743 349.394Z",
    fill: "#1A4784"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M538.215 351.649H546.162L545.323 312.494H539.054L538.215 351.649ZM544.257 349.797H540.106L540.866 314.346H543.511L544.257 349.797Z",
    fill: "#1A4784"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M232.221 355.306H221.402V349.394H232.221V355.306ZM223.254 353.45H230.362V351.246H223.254V353.45Z",
    fill: "#1A4784"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M536.779 355.709H547.598V349.797H536.779V355.709ZM545.746 353.854H538.638V351.649H545.746V353.854Z",
    fill: "#1A4784"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M231.282 313.942H222.355V308.685H231.297L231.282 313.942ZM224.192 312.09H229.431V310.537H224.192V312.09Z",
    fill: "#1A4784"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M537.718 314.346H546.645V309.089H537.703L537.718 314.346ZM544.808 312.494H539.569V310.941H544.808V312.494Z",
    fill: "#1A4784"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M232.306 310.537H221.289V304.725H232.306V310.537ZM223.14 308.685H230.454V306.58H223.154L223.14 308.685Z",
    fill: "#1A4784"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M536.694 310.941H547.711V305.128H536.694V310.941ZM545.86 309.089H538.546V306.984H545.846L545.86 309.089Z",
    fill: "#1A4784"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M232.214 306.58H221.406V299.457H232.214V306.58ZM223.258 304.725H230.366V301.32H223.258V304.725Z",
    fill: "#1A4784"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M536.786 306.984H547.594V299.861H536.786V306.984ZM545.742 305.128H538.634V301.724H545.742V305.128Z",
    fill: "#1A4784"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M233.532 301.32H220.091V295.561H233.532V301.32ZM221.939 299.468H231.681V297.424H221.939V299.468Z",
    fill: "#1A4784"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M535.468 301.724H548.909V295.965H535.468V301.724ZM547.061 299.872H537.319V297.828H547.061V299.872Z",
    fill: "#1A4784"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M252.958 293.624H245.012L245.85 256.819H252.12L252.958 293.624ZM246.917 291.768H251.075L250.321 258.671H247.659L246.917 291.768Z",
    fill: "#1A4784"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M516.042 294.027H523.988L523.15 257.223H516.88L516.042 294.027ZM522.083 292.172H517.925L518.679 259.075H521.341L522.083 292.172Z",
    fill: "#1A4784"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M254.394 297.424H243.576V291.768H254.394V297.424ZM245.427 295.572H252.535V293.624H245.427V295.572Z",
    fill: "#1A4784"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M514.606 297.828H525.424V292.172H514.606V297.828ZM523.573 295.976H516.465V294.027H523.573V295.976Z",
    fill: "#1A4784"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M253.456 258.671H244.514V253.628H253.456V258.671ZM246.366 256.819H251.604V255.483H246.366V256.819Z",
    fill: "#1A4784"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M515.544 259.075H524.486V254.032H515.544V259.075ZM522.634 257.223H517.396V255.887H522.634V257.223Z",
    fill: "#1A4784"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M254.494 255.483H243.476V249.92H254.494V255.483ZM245.328 253.628H252.642V251.772H245.328V253.628Z",
    fill: "#1A4784"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M514.506 255.887H525.524V250.324H514.506V255.887ZM523.672 254.032H516.358V252.176H523.672V254.032Z",
    fill: "#1A4784"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M254.387 251.772H243.579V244.988H254.387V251.772ZM245.431 249.92H252.539V246.847H245.431V249.92Z",
    fill: "#1A4784"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M514.613 252.176H525.421V245.391H514.613V252.176ZM523.569 250.324H516.461V247.25H523.569V250.324Z",
    fill: "#1A4784"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M255.706 246.847H242.257V241.341H255.699L255.706 246.847ZM244.112 244.988H253.854V243.207H244.112V244.988Z",
    fill: "#1A4784"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M513.294 247.25H526.743V241.744H513.301L513.294 247.25ZM524.888 245.391H515.146V243.61H524.888V245.391Z",
    fill: "#1A4784"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M256.441 243.207H241.547V237.013H256.473L256.441 243.207ZM243.38 241.351H254.59V238.88H243.38V241.351Z",
    fill: "#1A4784"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M512.559 243.61H527.453V237.417H512.527L512.559 243.61ZM525.62 241.755H514.41V239.283H525.62V241.755Z",
    fill: "#1A4784"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M257.333 238.869H240.63V233.883H257.333V238.869ZM242.488 237.013H255.482V235.727H242.488V237.013Z",
    fill: "#1A4784"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M511.667 239.272H528.37V234.286H511.667V239.272ZM526.512 237.417H513.518V236.131H526.512V237.417Z",
    fill: "#1A4784"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M252.958 351.246H245.012L245.85 312.09H252.12L252.958 351.246ZM246.917 349.394H251.082L250.321 313.942H247.659L246.917 349.394Z",
    fill: "#1A4784"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M516.042 351.649H523.988L523.15 312.494H516.88L516.042 351.649ZM522.083 349.797H517.918L518.679 314.346H521.341L522.083 349.797Z",
    fill: "#1A4784"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M254.394 355.306H243.576V349.394H254.394V355.306ZM245.427 353.45H252.535V351.246H245.427V353.45Z",
    fill: "#1A4784"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M514.606 355.709H525.424V349.797H514.606V355.709ZM523.573 353.854H516.465V351.649H523.573V353.854Z",
    fill: "#1A4784"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M253.456 313.942H244.514V308.685H253.456V313.942ZM246.366 312.09H251.604V310.537H246.366V312.09Z",
    fill: "#1A4784"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M515.544 314.346H524.486V309.089H515.544V314.346ZM522.634 312.494H517.396V310.941H522.634V312.494Z",
    fill: "#1A4784"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M254.494 310.537H243.476V304.725H254.494V310.537ZM245.328 308.685H252.642V306.58H245.328V308.685Z",
    fill: "#1A4784"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M514.506 310.941H525.524V305.128H514.506V310.941ZM523.672 309.089H516.358V306.984H523.672V309.089Z",
    fill: "#1A4784"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M254.387 306.58H243.579V299.457H254.387V306.58ZM245.431 304.725H252.539V301.32H245.431V304.725Z",
    fill: "#1A4784"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M514.613 306.984H525.421V299.861H514.613V306.984ZM523.569 305.128H516.461V301.724H523.569V305.128Z",
    fill: "#1A4784"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M255.706 301.32H242.257V295.561H255.699L255.706 301.32ZM244.112 299.468H253.854V297.424H244.112V299.468Z",
    fill: "#1A4784"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M513.294 301.724H526.743V295.965H513.301L513.294 301.724ZM524.888 299.872H515.146V297.828H524.888V299.872Z",
    fill: "#1A4784"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M275.132 293.624H267.185L268.024 256.819H274.293L275.132 293.624ZM269.09 291.768H273.248L272.495 258.671H269.844L269.09 291.768Z",
    fill: "#1A4784"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M493.868 294.027H501.815L500.976 257.223H494.707L493.868 294.027ZM499.91 292.172H495.752L496.505 259.075H499.156L499.91 292.172Z",
    fill: "#1A4784"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M276.568 297.424H265.749V291.768H276.568V297.424ZM267.601 295.572H274.709V293.624H267.601V295.572Z",
    fill: "#1A4784"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M492.432 297.828H503.251V292.172H492.432V297.828ZM501.399 295.976H494.291V294.027H501.399V295.976Z",
    fill: "#1A4784"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M275.63 258.671H266.688V253.628H275.63V258.671ZM268.557 256.819H273.796V255.483H268.557V256.819Z",
    fill: "#1A4784"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M493.37 259.075H502.312V254.032H493.37V259.075ZM500.443 257.223H495.204V255.887H500.443V257.223Z",
    fill: "#1A4784"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M276.667 255.483H265.65V249.92H276.667V255.483ZM267.491 253.628H274.805V251.772H267.491V253.628Z",
    fill: "#1A4784"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M492.333 255.887H503.35V250.324H492.333V255.887ZM501.509 254.032H494.195V252.176H501.509V254.032Z",
    fill: "#1A4784"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M276.561 251.772H265.753V244.988H276.561V251.772ZM267.605 249.92H274.713V246.847H267.605V249.92Z",
    fill: "#1A4784"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M492.439 252.176H503.247V245.391H492.439V252.176ZM501.395 250.324H494.287V247.25H501.395V250.324Z",
    fill: "#1A4784"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M277.879 246.847H264.438V241.341H277.879V246.847ZM266.286 244.988H276.02V243.207H266.286V244.988Z",
    fill: "#1A4784"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M491.121 247.25H504.562V241.744H491.121V247.25ZM502.714 245.391H492.98V243.61H502.714V245.391Z",
    fill: "#1A4784"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M278.615 243.207H263.688V237.013H278.615V243.207ZM265.554 241.351H276.763V238.88H265.554V241.351Z",
    fill: "#1A4784"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M490.385 243.61H505.312V237.417H490.385V243.61ZM503.446 241.755H492.237V239.283H503.446V241.755Z",
    fill: "#1A4784"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M279.507 238.869H262.803V233.883H279.507V238.869ZM264.648 237.013H277.655V235.727H264.648V237.013Z",
    fill: "#1A4784"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M489.493 239.272H506.197V234.286H489.493V239.272ZM504.352 237.417H491.345V236.131H504.352V237.417Z",
    fill: "#1A4784"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M275.132 351.246H267.185L268.024 312.09H274.293L275.132 351.246ZM269.09 349.394H273.255L272.466 313.942H269.836L269.09 349.394Z",
    fill: "#1A4784"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M493.868 351.649H501.815L500.976 312.494H494.707L493.868 351.649ZM499.91 349.797H495.745L496.534 314.346H499.164L499.91 349.797Z",
    fill: "#1A4784"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M276.568 355.306H265.749V349.394H276.568V355.306ZM267.601 353.45H274.709V351.246H267.601V353.45Z",
    fill: "#1A4784"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M492.432 355.709H503.251V349.797H492.432V355.709ZM501.399 353.854H494.291V351.649H501.399V353.854Z",
    fill: "#1A4784"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M275.63 313.942H266.688V308.685H275.63V313.942ZM268.539 312.09H273.778V310.537H268.557L268.539 312.09Z",
    fill: "#1A4784"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M493.37 314.346H502.312V309.089H493.37V314.346ZM500.461 312.494H495.222V310.941H500.443L500.461 312.494Z",
    fill: "#1A4784"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M276.667 310.537H265.65V304.725H276.667V310.537ZM267.502 308.685H274.816V306.58H267.491L267.502 308.685Z",
    fill: "#1A4784"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M492.333 310.941H503.35V305.128H492.333V310.941ZM501.498 309.089H494.184V306.984H501.509L501.498 309.089Z",
    fill: "#1A4784"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M276.561 306.58H265.753V299.457H276.561V306.58ZM267.605 304.725H274.713V301.32H267.605V304.725Z",
    fill: "#1A4784"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M492.439 306.984H503.247V299.861H492.439V306.984ZM501.395 305.128H494.287V301.724H501.395V305.128Z",
    fill: "#1A4784"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M277.879 301.32H264.438V295.561H277.879V301.32ZM266.286 299.468H276.02V297.424H266.286V299.468Z",
    fill: "#1A4784"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M491.121 301.724H504.562V295.965H491.121V301.724ZM502.714 299.872H492.98V297.828H502.714V299.872Z",
    fill: "#1A4784"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M391.338 205.724L384.248 202.995L377.157 205.724V190.075H391.338V205.724ZM379.009 203.868L384.248 201.139L389.486 203.868V191.93H379.009V203.868Z",
    fill: "#1A4784"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M388.164 191.93H380.345V180.23H388.164V191.93ZM382.179 190.075H386.316V182.082H382.179V190.075Z",
    fill: "#1A4784"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M394.941 230.271H373.151V222.993H394.941V230.271ZM374.405 228.482H393.687V224.782H374.405V228.482Z",
    fill: "#1A4784"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M394.941 239.37H373.151V228.452H394.941V239.37ZM374.405 237.522H393.687V230.3H374.405V237.522Z",
    fill: "#1A4784"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M364.98 228.452H332.295V222.993H364.98V228.452ZM333.669 226.828H363.594V224.62H333.669V226.828Z",
    fill: "#1A4784"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M404.02 228.855H436.705V223.396H404.02V228.855ZM435.331 227.231H405.406V225.023H435.331V227.231Z",
    fill: "#1A4784"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M364.98 239.37H333.203V226.632H364.98V239.37ZM334.539 237.468H363.633V228.53H334.539V237.468Z",
    fill: "#1A4784"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M404.02 239.773H435.797V227.035H404.02V239.773ZM434.461 237.872H405.367V228.933H434.461V237.872Z",
    fill: "#1A4784"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M334.09 227.889H332.238V238.466H334.09V227.889Z",
    fill: "#1A4784"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M434.91 228.292H436.762V238.87H434.91V228.292Z",
    fill: "#1A4784"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M338.116 227.889H336.265V238.466H338.116V227.889Z",
    fill: "#1A4784"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M430.884 228.292H432.735V238.87H430.884V228.292Z",
    fill: "#1A4784"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M342.143 227.889H340.291V238.466H342.143V227.889Z",
    fill: "#1A4784"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M426.857 228.292H428.709V238.87H426.857V228.292Z",
    fill: "#1A4784"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M346.17 227.889H344.318V238.466H346.17V227.889Z",
    fill: "#1A4784"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M422.83 228.292H424.682V238.87H422.83V228.292Z",
    fill: "#1A4784"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M350.196 227.889H348.345V238.466H350.196V227.889Z",
    fill: "#1A4784"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M418.804 228.292H420.655V238.87H418.804V228.292Z",
    fill: "#1A4784"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M354.223 227.889H352.372V238.466H354.223V227.889Z",
    fill: "#1A4784"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M414.777 228.292H416.628V238.87H414.777V228.292Z",
    fill: "#1A4784"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M358.25 227.889H356.398V238.466H358.25V227.889Z",
    fill: "#1A4784"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M410.75 228.292H412.602V238.87H410.75V228.292Z",
    fill: "#1A4784"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M362.28 227.889H360.429V238.466H362.28V227.889Z",
    fill: "#1A4784"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M406.72 228.292H408.572V238.87H406.72V228.292Z",
    fill: "#1A4784"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M366.307 227.889H364.455V238.466H366.307V227.889Z",
    fill: "#1A4784"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M402.693 228.292H404.545V238.87H402.693V228.292Z",
    fill: "#1A4784"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M351.135 355.306H331.136V314.594C331.31 308.992 335.703 304.622 341.137 304.622C346.571 304.622 350.961 308.988 351.135 314.562V355.306ZM332.988 353.45H349.283V314.594C349.251 312.444 348.381 310.391 346.858 308.875C345.336 307.359 343.283 306.5 341.137 306.481C336.709 306.481 333.127 310.042 332.988 314.622V353.45Z",
    fill: "#1A4784"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M417.865 355.709H437.864V314.997C437.69 309.395 433.297 305.025 427.863 305.025C422.429 305.025 418.039 309.391 417.865 314.965V355.709ZM436.012 353.853H419.717V314.997C419.749 312.847 420.619 310.795 422.142 309.279C423.664 307.763 425.717 306.903 427.863 306.884C432.291 306.884 435.873 310.446 436.012 315.026V353.853Z",
    fill: "#1A4784"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M331.897 351.502H323.95L324.789 314.701H331.058L331.897 351.502ZM325.855 349.65H330.013L329.26 316.553H326.608L325.855 349.65Z",
    fill: "#1A4784"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M437.103 351.905H445.05L444.211 315.104H437.942L437.103 351.905ZM443.145 350.053H438.987L439.74 316.956H442.392L443.145 350.053Z",
    fill: "#1A4784"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M333.333 355.306H322.514V349.65H333.333V355.306ZM324.355 353.45H331.463V351.502H324.355V353.45Z",
    fill: "#1A4784"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M435.667 355.709H446.486V350.053H435.667V355.709ZM444.645 353.854H437.537V351.905H444.645V353.854Z",
    fill: "#1A4784"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M332.394 316.553H323.453V311.51H332.394V316.553ZM325.286 314.701H330.525V313.369H325.304L325.286 314.701Z",
    fill: "#1A4784"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M436.606 316.957H445.547V311.914H436.606V316.957ZM443.714 315.105H438.475V313.773H443.696L443.714 315.105Z",
    fill: "#1A4784"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M333.432 313.369H322.415V307.805H333.432V313.369ZM324.266 311.513H331.581V309.657H324.266V311.513Z",
    fill: "#1A4784"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M435.568 313.772H446.585V308.209H435.568V313.772ZM444.734 311.917H437.419V310.061H444.734V311.917Z",
    fill: "#1A4784"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M331.918 309.654H323.929V302.887H331.918V309.654ZM325.78 307.802H330.067V304.729H325.777L325.78 307.802Z",
    fill: "#1A4784"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M437.082 310.058H445.071V303.291H437.082V310.058ZM443.22 308.206H438.933V305.132H443.223L443.22 308.206Z",
    fill: "#1A4784"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M332.821 304.729H323.026V299.222H332.821V304.729ZM324.878 302.873H330.969V301.092H324.878V302.873Z",
    fill: "#1A4784"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M436.179 305.132H445.974V299.626H436.179V305.132ZM444.122 303.277H438.031V301.496H444.122V303.277Z",
    fill: "#1A4784"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M403.965 355.306H364.516V318.565C364.871 308.728 373.522 301.05 384.237 301.05C394.952 301.05 403.628 308.739 403.965 318.533V355.306ZM366.374 353.45H402.117V318.547C401.812 309.779 393.961 302.877 384.248 302.877C374.534 302.877 366.684 309.768 366.374 318.569V353.45Z",
    fill: "#1A4784"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M400.688 355.306H367.807V321.012C368.091 311.809 375.313 304.629 384.247 304.629C393.182 304.629 400.404 311.813 400.685 320.987L400.688 355.306ZM369.658 353.45H398.837V321.012C398.584 312.874 392.177 306.481 384.247 306.481C376.318 306.481 369.911 312.874 369.676 321.04L369.658 353.45Z",
    fill: "#1A4784"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M371.009 355.306H360.19V349.65H371.009V355.306ZM362.028 353.45H369.136V351.502H362.028V353.45Z",
    fill: "#1A4784"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M397.991 355.709H408.81V350.053H397.991V355.709ZM406.972 353.854H399.864V351.905H406.972V353.854Z",
    fill: "#1A4784"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M357.329 351.502H349.383L350.225 314.701H356.491L357.329 351.502ZM351.288 349.65H355.446L354.692 316.553H352.041L351.288 349.65Z",
    fill: "#1A4784"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M411.671 351.905H419.617L418.775 315.104H412.509L411.671 351.905ZM417.712 350.053H413.554L414.308 316.956H416.959L417.712 350.053Z",
    fill: "#1A4784"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M358.765 355.306H347.947V349.65H358.765V355.306ZM349.798 353.45H356.907V351.502H349.798V353.45Z",
    fill: "#1A4784"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M410.235 355.709H421.053V350.053H410.235V355.709ZM419.202 353.854H412.093V351.905H419.202V353.854Z",
    fill: "#1A4784"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M357.827 316.553H348.878V311.51H357.82L357.827 316.553ZM350.737 314.701H355.986V313.369H350.737V314.701Z",
    fill: "#1A4784"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M411.173 316.957H420.122V311.914H411.18L411.173 316.957ZM418.263 315.105H413.014V313.773H418.263V315.105Z",
    fill: "#1A4784"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M358.865 313.369H347.847V307.805H358.865V313.369ZM349.699 311.513H357.017V309.657H349.699V311.513Z",
    fill: "#1A4784"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M410.135 313.772H421.153V308.209H410.135V313.772ZM419.301 311.917H411.983V310.061H419.301V311.917Z",
    fill: "#1A4784"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M366.399 351.502H358.453L359.291 314.701H365.557L366.399 351.502ZM360.357 349.65H364.516L363.759 316.553H361.111L360.357 349.65Z",
    fill: "#1A4784"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M402.601 351.905H410.547L409.709 315.104H403.443L402.601 351.905ZM408.643 350.053H404.484L405.241 316.956H407.889L408.643 350.053Z",
    fill: "#1A4784"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M367.835 355.306H357.017V349.65H367.835V355.306ZM358.865 353.45H365.973V351.502H358.865V353.45Z",
    fill: "#1A4784"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M401.165 355.709H411.983V350.053H401.165V355.709ZM410.135 353.854H403.027V351.905H410.135V353.854Z",
    fill: "#1A4784"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M366.893 316.553H357.955V311.51H366.893V316.553ZM359.785 314.701H365.028V313.369H359.803L359.785 314.701Z",
    fill: "#1A4784"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M402.107 316.957H411.045V311.914H402.107V316.957ZM409.215 315.105H403.972V313.773H409.197L409.215 315.105Z",
    fill: "#1A4784"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M367.935 313.369H356.917V307.805H367.935V313.369ZM358.765 311.513H366.083V309.657H358.765V311.513Z",
    fill: "#1A4784"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M401.065 313.772H412.083V308.209H401.065V313.772ZM410.235 311.917H402.917V310.061H410.235V311.917Z",
    fill: "#1A4784"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M367.085 309.654H348.697V302.887H367.085V309.654ZM350.548 307.802H365.226V304.729H350.548V307.802Z",
    fill: "#1A4784"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M401.915 310.058H420.303V303.291H401.915V310.058ZM418.452 308.206H403.774V305.132H418.452V308.206Z",
    fill: "#1A4784"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M369.516 304.729H346.262V299.222H369.516V304.729ZM348.114 302.873H367.661V301.092H348.114V302.873Z",
    fill: "#1A4784"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M399.484 305.132H422.738V299.626H399.484V305.132ZM420.886 303.277H401.339V301.496H420.886V303.277Z",
    fill: "#1A4784"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M383.928 355.305H371.489V323.825L373.156 326.069C373.184 326.105 375.789 329.602 377.307 330.909C377.662 330.888 378.568 329.812 379.116 329.167C380.129 327.967 381.28 326.61 382.67 326.112L383.907 325.667L383.928 355.305ZM373.358 353.45H382.076V328.683C381.533 329.213 381.02 329.773 380.541 330.361C379.446 331.653 378.497 332.772 377.321 332.772C376.878 332.768 376.451 332.604 376.12 332.309C375.124 331.379 374.201 330.374 373.358 329.303V353.45Z",
    fill: "#1A4784"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M385.072 355.709H397.511V324.229L395.844 326.473C395.816 326.508 393.211 330.006 391.693 331.313C391.338 331.291 390.432 330.216 389.884 329.571C388.871 328.371 387.72 327.014 386.33 326.516L385.093 326.07L385.072 355.709ZM395.642 353.854H386.924V329.087C387.467 329.616 387.98 330.176 388.459 330.764C389.554 332.057 390.503 333.176 391.679 333.176C392.122 333.172 392.549 333.008 392.88 332.713C393.876 331.782 394.799 330.777 395.642 329.707V353.854Z",
    fill: "#1A4784"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M332.992 297.274H325.045L325.887 260.47H332.153L332.992 297.274ZM326.95 295.419H331.108L330.354 262.325H327.703L326.95 295.419Z",
    fill: "#1A4784"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M436.009 297.678H443.955L443.113 260.873H436.847L436.009 297.678ZM442.05 295.822H437.892L438.646 262.729H441.297L442.05 295.822Z",
    fill: "#1A4784"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M334.427 301.078H323.609V295.418H334.427V301.078ZM325.46 299.222H332.568V297.274H325.46V299.222Z",
    fill: "#1A4784"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M434.573 301.481H445.391V295.822H434.573V301.481ZM443.54 299.626H436.432V297.678H443.54V299.626Z",
    fill: "#1A4784"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M333.489 262.325H324.547V257.282H333.489V262.325ZM326.381 260.47H331.62V259.138H326.399L326.381 260.47Z",
    fill: "#1A4784"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M435.511 262.729H444.453V257.686H435.511V262.729ZM442.619 260.873H437.38V259.541H442.601L442.619 260.873Z",
    fill: "#1A4784"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M334.527 259.137H323.509V253.571H334.527V259.137ZM325.361 257.282H332.679V255.426H325.361V257.282Z",
    fill: "#1A4784"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M434.473 259.541H445.491V253.975H434.473V259.541ZM443.639 257.686H436.321V255.83H443.639V257.686Z",
    fill: "#1A4784"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M342.061 297.274H334.115L334.953 260.47H341.219L342.061 297.274ZM336.02 295.419H340.181L339.424 262.325H336.777L336.02 295.419Z",
    fill: "#1A4784"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M426.939 297.678H434.885L434.047 260.873H427.781L426.939 297.678ZM432.98 295.822H428.819L429.576 262.729H432.223L432.98 295.822Z",
    fill: "#1A4784"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M343.497 301.078H332.679V295.418H343.497V301.078ZM334.527 299.222H341.635V297.274H334.527V299.222Z",
    fill: "#1A4784"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M425.503 301.481H436.321V295.822H425.503V301.481ZM434.473 299.626H427.365V297.678H434.473V299.626Z",
    fill: "#1A4784"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M342.555 262.325H333.617V257.282H342.555V262.325ZM335.447 260.47H340.704V259.138H335.465L335.447 260.47Z",
    fill: "#1A4784"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M426.445 262.729H435.383V257.686H426.445V262.729ZM433.553 260.873H428.296V259.541H433.535L433.553 260.873Z",
    fill: "#1A4784"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M343.597 259.137H332.579V253.571H343.597V259.137ZM334.427 257.282H341.745V255.426H334.427V257.282Z",
    fill: "#1A4784"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M425.403 259.541H436.421V253.975H425.403V259.541ZM434.573 257.686H427.255V255.83H434.573V257.686Z",
    fill: "#1A4784"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M342.747 255.426H324.355V248.659H342.744L342.747 255.426ZM326.21 253.571H340.896V250.501H326.21V253.571Z",
    fill: "#1A4784"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M426.253 255.83H444.645V249.063H426.256L426.253 255.83ZM442.79 253.974H428.104V250.904H442.79V253.974Z",
    fill: "#1A4784"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M345.178 250.501H321.924V244.988H345.178V250.501ZM323.776 248.645H343.323V246.864H323.776V248.645Z",
    fill: "#1A4784"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M423.822 250.904H447.076V245.391H423.822V250.904ZM445.224 249.049H425.677V247.268H445.224V249.049Z",
    fill: "#1A4784"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M346.536 246.85H320.57V240.667H346.536V246.85ZM322.418 244.988H344.688V242.516H322.418V244.988Z",
    fill: "#1A4784"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M422.464 247.254H448.43V241.071H422.464V247.254ZM446.582 245.391H424.312V242.919H446.582V245.391Z",
    fill: "#1A4784"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M348.167 242.523H318.921V237.537H348.167V242.523ZM320.759 240.667H346.319V239.392H320.773L320.759 240.667Z",
    fill: "#1A4784"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M420.833 242.927H450.079V237.94H420.833V242.927ZM448.241 241.071H422.681V239.796H448.227L448.241 241.071Z",
    fill: "#1A4784"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M373.092 297.274H365.145L365.984 260.47H372.253L373.092 297.274ZM367.05 295.419H371.208L370.454 262.325H367.803L367.05 295.419Z",
    fill: "#1A4784"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M395.908 297.678H403.855L403.016 260.873H396.747L395.908 297.678ZM401.95 295.822H397.792L398.546 262.729H401.197L401.95 295.822Z",
    fill: "#1A4784"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M374.527 301.078H363.709V295.418H374.527V301.078ZM365.561 299.222H372.669V297.274H365.561V299.222Z",
    fill: "#1A4784"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M394.473 301.481H405.291V295.822H394.473V301.481ZM403.439 299.626H396.331V297.678H403.439V299.626Z",
    fill: "#1A4784"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M373.589 262.325H364.647V257.282H373.589V262.325ZM366.499 260.47H371.738V259.138H366.499V260.47Z",
    fill: "#1A4784"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M395.411 262.729H404.353V257.686H395.411V262.729ZM402.501 260.873H397.262V259.541H402.501V260.873Z",
    fill: "#1A4784"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M374.627 259.137H363.609V253.571H374.627V259.137ZM365.461 257.282H372.775V255.426H365.461V257.282Z",
    fill: "#1A4784"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M394.373 259.541H405.391V253.975H394.373V259.541ZM403.539 257.686H396.225V255.83H403.539V257.686Z",
    fill: "#1A4784"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M374.52 255.426H363.713V248.659H374.52V255.426ZM365.582 253.571H372.69V250.501H365.582V253.571Z",
    fill: "#1A4784"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M394.48 255.83H405.287V249.063H394.48V255.83ZM403.418 253.974H396.31V250.904H403.418V253.974Z",
    fill: "#1A4784"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M375.839 250.501H362.383V244.988H375.825L375.839 250.501ZM364.246 248.645H373.987V246.864H364.246V248.645Z",
    fill: "#1A4784"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M393.161 250.904H406.617V245.391H393.175L393.161 250.904ZM404.754 249.049H395.013V247.268H404.754V249.049Z",
    fill: "#1A4784"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M376.574 246.85H361.672V240.667H376.599L376.574 246.85ZM363.513 244.988H374.723V242.516H363.513V244.988Z",
    fill: "#1A4784"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M392.426 247.254H407.328V241.071H392.401L392.426 247.254ZM405.487 245.391H394.277V242.919H405.487V245.391Z",
    fill: "#1A4784"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M377.467 242.523H360.763V237.537H377.467V242.523ZM362.621 240.667H375.615V239.392H362.621V240.667Z",
    fill: "#1A4784"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M391.533 242.927H408.237V237.94H391.533V242.927ZM406.379 241.071H393.385V239.796H406.379V241.071Z",
    fill: "#1A4784"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M392.513 296.298H376.783V268.494H392.513V296.298ZM378.652 294.446H390.679V270.335H378.634L378.652 294.446Z",
    fill: "#1A4784"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M385.572 296.298H376.783V268.494H385.572V296.298ZM378.634 294.446H383.724V270.335H378.634V294.446Z",
    fill: "#1A4784"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M391.185 274.132H377.307V275.987H391.185V274.132Z",
    fill: "#1A4784"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M391.185 281.465H377.307V283.32H391.185V281.465Z",
    fill: "#1A4784"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M391.185 288.794H377.307V290.65H391.185V288.794Z",
    fill: "#1A4784"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M360.869 296.298H345.139V268.494H360.869V296.298ZM347.009 294.446H359.039V270.335H346.991L347.009 294.446Z",
    fill: "#1A4784"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M408.131 296.702H423.861V268.897H408.131V296.702ZM421.991 294.85H409.961V270.739H422.009L421.991 294.85Z",
    fill: "#1A4784"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M353.932 296.298H345.139V268.494H353.932V296.298ZM346.991 294.446H352.077V270.335H346.991V294.446Z",
    fill: "#1A4784"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M415.068 296.702H423.861V268.897H415.068V296.702ZM422.009 294.85H416.923V270.739H422.009V294.85Z",
    fill: "#1A4784"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M360.817 269.143C360.851 268.848 360.869 268.55 360.869 268.249C360.869 266.694 360.408 265.173 359.544 263.88C358.68 262.587 357.451 261.578 356.014 260.983C354.577 260.388 352.996 260.232 351.47 260.536C349.944 260.839 348.543 261.588 347.443 262.688C346.343 263.788 345.594 265.19 345.29 266.715C345.131 267.519 345.098 268.338 345.19 269.143H347.061C346.899 268.065 347.033 266.962 347.451 265.951C347.906 264.852 348.676 263.912 349.664 263.252C350.653 262.59 351.815 262.237 353.004 262.236C354.599 262.237 356.128 262.871 357.257 263.998C358.385 265.126 359.019 266.655 359.021 268.249C359.021 268.55 358.999 268.848 358.954 269.143H360.817Z",
    fill: "#1A4784"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M408.183 269.545C408.149 269.25 408.131 268.952 408.131 268.652C408.131 267.096 408.592 265.576 409.456 264.283C410.32 262.989 411.549 261.981 412.986 261.386C414.423 260.791 416.004 260.635 417.53 260.938C419.056 261.242 420.457 261.991 421.557 263.091C422.657 264.191 423.406 265.592 423.71 267.118C423.869 267.921 423.902 268.74 423.81 269.545H421.939C422.101 268.468 421.967 267.364 421.549 266.353C421.094 265.254 420.324 264.315 419.336 263.654C418.347 262.993 417.185 262.639 415.996 262.639C414.401 262.64 412.872 263.273 411.743 264.401C410.615 265.528 409.981 267.057 409.979 268.652C409.979 268.952 410.001 269.251 410.046 269.545H408.183Z",
    fill: "#1A4784"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M392.461 268.822C392.495 268.527 392.512 268.228 392.513 267.929C392.513 266.373 392.052 264.852 391.187 263.559C390.323 262.266 389.095 261.257 387.658 260.662C386.22 260.067 384.639 259.911 383.113 260.215C381.588 260.518 380.186 261.267 379.086 262.367C377.986 263.467 377.237 264.868 376.934 266.394C376.774 267.198 376.742 268.017 376.834 268.822H378.705C378.543 267.744 378.677 266.64 379.095 265.63C379.549 264.531 380.319 263.591 381.308 262.93C382.296 262.269 383.459 261.916 384.648 261.915C386.243 261.916 387.772 262.55 388.9 263.677C390.028 264.805 390.663 266.334 390.665 267.929C390.665 268.229 390.642 268.527 390.598 268.822H392.461Z",
    fill: "#1A4784"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M359.945 274.132H346.067V275.987H359.945V274.132Z",
    fill: "#1A4784"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M409.055 274.535H422.933V276.391H409.055V274.535Z",
    fill: "#1A4784"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M359.945 281.465H346.067V283.32H359.945V281.465Z",
    fill: "#1A4784"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M409.055 281.868H422.933V283.724H409.055V281.868Z",
    fill: "#1A4784"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M359.945 288.794H346.067V290.65H359.945V288.794Z",
    fill: "#1A4784"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M409.055 289.198H422.933V291.053H409.055V289.198Z",
    fill: "#1A4784"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M375.483 239.392H362.739V235.015H375.469L375.483 239.392ZM364.601 237.537H373.632V236.878H364.601V237.537Z",
    fill: "#1A4784"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M393.517 239.796H406.261V235.419H393.531L393.517 239.796ZM404.399 237.941H395.368V237.282H404.399V237.941Z",
    fill: "#1A4784"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M374.524 236.878H363.713V225.043H374.524V236.878ZM365.582 235.015H372.69V226.891H365.582V235.015Z",
    fill: "#1A4784"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M394.476 237.281H405.287V225.447H394.476V237.281ZM403.418 235.419H396.31V227.295H403.418V235.419Z",
    fill: "#1A4784"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M375.483 226.891H362.739V222.589H375.469L375.483 226.891ZM364.601 225.043H373.632V224.448H364.601V225.043Z",
    fill: "#1A4784"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M393.517 227.295H406.261V222.993H393.531L393.517 227.295ZM404.399 225.447H395.368V224.852H404.399V225.447Z",
    fill: "#1A4784"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M333.638 239.392H320.908V235.015H333.638V239.392ZM322.756 237.537H331.787V236.878H322.756V237.537Z",
    fill: "#1A4784"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M435.362 239.796H448.092V235.419H435.362V239.796ZM446.244 237.941H437.213V237.282H446.244V237.941Z",
    fill: "#1A4784"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M332.675 236.878H321.867V225.043H332.675V236.878ZM323.719 235.015H330.827V226.891H323.719V235.015Z",
    fill: "#1A4784"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M436.325 237.281H447.133V225.447H436.325V237.281ZM445.281 235.419H438.173V227.295H445.281V235.419Z",
    fill: "#1A4784"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M333.638 226.891H320.908V222.589H333.638V226.891ZM322.756 225.043H331.787V224.448H322.756V225.043Z",
    fill: "#1A4784"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M435.362 227.295H448.092V222.993H435.362V227.295ZM446.244 225.447H437.213V224.852H446.244V225.447Z",
    fill: "#1A4784"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M419.831 214.854H348.665C348.451 214.854 348.244 214.78 348.079 214.644C347.914 214.508 347.801 214.319 347.759 214.11C347.717 213.9 347.749 213.682 347.849 213.493C347.95 213.304 348.112 213.155 348.309 213.073L383.892 198.086C384.12 197.992 384.375 197.992 384.603 198.086L420.182 213.073C420.38 213.155 420.542 213.304 420.643 213.493C420.743 213.682 420.775 213.9 420.733 214.11C420.691 214.319 420.578 214.508 420.413 214.644C420.248 214.78 420.041 214.854 419.827 214.854H419.831ZM353.257 212.998H415.239L384.248 199.949L353.257 212.998Z",
    fill: "#1A4784"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M411.472 214.853H357.024C356.81 214.853 356.603 214.779 356.438 214.644C356.273 214.508 356.16 214.319 356.118 214.109C356.076 213.899 356.108 213.681 356.208 213.492C356.309 213.303 356.471 213.155 356.668 213.073L383.892 201.605C384.12 201.51 384.375 201.51 384.603 201.605L411.827 213.073C412.024 213.155 412.187 213.303 412.287 213.492C412.388 213.681 412.419 213.899 412.378 214.109C412.336 214.319 412.223 214.508 412.057 214.644C411.892 214.779 411.685 214.853 411.472 214.853ZM361.616 212.998H406.88L384.248 203.467L361.616 212.998Z",
    fill: "#1A4784"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M418 224.445H350.495V218.073H418V224.445ZM352.347 222.589H416.149V219.929H352.347V222.589Z",
    fill: "#1A4784"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M419.866 219.929H348.626V215.278H419.866V219.929ZM350.477 218.073H418.004V217.133H350.477V218.073Z",
    fill: "#1A4784"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M422.162 217.133H346.333V212.998H422.162V217.133ZM348.167 215.277H420.314V214.854H348.167V215.277Z",
    fill: "#1A4784"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M357.763 210.9C357.597 210.901 357.434 210.857 357.291 210.772C357.148 210.688 357.03 210.566 356.95 210.421C356.87 210.275 356.831 210.11 356.836 209.944C356.842 209.778 356.892 209.616 356.981 209.476C356.981 209.476 357.276 209.013 357.941 207.855C358.118 207.545 358.296 207.186 358.495 206.822C359.249 205.369 359.757 204.461 360.457 204.076C360.921 203.861 361.419 203.726 361.928 203.678L362.099 203.653C362.046 203.296 361.978 202.873 361.928 202.584C361.906 202.444 361.914 202.301 361.954 202.164C361.994 202.028 362.064 201.903 362.159 201.797C362.255 201.693 362.374 201.613 362.506 201.561C362.637 201.51 362.779 201.49 362.92 201.501L363.876 201.583C363.77 200.943 363.873 200.286 364.171 199.71C364.294 199.509 364.46 199.338 364.657 199.208C364.853 199.078 365.075 198.993 365.308 198.959C365.464 198.937 365.617 198.898 365.763 198.841C365.408 197.801 366.264 196.27 367.416 195.322C367.805 194.983 368.3 194.79 368.816 194.777C369.928 194.777 370.867 195.789 370.948 197.082C371.039 197.724 370.901 198.377 370.558 198.926C370.66 199.009 370.783 199.063 370.913 199.08C371.032 199.086 371.151 199.079 371.268 199.058C371.386 199.044 371.505 199.035 371.624 199.033C371.802 199.026 371.979 199.06 372.141 199.134C372.304 199.208 372.446 199.318 372.558 199.457C372.914 199.888 372.836 200.415 372.718 200.921C372.628 201.294 372.51 201.66 372.363 202.014C373.116 202.014 373.909 202.014 373.92 202.014C374.033 202.015 374.144 202.035 374.25 202.075L374.517 202.175C374.689 202.241 374.838 202.358 374.944 202.51C375.05 202.661 375.108 202.842 375.111 203.027C375.114 203.212 375.062 203.394 374.961 203.549C374.86 203.705 374.715 203.826 374.545 203.898L358.118 210.829C358.005 210.875 357.885 210.899 357.763 210.9ZM363.947 203.46C363.983 203.706 364.011 203.941 364.022 204.105C364.096 205.223 362.874 205.412 362.213 205.512C361.919 205.541 361.631 205.606 361.353 205.704C361.072 205.889 360.493 207.008 360.144 207.677L359.949 208.033L370.668 203.521C370.595 203.454 370.531 203.379 370.476 203.296C370.081 202.691 370.355 202.021 370.614 201.373C370.675 201.224 370.735 201.074 370.789 200.925H370.749C370.243 200.861 369.764 200.656 369.367 200.334C368.97 200.012 368.671 199.585 368.503 199.101C368.441 198.914 368.439 198.711 368.499 198.523C368.559 198.334 368.678 198.17 368.837 198.054C369.09 197.872 369.157 197.826 369.115 197.206C369.118 197.093 369.093 196.981 369.042 196.881C368.991 196.78 368.916 196.693 368.823 196.629C368.739 196.65 368.662 196.693 368.599 196.754C368.109 197.138 367.739 197.654 367.533 198.243C367.641 198.438 367.703 198.655 367.715 198.878C367.726 199.1 367.687 199.323 367.601 199.528C367.448 199.885 366.996 200.536 365.717 200.771C365.678 201.3 365.745 201.832 365.912 202.335C365.96 202.48 365.97 202.635 365.942 202.784C365.914 202.934 365.849 203.075 365.752 203.193C365.659 203.314 365.537 203.41 365.397 203.472C365.258 203.534 365.105 203.561 364.953 203.549L363.947 203.46Z",
    fill: "#1A4784"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M412.289 210.911C412.455 210.911 412.619 210.867 412.762 210.783C412.905 210.698 413.022 210.577 413.102 210.431C413.182 210.285 413.222 210.121 413.216 209.954C413.211 209.788 413.161 209.626 413.071 209.486C413.071 209.486 412.776 209.023 412.112 207.866C411.934 207.556 411.756 207.196 411.557 206.833C410.804 205.38 410.296 204.472 409.595 204.087C409.131 203.872 408.634 203.737 408.124 203.688L407.954 203.663C408.007 203.307 408.074 202.883 408.124 202.595C408.147 202.455 408.138 202.311 408.098 202.175C408.058 202.039 407.988 201.913 407.893 201.808C407.797 201.704 407.679 201.623 407.547 201.572C407.415 201.521 407.273 201.5 407.133 201.512L406.176 201.594C406.283 200.954 406.179 200.297 405.881 199.721C405.758 199.52 405.592 199.348 405.396 199.219C405.199 199.089 404.977 199.004 404.744 198.969C404.589 198.948 404.436 198.908 404.289 198.852C404.645 197.812 403.788 196.28 402.637 195.333C402.248 194.993 401.752 194.8 401.236 194.788C400.124 194.788 399.186 195.799 399.104 197.092C399.013 197.734 399.152 198.387 399.495 198.937C399.393 199.02 399.27 199.073 399.14 199.09C399.021 199.096 398.901 199.089 398.784 199.069C398.666 199.054 398.548 199.046 398.429 199.044C398.251 199.036 398.073 199.071 397.911 199.145C397.749 199.218 397.606 199.329 397.494 199.468C397.139 199.899 397.217 200.426 397.334 200.931C397.424 201.305 397.543 201.67 397.689 202.025C396.936 202.025 396.143 202.025 396.133 202.025C396.02 202.025 395.908 202.046 395.802 202.085L395.536 202.185C395.363 202.252 395.214 202.368 395.108 202.52C395.002 202.672 394.944 202.852 394.941 203.037C394.938 203.223 394.99 203.405 395.091 203.56C395.192 203.715 395.337 203.837 395.507 203.909L411.934 210.84C412.047 210.885 412.168 210.909 412.289 210.911ZM406.105 203.471C406.07 203.717 406.041 203.952 406.031 204.115C405.956 205.234 407.179 205.423 407.84 205.522C408.133 205.552 408.422 205.616 408.7 205.715C408.981 205.9 409.56 207.018 409.908 207.688L410.104 208.044L399.385 203.531C399.457 203.464 399.522 203.389 399.577 203.307C399.971 202.702 399.698 202.032 399.438 201.384C399.378 201.234 399.317 201.085 399.264 200.935H399.303C399.81 200.871 400.289 200.666 400.686 200.344C401.082 200.022 401.382 199.595 401.549 199.112C401.612 198.924 401.613 198.721 401.553 198.533C401.493 198.345 401.375 198.181 401.215 198.064C400.963 197.883 400.895 197.837 400.938 197.217C400.935 197.104 400.959 196.992 401.01 196.891C401.061 196.79 401.137 196.704 401.229 196.64C401.314 196.661 401.391 196.704 401.453 196.764C401.943 197.148 402.313 197.665 402.519 198.253C402.412 198.448 402.349 198.665 402.338 198.888C402.326 199.111 402.365 199.333 402.452 199.539C402.605 199.895 403.056 200.547 404.336 200.782C404.374 201.311 404.308 201.842 404.14 202.345C404.093 202.49 404.083 202.645 404.111 202.795C404.139 202.945 404.204 203.085 404.3 203.204C404.394 203.324 404.516 203.42 404.655 203.482C404.795 203.544 404.947 203.571 405.1 203.56L406.105 203.471Z",
    fill: "#1A4784"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechFocusTopBg);
export default __webpack_public_path__ + "static/media/tech-focus-top-bg.cf4aa9d59c5278e36b191fb8c03205ea.svg";
export { ForwardRef as ReactComponent };